import { t as __exportAll } from "../rolldown-runtime-CNktS9qV.mjs";
import axios from "axios";
import { stringify } from "qs";
//#region src/propx/gen/models/ActiveRentTenancy.ts
const ActiveRentTenancyTenancyType = {
	MainTenancy: "MainTenancy",
	SubTenancy: "SubTenancy",
	ParkingTenancy: "ParkingTenancy"
};
//#endregion
//#region src/propx/gen/models/AnnualServiceChargeStatementStatusEnum.ts
const AnnualServiceChargeStatementStatusEnum = {
	Created: "Created",
	Prepared: "Prepared",
	Sent: "Sent",
	Paid: "Paid",
	Underpaid: "Underpaid",
	Overpaid: "Overpaid"
};
//#endregion
//#region src/propx/gen/models/BankAccountExpandOpts.ts
const BankAccountExpandOptsSelect = {
	bankAccountId: "bankAccountId",
	bankAccountType: "bankAccountType",
	iban: "iban",
	bic: "bic",
	bankId: "bankId",
	parentId: "parentId",
	externalEntityId: "externalEntityId",
	companyId: "companyId",
	contactPersonId: "contactPersonId"
};
const BankAccountExpandOptsSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/Barcode.ts
const BarcodeType = {};
const BarcodeType2 = { EAN2: "EAN2" };
const BarcodeType3 = { EAN5: "EAN5" };
const BarcodeType4 = { EAN8: "EAN8" };
const BarcodeType5 = { UPCE: "UPCE" };
const BarcodeType6 = { ISBN10: "ISBN10" };
const BarcodeType7 = { UPCA: "UPCA" };
const BarcodeType8 = { EAN13: "EAN13" };
const BarcodeType9 = { ISBN13: "ISBN13" };
const BarcodeType10 = { COMPOSITE: "COMPOSITE" };
const BarcodeType11 = { I25: "I25" };
const BarcodeType12 = { DATABAR: "DATABAR" };
const BarcodeType13 = { DATABAR_EXP: "DATABAR_EXP" };
const BarcodeType14 = { CODABAR: "CODABAR" };
const BarcodeType15 = { CODE39: "CODE39" };
const BarcodeType16 = { PDF417: "PDF417" };
const BarcodeType17 = { QRCODE: "QRCODE" };
const BarcodeType18 = { CODE93: "CODE93" };
const BarcodeType19 = { CODE128: "CODE128" };
//#endregion
//#region src/propx/gen/models/BarcodeTypeEnum.ts
const BarcodeTypeEnum = {};
const BarcodeTypeEnum2 = { EAN2: "EAN2" };
const BarcodeTypeEnum3 = { EAN5: "EAN5" };
const BarcodeTypeEnum4 = { EAN8: "EAN8" };
const BarcodeTypeEnum5 = { UPCE: "UPCE" };
const BarcodeTypeEnum6 = { ISBN10: "ISBN10" };
const BarcodeTypeEnum7 = { UPCA: "UPCA" };
const BarcodeTypeEnum8 = { EAN13: "EAN13" };
const BarcodeTypeEnum9 = { ISBN13: "ISBN13" };
const BarcodeTypeEnum10 = { COMPOSITE: "COMPOSITE" };
const BarcodeTypeEnum11 = { I25: "I25" };
const BarcodeTypeEnum12 = { DATABAR: "DATABAR" };
const BarcodeTypeEnum13 = { DATABAR_EXP: "DATABAR_EXP" };
const BarcodeTypeEnum14 = { CODABAR: "CODABAR" };
const BarcodeTypeEnum15 = { CODE39: "CODE39" };
const BarcodeTypeEnum16 = { PDF417: "PDF417" };
const BarcodeTypeEnum17 = { QRCODE: "QRCODE" };
const BarcodeTypeEnum18 = { CODE93: "CODE93" };
const BarcodeTypeEnum19 = { CODE128: "CODE128" };
//#endregion
//#region src/propx/gen/models/BaseBankAccount.ts
const BaseBankAccountBankAccountType = { Other: "Other" };
const BaseBankAccountBankAccountType2 = { Business: "Business" };
const BaseBankAccountBankAccountType3 = { Loan: "Loan" };
const BaseBankAccountBankAccountType4 = { Tenant: "Tenant" };
const BaseBankAccountBankAccountType5 = { Escrow: "Escrow" };
const BaseBankAccountBankAccountType6 = { RentDeposit: "RentDeposit" };
const BaseBankAccountBankAccountType7 = { Investor: "Investor" };
const BaseBankAccountBankAccountType8 = { BankServiceAccount: "BankServiceAccount" };
const BaseBankAccountBankAccountType9 = { TenantOwned: "TenantOwned" };
//#endregion
//#region src/propx/gen/models/BaseBankTransaction.ts
const BaseBankTransactionCategory = { Drawdown: "Drawdown" };
const BaseBankTransactionCategory2 = { Fee: "Fee" };
const BaseBankTransactionCategory3 = { Transfer: "Transfer" };
const BaseBankTransactionCategory4 = { Booking: "Booking" };
const BaseBankTransactionCategory5 = { PropertyManagement: "PropertyManagement" };
const BaseBankTransactionCategory6 = { Storno: "Storno" };
const BaseBankTransactionCategory7 = { ServiceCharges: "ServiceCharges" };
const BaseBankTransactionCategory8 = { Operational: "Operational" };
const BaseBankTransactionCategory9 = { Revenue: "Revenue" };
const BaseBankTransactionCategory10 = { DirectDebit: "DirectDebit" };
const BaseBankTransactionCategory11 = { Unknown: "Unknown" };
const BaseBankTransactionCategoryType = { Interest: "Interest" };
const BaseBankTransactionCategoryType2 = { Commitment: "Commitment" };
const BaseBankTransactionCategoryType3 = { Combined: "Combined" };
const BaseBankTransactionCategoryType4 = { Processing: "Processing" };
const BaseBankTransactionCategoryType5 = { Invoice: "Invoice" };
const BaseBankTransactionCategoryType6 = { PurchasingPrice: "PurchasingPrice" };
const BaseBankTransactionCategoryType7 = { JuniorDebt: "JuniorDebt" };
const BaseBankTransactionCategoryType8 = { Intergroup: "Intergroup" };
const BaseBankTransactionCategoryType9 = { OwnFunds: "OwnFunds" };
const BaseBankTransactionCategoryType10 = { Rent: "Rent" };
const BaseBankTransactionCategoryType11 = { ManagementFee: "ManagementFee" };
const BaseBankTransactionCategoryType12 = { InvestorIncome: "InvestorIncome" };
const BaseBankTransactionCategoryType13 = { PropertyTax: "PropertyTax" };
const BaseBankTransactionCategoryType14 = { AncillaryCosts: "AncillaryCosts" };
const BaseBankTransactionCategoryType15 = { RentGuarantee: "RentGuarantee" };
const BaseBankTransactionCategoryType16 = { OtherCost: "OtherCost" };
const BaseBankTransactionCategoryType17 = { HouseGeldDealPayback: "HouseGeldDealPayback" };
const BaseBankTransactionCategoryType18 = { RepaymentSubsidy: "RepaymentSubsidy" };
const BaseBankTransactionCategoryType19 = { RentDeposit: "RentDeposit" };
const BaseBankTransactionCategoryType20 = { AnnualServiceChargeStatement: "AnnualServiceChargeStatement" };
const BaseBankTransactionCategoryType21 = { HouseGeld: "HouseGeld" };
const BaseBankTransactionCategoryType22 = { HOAFeeSettlement: "HOAFeeSettlement" };
const BaseBankTransactionCategoryType23 = { Selling: "Selling" };
const BaseBankTransactionCategoryType24 = { Commission: "Commission" };
const BaseBankTransactionCategoryType25 = { ReturnDebit: "ReturnDebit" };
const BaseBankTransactionCategoryType26 = { ReturnDebitFee: "ReturnDebitFee" };
const BaseBankTransactionCategoryType27 = { Storno: "Storno" };
const BaseBankTransactionCategoryType28 = { BankFee: "BankFee" };
const BaseBankTransactionCategoryType29 = { BankFeeCompensation: "BankFeeCompensation" };
const BaseBankTransactionCategoryType30 = { ParkingIncome: "ParkingIncome" };
const BaseBankTransactionCategoryType31 = { RefundManagementFee: "RefundManagementFee" };
const BaseBankTransactionCategoryType32 = { BadDebts: "BadDebts" };
const BaseBankTransactionCategoryType33 = { LiquidityReserve: "LiquidityReserve" };
const BaseBankTransactionCategoryType34 = { Other: "Other" };
const BaseBankTransactionCategoryType35 = { Unknown: "Unknown" };
const BaseBankTransactionBankTransactionState = { Pending: "Pending" };
const BaseBankTransactionBankTransactionState2 = { Reconciled: "Reconciled" };
const BaseBankTransactionBankTransactionState3 = { Incomplete: "Incomplete" };
const BaseBankTransactionBankTransactionState4 = { Error: "Error" };
const BaseBankTransactionBankTransactionState5 = { Storno: "Storno" };
const SubtagsType = { DebtorIban: "DebtorIban" };
const SubtagsType2 = { DebtorBic: "DebtorBic" };
const SubtagsType3 = { Bookingtext: "Bookingtext" };
const SubtagsType4 = { EndToEndReference: "EndToEndReference" };
const SubtagsType5 = { MandateReference: "MandateReference" };
const SubtagsType6 = { CustomerReference: "CustomerReference" };
const SubtagsType7 = { DebtorIdentifier: "DebtorIdentifier" };
const SubtagsType8 = { CreditorIdentifier: "CreditorIdentifier" };
const SubtagsType9 = { SepaRefererenceNumber: "SepaRefererenceNumber" };
const SubtagsType10 = { UltimateDebtor: "UltimateDebtor" };
const SubtagsType11 = { UltimateCreditor: "UltimateCreditor" };
const SubtagsType12 = { PrimanoteNumber: "PrimanoteNumber" };
const SubtagsType13 = { Reference: "Reference" };
const SubtagsType14 = { AdditionalPurpose: "AdditionalPurpose" };
const SubtagsType15 = { Bic: "Bic" };
const SubtagsType16 = { Iban: "Iban" };
const SubtagsType17 = { Debtor: "Debtor" };
const SubtagsType18 = { Creditor: "Creditor" };
const SubtagsType19 = { ReasonCode: "ReasonCode" };
const SubtagsType20 = { Unknown: "Unknown" };
const BaseBankTransactionTransactionSource = { System: "System" };
const BaseBankTransactionTransactionSource2 = { User: "User" };
//#endregion
//#region src/propx/gen/models/BaseCompany.ts
const BaseCompanySellingPartner = {
	"G&B": "G&B",
	HIH: "HIH",
	Tecis: "Tecis",
	PlanetHome: "PlanetHome",
	NoPartner: "NoPartner"
};
const BaseCompanyType = { Bank: "Bank" };
const BaseCompanyType2 = { Realtor: "Realtor" };
const BaseCompanyType3 = { DistributionPartner: "DistributionPartner" };
const BaseCompanyType4 = { Notary: "Notary" };
const BaseCompanyType5 = { PurchasingEntity: "PurchasingEntity" };
const BaseCompanyType6 = { General: "General" };
const BaseCompanyType7 = { KitchenSupplier: "KitchenSupplier" };
const BaseCompanyType8 = { MeasurementsProvider: "MeasurementsProvider" };
const BaseCompanyType9 = { ContractorGeneral: "ContractorGeneral" };
const BaseCompanyType10 = { ContractorCleaning: "ContractorCleaning" };
const BaseCompanyType11 = { ContractorElectricity: "ContractorElectricity" };
const BaseCompanyType12 = { GeneralPropertyManagement: "GeneralPropertyManagement" };
const BaseCompanyType13 = { IndividualPropertyManager: "IndividualPropertyManager" };
const BaseCompanyType14 = { DistrictCourt: "DistrictCourt" };
const BaseCompanyType15 = { ConstructionAuthority: "ConstructionAuthority" };
const BaseCompanyType16 = { WaterProvier: "WaterProvier" };
const BaseCompanyType17 = { ElectricityProvider: "ElectricityProvider" };
const BaseCompanyType18 = { GasProvider: "GasProvider" };
const BaseCompanyType19 = { FacilityManagement: "FacilityManagement" };
const BaseCompanyType20 = { ServiceProvider: "ServiceProvider" };
const BaseCompanyType21 = { SellingNotary: "SellingNotary" };
const BaseCompanyType22 = { MaterialSupplier: "MaterialSupplier" };
const BaseCompanyType23 = { TaxOffice: "TaxOffice" };
const BaseCompanyType24 = { AssetManagement: "AssetManagement" };
const BaseCompanyType25 = { HrCompany: "HrCompany" };
const BaseCompanyType26 = { OfficeSupplier: "OfficeSupplier" };
const BaseCompanyType27 = { TravelProvider: "TravelProvider" };
const BaseCompanyType28 = { RentalCarCompany: "RentalCarCompany" };
const BaseCompanyType29 = { MarketingCompany: "MarketingCompany" };
const BaseCompanyType30 = { HardwareProvider: "HardwareProvider" };
const BaseCompanyType31 = { SoftwareCompany: "SoftwareCompany" };
const BaseCompanyType32 = { Seller: "Seller" };
const BaseCompanyType33 = { Buyer: "Buyer" };
const BaseCompanyType34 = { AssetPartner: "AssetPartner" };
const BaseCompanyType35 = { Tenant: "Tenant" };
const BaseCompanyType36 = { RentingLead: "RentingLead" };
const BaseCompanyType37 = { AuditingFirm: "AuditingFirm" };
const BaseCompanyType38 = { Planning: "Planning" };
const BaseCompanyType39 = { PlanningAndConstructions: "PlanningAndConstructions" };
const BaseCompanyType40 = { Proptech: "Proptech" };
//#endregion
//#region src/propx/gen/models/BaseContactPerson.ts
const BaseContactPersonContactType = {
	User: "User",
	PurchasingEntityDirector: "PurchasingEntityDirector",
	Seller: "Seller",
	Buyer: "Buyer",
	RealEstateAgent: "RealEstateAgent",
	Banker: "Banker",
	Notary: "Notary",
	GeneralContractor: "GeneralContractor",
	KitchenSupplier: "KitchenSupplier",
	MeasurementProvider: "MeasurementProvider",
	WEGVerwaltung: "WEGVerwaltung",
	IndividualPropertyManagement: "IndividualPropertyManagement",
	Tenant: "Tenant",
	RentingLead: "RentingLead",
	Generic: "Generic",
	Neighbor: "Neighbor",
	Craftsman: "Craftsman",
	SellingNotary: "SellingNotary",
	SalesRepresentative: "SalesRepresentative",
	BankAccountOwner: "BankAccountOwner",
	MaterialSupplier: "MaterialSupplier",
	EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant",
	TechnicalDDExpert: "TechnicalDDExpert",
	LegalDDExpert: "LegalDDExpert",
	RentingPartner: "RentingPartner",
	AssetPartner: "AssetPartner",
	TaxDDConsultant: "TaxDDConsultant",
	ExternalAuditor: "ExternalAuditor"
};
//#endregion
//#region src/propx/gen/models/BaseEstate.ts
const BaseEstateEstateType = {
	Apartment: "Apartment",
	House: "House",
	Office: "Office"
};
//#endregion
//#region src/propx/gen/models/BaseInvoiceSchema.ts
const BaseInvoiceSchemaCurrency = {
	EUR: "EUR",
	USD: "USD",
	GBP: "GBP",
	CHF: "CHF"
};
const BaseInvoiceSchemaVatClass = {
	StandardRate: "StandardRate",
	LuxembourgStandardRate: "LuxembourgStandardRate",
	ReducedRate: "ReducedRate",
	ReverseCharge: "ReverseCharge",
	ImportTax: "ImportTax",
	ThirdCountriesOutsideEU: "ThirdCountriesOutsideEU",
	TaxFreeEEUPurchases: "TaxFreeEEUPurchases",
	EUPurchases: "EUPurchases",
	Exempt: "Exempt",
	VATZero: "VATZero",
	ReverseChargeThirdCountry: "ReverseChargeThirdCountry",
	ReverseChargeEU: "ReverseChargeEU",
	IntraCommunityAcquisition: "IntraCommunityAcquisition"
};
const BaseInvoiceSchemaInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Consolidated: "Consolidated",
	Other: "Other"
};
const BaseInvoiceSchemaDebtAllocation = {
	Junior: "Junior",
	Senior: "Senior"
};
const BarcodesType20 = {};
const BarcodesType21 = { EAN2: "EAN2" };
const BarcodesType22 = { EAN5: "EAN5" };
const BarcodesType23 = { EAN8: "EAN8" };
const BarcodesType24 = { UPCE: "UPCE" };
const BarcodesType25 = { ISBN10: "ISBN10" };
const BarcodesType26 = { UPCA: "UPCA" };
const BarcodesType27 = { EAN13: "EAN13" };
const BarcodesType28 = { ISBN13: "ISBN13" };
const BarcodesType29 = { COMPOSITE: "COMPOSITE" };
const BarcodesType30 = { I25: "I25" };
const BarcodesType31 = { DATABAR: "DATABAR" };
const BarcodesType32 = { DATABAR_EXP: "DATABAR_EXP" };
const BarcodesType33 = { CODABAR: "CODABAR" };
const BarcodesType34 = { CODE39: "CODE39" };
const BarcodesType35 = { PDF417: "PDF417" };
const BarcodesType36 = { QRCODE: "QRCODE" };
const BarcodesType37 = { CODE93: "CODE93" };
const BarcodesType38 = { CODE128: "CODE128" };
const RawDataDocumentType11 = {};
const RawDataDocumentType12 = { invoice: "invoice" };
const RawDataDocumentType13 = { receipt: "receipt" };
const RawDataDocumentType14 = { bank_transaction: "bank_transaction" };
const RawDataDocumentType15 = { bank_overview: "bank_overview" };
const RawDataDocumentType16 = { parking: "parking" };
const RawDataDocumentType17 = { petrol: "petrol" };
const RawDataDocumentType18 = { ticket: "ticket" };
const RawDataDocumentType19 = { boarding_pass: "boarding_pass" };
const RawDataDocumentType20 = { other: "other" };
const RawDataInvoiceType4 = {};
const RawDataInvoiceType5 = { invoice: "invoice" };
const RawDataInvoiceType6 = { credit_invoice: "credit_invoice" };
const RawDataPaymentmethod6 = {};
const RawDataPaymentmethod7 = { cash: "cash" };
const RawDataPaymentmethod8 = { creditcard: "creditcard" };
const RawDataPaymentmethod9 = { pin: "pin" };
const RawDataPaymentmethod10 = { bank: "bank" };
const BaseInvoiceSchemaState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const BaseInvoiceSchemaSource = {
	Upload: "Upload",
	Email: "Email"
};
//#endregion
//#region src/propx/gen/models/BaseMonthlyInvestorShare.ts
const BaseMonthlyInvestorShareExcludedReason = {
	NoOwnersAssigned: "NoOwnersAssigned",
	InvestorLedgerNotFound: "InvestorLedgerNotFound",
	LowCashReserve: "LowCashReserve",
	Other: "Other"
};
const BaseMonthlyInvestorShareStatus = {
	New: "New",
	ReadyToGenerate: "ReadyToGenerate",
	ReadyToSend: "ReadyToSend",
	Sent: "Sent",
	Delivered: "Delivered"
};
//#endregion
//#region src/propx/gen/models/BaseParkingSpace.ts
const BaseParkingSpaceParkingSpaceType = {
	UndergroundGarage: "UndergroundGarage",
	Garage: "Garage",
	NoInformation: "NoInformation",
	StreetParking: "StreetParking",
	CarPark: "CarPark",
	NA: "NA",
	Carport: "Carport",
	Duplex: "Duplex",
	Outside: "Outside"
};
//#endregion
//#region src/propx/gen/models/BaseProcess.ts
const BaseProcessProcessType = { Sourcing: "Sourcing" };
const BaseProcessProcessType2 = { Purchasing: "Purchasing" };
const BaseProcessProcessType3 = { Renovation: "Renovation" };
const BaseProcessProcessType4 = { Renting: "Renting" };
const BaseProcessProcessType5 = { RentableUnit: "RentableUnit" };
const BaseProcessProcessType6 = { Selling: "Selling" };
const BaseProcessProcessType7 = { PropertyManagement: "PropertyManagement" };
const BaseProcessProcessType8 = { EstateManagement: "EstateManagement" };
const BaseProcessProcessType9 = { OwnerManagement: "OwnerManagement" };
const BaseProcessProcessType10 = { TenantManagement: "TenantManagement" };
//#endregion
//#region src/propx/gen/models/BaseRentableUnitProcess.ts
const BaseRentableUnitProcessProcessType = {
	Sourcing: "Sourcing",
	Purchasing: "Purchasing",
	Renovation: "Renovation",
	Renting: "Renting",
	RentableUnit: "RentableUnit",
	Selling: "Selling",
	PropertyManagement: "PropertyManagement",
	EstateManagement: "EstateManagement",
	OwnerManagement: "OwnerManagement",
	TenantManagement: "TenantManagement"
};
const ProcessStateState = {
	Vacant: "Vacant",
	Occupied: "Occupied",
	OwnerOccupied: "OwnerOccupied",
	PartiallyOccupied: "PartiallyOccupied",
	BlockedByPm: "BlockedByPm",
	BlockedByRenovation: "BlockedByRenovation"
};
//#endregion
//#region src/propx/gen/models/BaseRentingLead.ts
const BaseRentingLeadRentingLeadStatus = {
	New: "New",
	Approved: "Approved"
};
const BaseRentingLeadLeadImpression = {
	Good: "Good",
	Neutral: "Neutral",
	Bad: "Bad"
};
//#endregion
//#region src/propx/gen/models/BaseReviewProcess.ts
const BaseReviewProcessReviewProcessState = {
	Requested: "Requested",
	Cancelled: "Cancelled",
	Approved: "Approved",
	Rejected: "Rejected"
};
//#endregion
//#region src/propx/gen/models/BaseTenantManagementProcess.ts
const BaseTenantManagementProcessProcessType = {
	Sourcing: "Sourcing",
	Purchasing: "Purchasing",
	Renovation: "Renovation",
	Renting: "Renting",
	RentableUnit: "RentableUnit",
	Selling: "Selling",
	PropertyManagement: "PropertyManagement",
	EstateManagement: "EstateManagement",
	OwnerManagement: "OwnerManagement",
	TenantManagement: "TenantManagement"
};
//#endregion
//#region src/propx/gen/models/CompanyEmploymentRelation.ts
const CompanyEmploymentRelationCompanyRole = {
	Employee: "Employee",
	ManagingDirector: "ManagingDirector"
};
//#endregion
//#region src/propx/gen/models/CondoSalesConditionEnum.ts
const CondoSalesConditionEnum = {
	EEOnly: "EEOnly",
	EEOnlyPlusTI: "EEOnlyPlusTI",
	EEOnlyPlusTIGuarantee: "EEOnlyPlusTIGuarantee"
};
//#endregion
//#region src/propx/gen/models/ContactPerson.ts
const ContactPersonContactType = {
	User: "User",
	PurchasingEntityDirector: "PurchasingEntityDirector",
	Seller: "Seller",
	Buyer: "Buyer",
	RealEstateAgent: "RealEstateAgent",
	Banker: "Banker",
	Notary: "Notary",
	GeneralContractor: "GeneralContractor",
	KitchenSupplier: "KitchenSupplier",
	MeasurementProvider: "MeasurementProvider",
	WEGVerwaltung: "WEGVerwaltung",
	IndividualPropertyManagement: "IndividualPropertyManagement",
	Tenant: "Tenant",
	RentingLead: "RentingLead",
	Generic: "Generic",
	Neighbor: "Neighbor",
	Craftsman: "Craftsman",
	SellingNotary: "SellingNotary",
	SalesRepresentative: "SalesRepresentative",
	BankAccountOwner: "BankAccountOwner",
	MaterialSupplier: "MaterialSupplier",
	EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant",
	TechnicalDDExpert: "TechnicalDDExpert",
	LegalDDExpert: "LegalDDExpert",
	RentingPartner: "RentingPartner",
	AssetPartner: "AssetPartner",
	TaxDDConsultant: "TaxDDConsultant",
	ExternalAuditor: "ExternalAuditor"
};
//#endregion
//#region src/propx/gen/models/CostTypes.ts
const CostTypes = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	VoluntarySocialExpenses: "VoluntarySocialExpenses",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	LivingsAgencyFeesRenting: "LivingsAgencyFeesRenting",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	RenovationCostsRoofConversionCapex: "RenovationCostsRoofConversionCapex",
	RenovationCostsRoofExtensionCapex: "RenovationCostsRoofExtensionCapex",
	RenovationCostsSeparateNewBuildingCapex: "RenovationCostsSeparateNewBuildingCapex",
	LettingFees: "LettingFees",
	OperatingPartnerFee: "OperatingPartnerFee",
	OperatingPartnerFeeAcquisition: "OperatingPartnerFeeAcquisition",
	OperatingPartnerFeeCapexTIManagement: "OperatingPartnerFeeCapexTIManagement",
	OperatingPartnerFeePropertyManagement: "OperatingPartnerFeePropertyManagement",
	OperatingPartnerFeeAssetManagement: "OperatingPartnerFeeAssetManagement",
	OperatingPartnerFeeDisposition: "OperatingPartnerFeeDisposition",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts",
	InstiLandTransferTaxes: "InstiLandTransferTaxes",
	InstiNotary: "InstiNotary",
	InstiPropertyRegistration: "InstiPropertyRegistration",
	InstiAgencyFeePurchasing: "InstiAgencyFeePurchasing",
	InstiAgencyFeeSelling: "InstiAgencyFeeSelling",
	InstiOtherCostSelling: "InstiOtherCostSelling",
	OutsourcedPropertyManagementCost: "OutsourcedPropertyManagementCost",
	OutsourcedPlanningCosts: "OutsourcedPlanningCosts",
	DueDiligenceCosts: "DueDiligenceCosts",
	GERAccountingFees: "GERAccountingFees",
	GERLegalFees: "GERLegalFees",
	GERTaxAdvisoryFees: "GERTaxAdvisoryFees",
	GEROtherStructureCosts: "GEROtherStructureCosts",
	GEROtherExtraordinaryIncome: "GEROtherExtraordinaryIncome",
	GEROtherExtraordinaryExpenses: "GEROtherExtraordinaryExpenses",
	LUXAccountingFees: "LUXAccountingFees",
	LUXLegalFees: "LUXLegalFees",
	LUXTaxAdvisoryFees: "LUXTaxAdvisoryFees",
	LUXPeaksideFees: "LUXPeaksideFees",
	LUXAuditFees: "LUXAuditFees",
	LUXOtherStructureCosts: "LUXOtherStructureCosts",
	LUXOtherExtraordinaryIncome: "LUXOtherExtraordinaryIncome",
	LUXOtherExtraordinaryExpenses: "LUXOtherExtraordinaryExpenses"
};
//#endregion
//#region src/propx/gen/models/Currency.ts
const Currency = {
	EUR: "EUR",
	USD: "USD",
	GBP: "GBP",
	CHF: "CHF"
};
//#endregion
//#region src/propx/gen/models/DebtAllocation.ts
const DebtAllocation = {
	Junior: "Junior",
	Senior: "Senior"
};
//#endregion
//#region src/propx/gen/models/DocumentCategory.ts
const DocumentCategory = {
	General: "General",
	Sourcing: "Sourcing",
	Purchasing: "Purchasing",
	Renovation: "Renovation",
	Marketing: "Marketing",
	PortfolioManagement: "PortfolioManagement",
	PropertyManagement: "PropertyManagement",
	Accounting: "Accounting",
	PostRenovation: "PostRenovation",
	Renting: "Renting",
	Selling: "Selling",
	Orientation: "Orientation",
	Livings: "Livings",
	SalesPackage: "SalesPackage",
	SellingRegion: "SellingRegion",
	Land: "Land",
	Building: "Building",
	RentalContract: "RentalContract",
	ObjectManagement: "ObjectManagement",
	PurchasingContract: "PurchasingContract",
	DueDiligence: "DueDiligence",
	MfhOther: "MfhOther",
	Taxes: "Taxes",
	GeneralCompany: "GeneralCompany",
	ShareholderAndStatutes: "ShareholderAndStatutes",
	CompanyContracts: "CompanyContracts",
	Financing: "Financing",
	KYC: "KYC"
};
//#endregion
//#region src/propx/gen/models/DocumentType.ts
const DocumentType = {
	EbicsAuthorizationLetter: "EbicsAuthorizationLetter",
	PaymentOrder: "PaymentOrder",
	LoanOfferTermSheet: "LoanOfferTermSheet",
	LoanContract: "LoanContract",
	PortfolioInvestmentPlan: "PortfolioInvestmentPlan",
	PurchasingDrawdownRequest: "PurchasingDrawdownRequest",
	InvoicesDrawdownRequest: "InvoicesDrawdownRequest",
	RenovationAcceptanceReport: "RenovationAcceptanceReport",
	ConstructionSiteReport: "ConstructionSiteReport",
	GeneratedInvoiceSubscriptionInvoice: "GeneratedInvoiceSubscriptionInvoice",
	InvoiceApprovalSlip: "InvoiceApprovalSlip",
	InvoiceInXML: "InvoiceInXML",
	InvoiceInPDF: "InvoiceInPDF",
	InvoiceOutPDF: "InvoiceOutPDF",
	Invoice: "Invoice",
	SubscriptionContract: "SubscriptionContract",
	ProtocolArchived: "ProtocolArchived",
	Protocol2024: "Protocol2024",
	Protocol2025: "Protocol2025",
	Protocol2026: "Protocol2026",
	ArchiveOfResolutions: "ArchiveOfResolutions",
	InvitationETV: "InvitationETV",
	AnnualStatement: "AnnualStatement",
	EconomicPlan: "EconomicPlan",
	HomeOwnerFeeStatement: "HomeOwnerFeeStatement",
	BuildingInsurance: "BuildingInsurance",
	EnergyCertificate: "EnergyCertificate",
	PropertyTaxNotice: "PropertyTaxNotice",
	ConstructionBurdenStatement: "ConstructionBurdenStatement",
	AbstractOfTitle: "AbstractOfTitle",
	DeclarationOfCondominium: "DeclarationOfCondominium",
	AmendmentToDeclarationOfDivision: "AmendmentToDeclarationOfDivision",
	AllowanceOfEntrySectionII: "AllowanceOfEntrySectionII",
	SeparationDeclaration: "SeparationDeclaration",
	PartitionPlan: "PartitionPlan",
	Floorplans: "Floorplans",
	ViewsAndSections: "ViewsAndSections",
	LivingSpaceCalculation: "LivingSpaceCalculation",
	ConstructionDescriptionBuilding: "ConstructionDescriptionBuilding",
	HouseRules: "HouseRules",
	LandRegisterMap: "LandRegisterMap",
	ManagementAgreement: "ManagementAgreement",
	SpecialAssessments: "SpecialAssessments",
	Other: "Other",
	EstateMedia: "EstateMedia",
	BuildingPermit: "BuildingPermit",
	Expose: "Expose",
	ExposeExternal: "ExposeExternal",
	ContractDraft: "ContractDraft",
	ContractNotarized: "ContractNotarized",
	LandCharge: "LandCharge",
	PaymentNotice: "PaymentNotice",
	RegistrationNotice: "RegistrationNotice",
	NotaryCorrespondence: "NotaryCorrespondence",
	AdministrationCorrespondence: "AdministrationCorrespondence",
	NotaryRegistrationReservation: "NotaryRegistrationReservation",
	SEPAMandateHomeOwnersFee: "SEPAMandateHomeOwnersFee",
	PurchasingHandoverProtocol: "PurchasingHandoverProtocol",
	ProofOfPayment: "ProofOfPayment",
	SellingExpose: "SellingExpose",
	PromotionExpose: "PromotionExpose",
	CustomizedSellingExpose: "CustomizedSellingExpose",
	SellingExposeSlip: "SellingExposeSlip",
	SellingCalculations: "SellingCalculations",
	SellingCalculationsSlip: "SellingCalculationsSlip",
	SellingContractDraft: "SellingContractDraft",
	SellingContractSummary: "SellingContractSummary",
	SellingContractNotarized: "SellingContractNotarized",
	SellingPaymentNotice: "SellingPaymentNotice",
	SellingRenovationAcceptanceProtocol: "SellingRenovationAcceptanceProtocol",
	SellingRegistrationNotice: "SellingRegistrationNotice",
	SellingNotaryCorrespondence: "SellingNotaryCorrespondence",
	SellingAdministrationCorrespondence: "SellingAdministrationCorrespondence",
	SellingDataSheet: "SellingDataSheet",
	SellingNotaryRegistrationReservation: "SellingNotaryRegistrationReservation",
	SellingHandoverProtocol: "SellingHandoverProtocol",
	SellingExpertReportWithCapEx: "SellingExpertReportWithCapEx",
	SellingExpertReport: "SellingExpertReport",
	SellingResidualValueCertificate: "SellingResidualValueCertificate",
	BuildingModernizationMeasures: "BuildingModernizationMeasures",
	SellingExposeLocation: "SellingExposeLocation",
	SellingAbstractOfTitle: "SellingAbstractOfTitle",
	NotaryCertification: "NotaryCertification",
	SellingProofOfPayment: "SellingProofOfPayment",
	LandRegisterParkingSpace: "LandRegisterParkingSpace",
	BuildingAcceptancePowerOfAttorney: "BuildingAcceptancePowerOfAttorney",
	LocationProfile: "LocationProfile",
	BuildingInformationModel: "BuildingInformationModel",
	FloorPlanSketch: "FloorPlanSketch",
	DimensionedFloorPlan: "DimensionedFloorPlan",
	DimensionedFloorPlanPlanned: "DimensionedFloorPlanPlanned",
	CadFile: "CadFile",
	CadFilePlanned: "CadFilePlanned",
	LV: "LV",
	LongLV: "LongLV",
	Kitchen: "Kitchen",
	KitchenContracted: "KitchenContracted",
	Inspection: "Inspection",
	ConstructionContract: "ConstructionContract",
	ContractorOffer: "ContractorOffer",
	RevisionDocumentation: "RevisionDocumentation",
	ReportsCalculationsAppraisals: "ReportsCalculationsAppraisals",
	ConstructionGuarantee: "ConstructionGuarantee",
	BathPlan: "BathPlan",
	StructuredLvSheet: "StructuredLvSheet",
	RenovationCostTrackingSheet: "RenovationCostTrackingSheet",
	MfhConstructionPlan: "MfhConstructionPlan",
	ConstructionDescriptionRenovation: "ConstructionDescriptionRenovation",
	PostRenovationDimensionedFloorPlan: "PostRenovationDimensionedFloorPlan",
	SalesPartnerFloorPlan: "SalesPartnerFloorPlan",
	LivingSpaceCalculations: "LivingSpaceCalculations",
	BeforeAfterPictures: "BeforeAfterPictures",
	PostRenovationAcceptanceProtocol: "PostRenovationAcceptanceProtocol",
	RoomVolumeCalculation: "RoomVolumeCalculation",
	RentContract: "RentContract",
	RentIncrease: "RentIncrease",
	AcceptanceProtocol: "AcceptanceProtocol",
	HeatingBill: "HeatingBill",
	Correspondence: "Correspondence",
	SelfAssessmentSheet: "SelfAssessmentSheet",
	ID: "ID",
	SalaryInformation: "SalaryInformation",
	SchufaReport: "SchufaReport",
	Deposit: "Deposit",
	HousingProviderConfirmation: "HousingProviderConfirmation",
	SEVContract: "SEVContract",
	SEVContractWithFee: "SEVContractWithFee",
	SEVContractWithoutFee: "SEVContractWithoutFee",
	SEVPoA: "SEVPoA",
	DkbInvestorVerification: "DkbInvestorVerification",
	SEVCoverLetter: "SEVCoverLetter",
	GDPRTenant: "GDPRTenant",
	GDPROwner: "GDPROwner",
	PersonalIDOwner: "PersonalIDOwner",
	SEPAManadateHouseGeld: "SEPAManadateHouseGeld",
	SEPATenant: "SEPATenant",
	WithdrawlInstructionTenant: "WithdrawlInstructionTenant",
	WithdrawlInstructionOwner: "WithdrawlInstructionOwner",
	TenantCorrespondence: "TenantCorrespondence",
	OwnerCorrespondence: "OwnerCorrespondence",
	UtilitiesCorrespondence: "UtilitiesCorrespondence",
	CancellationLease: "CancellationLease",
	CancellationLeaseConfirmation: "CancellationLeaseConfirmation",
	CancellationSEVContract: "CancellationSEVContract",
	CancellationSEVContractConfirmation: "CancellationSEVContractConfirmation",
	CondoTerminationAgreement: "CondoTerminationAgreement",
	LegalDisputes: "LegalDisputes",
	EstateInvestorShare: "EstateInvestorShare",
	EstateAggregatedInvestorShare: "EstateAggregatedInvestorShare",
	WEGAnnualStatement: "WEGAnnualStatement",
	InvoicesPropertyManagement: "InvoicesPropertyManagement",
	EstateRentReport: "EstateRentReport",
	CorrespondencePropertyManagement: "CorrespondencePropertyManagement",
	SalutationWEG: "SalutationWEG",
	InvestorPayout: "InvestorPayout",
	InvestorYearlyPayout: "InvestorYearlyPayout",
	InvestorYearlyPayoutLegacy: "InvestorYearlyPayoutLegacy",
	RentArrearNotice: "RentArrearNotice",
	RentGuarantee: "RentGuarantee",
	DunningNotice: "DunningNotice",
	EnforcementNotice: "EnforcementNotice",
	BKAStatement: "BKAStatement",
	BKAHeatingStatement: "BKAHeatingStatement",
	BKAAllocationCalculation: "BKAAllocationCalculation",
	BKAHouseholdCosts: "BKAHouseholdCosts",
	BKADeposit: "BKADeposit",
	SelfDeclarationTenant: "SelfDeclarationTenant",
	QuestionnaireTenant: "QuestionnaireTenant",
	RentalContractDraft: "RentalContractDraft",
	SalaryRecordPropesctiveTenant: "SalaryRecordPropesctiveTenant",
	SchufaProspectiveTenant: "SchufaProspectiveTenant",
	AnnualServiceChargeCalculation: "AnnualServiceChargeCalculation",
	PersonalIDProspectiveTenant: "PersonalIDProspectiveTenant",
	Safe: "Safe",
	Estate: "Estate",
	BasementRoom: "BasementRoom",
	AtticRoom: "AtticRoom",
	CommonRoom: "CommonRoom",
	Parking: "Parking",
	FurniturePlanPdf: "FurniturePlanPdf",
	FurniturePlanDwg: "FurniturePlanDwg",
	RequestedOrderLists: "RequestedOrderLists",
	ContractedOrderLists: "ContractedOrderLists",
	PartnerBrochure: "PartnerBrochure",
	InvoicesFittings: "InvoicesFittings",
	InvoicesServiceProvider: "InvoicesServiceProvider",
	Internet: "Internet",
	LivingsAcceptanceProtocol: "LivingsAcceptanceProtocol",
	PortfolioInspectionSheet: "PortfolioInspectionSheet",
	CreditLineCashflowPredictions: "CreditLineCashflowPredictions",
	CreditLineBudgetCosts: "CreditLineBudgetCosts",
	EstateInvestorCashflow: "EstateInvestorCashflow",
	SalesPackageFinalSheet: "SalesPackageFinalSheet",
	SalesPackageDataSheet: "SalesPackageDataSheet",
	SalesPackageNotarySheet: "SalesPackageNotarySheet",
	SalesPackageChecklist: "SalesPackageChecklist",
	SalesPackageSellingCompanies: "SalesPackageSellingCompanies",
	PurchasingDocumentsSheet: "PurchasingDocumentsSheet",
	SellingDocumentsSheet: "SellingDocumentsSheet",
	SellingDataChecklist: "SellingDataChecklist",
	SellingEstatesDataSheet: "SellingEstatesDataSheet",
	CashflowStatementSheet: "CashflowStatementSheet",
	InvestorPaymentSlip: "InvestorPaymentSlip",
	InvestorPayoutStatement: "InvestorPayoutStatement",
	DefectReport: "DefectReport",
	SalesPackageUserUploadedPriceList: "SalesPackageUserUploadedPriceList",
	SalesPackageUserUploadedDataSheet: "SalesPackageUserUploadedDataSheet",
	SalesPackageUserUploadedChecklist: "SalesPackageUserUploadedChecklist",
	SalesPackageUserUploadedPhotoAlbum: "SalesPackageUserUploadedPhotoAlbum",
	SellingRegionBrochure: "SellingRegionBrochure",
	TransferRecurrentPaymentsSEPAXmlList: "TransferRecurrentPaymentsSEPAXmlList",
	CondoSellingPresentation: "CondoSellingPresentation",
	SalesPartnerFlyer: "SalesPartnerFlyer",
	PropertyManagementOwnerBrochure: "PropertyManagementOwnerBrochure",
	ModelPurchaseContract: "ModelPurchaseContract",
	ModelRentalContract: "ModelRentalContract",
	ModelPropertyManagementContractWithFee: "ModelPropertyManagementContractWithFee",
	ModelPropertyManagementLawOfAttorney: "ModelPropertyManagementLawOfAttorney",
	ModelPropertyManagementGDPR: "ModelPropertyManagementGDPR",
	CurrentLandRegisterExtract: "CurrentLandRegisterExtract",
	EncumbranceBasisInDeptII: "EncumbranceBasisInDeptII",
	CurrentParcelMap: "CurrentParcelMap",
	CurrentPlanningRights: "CurrentPlanningRights",
	InformationUrbanRenewalArea: "InformationUrbanRenewalArea",
	InformationUrbanConservationArea: "InformationUrbanConservationArea",
	InformationMonumentProtection: "InformationMonumentProtection",
	SocialPreservationOrdinance: "SocialPreservationOrdinance",
	InformationBuildingChargeRegister: "InformationBuildingChargeRegister",
	ExtractContaminatedSitesRegister: "ExtractContaminatedSitesRegister",
	ExtractDevelopmentAndExpansionContributions: "ExtractDevelopmentAndExpansionContributions",
	UrbanDevelopmentContracts: "UrbanDevelopmentContracts",
	SoilReportOrContaminatedSites: "SoilReportOrContaminatedSites",
	GroundLease: "GroundLease",
	VerificationOfExplosiveOrdnance: "VerificationOfExplosiveOrdnance",
	OngoingLegalDisputesRegardingProperty: "OngoingLegalDisputesRegardingProperty",
	BuildingEnergyCertificate: "BuildingEnergyCertificate",
	SectionDrawingsBuildingElevations: "SectionDrawingsBuildingElevations",
	FloorPlansIncludingAreaCalculation: "FloorPlansIncludingAreaCalculation",
	BuildingApplicationOrBuildingPermit: "BuildingApplicationOrBuildingPermit",
	WarrantyGuarantees: "WarrantyGuarantees",
	OverviewOfPastOngoingAndPlannedModernization: "OverviewOfPastOngoingAndPlannedModernization",
	InsuranceClaimsLast5Years: "InsuranceClaimsLast5Years",
	ModernizationsOfIndividualApartments: "ModernizationsOfIndividualApartments",
	DeclarationOfDivisionIfDivided: "DeclarationOfDivisionIfDivided",
	OngoingLegalDisputesRegardingObject: "OngoingLegalDisputesRegardingObject",
	TenantList: "TenantList",
	RentIncreaseLetters: "RentIncreaseLetters",
	RentalAgreements: "RentalAgreements",
	ListOfExistingRentalDeposits: "ListOfExistingRentalDeposits",
	OperatingCostStatement: "OperatingCostStatement",
	TenantHandoverProtocols: "TenantHandoverProtocols",
	ListOfCurrentDefectComplaintsReductionsArrears: "ListOfCurrentDefectComplaintsReductionsArrears",
	OngoingLegalDisputesWithTenants: "OngoingLegalDisputesWithTenants",
	ManagementContracts: "ManagementContracts",
	MaintenanceProtocols: "MaintenanceProtocols",
	ListOfAgeOfInstallations: "ListOfAgeOfInstallations",
	InsurancesMainlyCurrentBuildingInsurance: "InsurancesMainlyCurrentBuildingInsurance",
	PropertyTaxAssessmentAndUnitValueNotice: "PropertyTaxAssessmentAndUnitValueNotice",
	ListOfCraftsmen: "ListOfCraftsmen",
	PurchaseContractDraft: "PurchaseContractDraft",
	AttachmentsToPurchaseContract: "AttachmentsToPurchaseContract",
	PowersOfAttorney: "PowersOfAttorney",
	MfhExpose: "MfhExpose",
	SuperStructures: "SuperStructures",
	LandValueMap: "LandValueMap",
	CommercialOwnerRegisterExtract: "CommercialOwnerRegisterExtract",
	NeighbourhoodAgreements: "NeighbourhoodAgreements",
	LandUsePlan: "LandUsePlan",
	OtherPermits: "OtherPermits",
	OfficialCertificates: "OfficialCertificates",
	BuildingInventoryPlans: "BuildingInventoryPlans",
	BuildingSections: "BuildingSections",
	BuildingStatics: "BuildingStatics",
	BuildingHeating: "BuildingHeating",
	BuildingVentilation: "BuildingVentilation",
	BuildingAirConditioning: "BuildingAirConditioning",
	BuildingSanitary: "BuildingSanitary",
	BuildingElectrical: "BuildingElectrical",
	FireProtection: "FireProtection",
	SpecialistPlannerContracts: "SpecialistPlannerContracts",
	SpecialRealEstateAdditionalInformation: "SpecialRealEstateAdditionalInformation",
	BuildingAdditonalInformation: "BuildingAdditonalInformation",
	Terminations: "Terminations",
	TaxAssessmentNotices: "TaxAssessmentNotices",
	TaxOtherMunicipalCharges: "TaxOtherMunicipalCharges",
	TaxCorrectionBalancesAndPeriods: "TaxCorrectionBalancesAndPeriods",
	TaxValueAddTenants: "TaxValueAddTenants",
	TaxValueAddSellers: "TaxValueAddSellers",
	TaxOptionRatesAndAreaKeys: "TaxOptionRatesAndAreaKeys",
	CompanyOverview: "CompanyOverview",
	CommercialRegisterExtract: "CommercialRegisterExtract",
	TransferOfShares: "TransferOfShares",
	RegisterExcerpts: "RegisterExcerpts",
	ShareRegister: "ShareRegister",
	ListOfShareholders: "ListOfShareholders",
	ArticlesOfAssociation: "ArticlesOfAssociation",
	ArticlesOfAssociationResolutionAmmendments: "ArticlesOfAssociationResolutionAmmendments",
	ArticlesOfAssociationResolutions: "ArticlesOfAssociationResolutions",
	DistributionOfProfitsResolutions: "DistributionOfProfitsResolutions",
	CapitalEndowmentResolutions: "CapitalEndowmentResolutions",
	OtherResolutions: "OtherResolutions",
	ManagingDirectorResolutions: "ManagingDirectorResolutions",
	Minutes: "Minutes",
	AgreementsWithManagement: "AgreementsWithManagement",
	CompanyAccountant: "CompanyAccountant",
	CompanyAuditor: "CompanyAuditor",
	CompanyTaxConsultant: "CompanyTaxConsultant",
	CompanyOtherContracts: "CompanyOtherContracts",
	LoanAgreement: "LoanAgreement",
	LandChargeDeed: "LandChargeDeed",
	DeclarationOfSecurityPurpose: "DeclarationOfSecurityPurpose",
	DeclarationOfAssignment: "DeclarationOfAssignment",
	Pledges: "Pledges",
	PurchasingTerminationDocuments: "PurchasingTerminationDocuments",
	FinancialAnnualStatements: "FinancialAnnualStatements",
	FinancialTaxes: "FinancialTaxes",
	FinancialManagementReporting: "FinancialManagementReporting",
	FinancialLiabilities: "FinancialLiabilities",
	FinancialCurrentBalances: "FinancialCurrentBalances",
	FinancialOtherInformation: "FinancialOtherInformation",
	FoundationReport: "FoundationReport",
	ImportantCorrespondence: "ImportantCorrespondence",
	AdditionalCostsInvoice: "AdditionalCostsInvoice",
	MFHSummary: "MFHSummary",
	MFHInvestmentCaseExportableSheet: "MFHInvestmentCaseExportableSheet",
	AssetPipelineSheet: "AssetPipelineSheet",
	ExternalInvoiceExport: "ExternalInvoiceExport",
	AssetTenderingProcess: "AssetTenderingProcess",
	DueDiligenceOnSiteInspection: "DueDiligenceOnSiteInspection",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	CommercialDD: "CommercialDD",
	EnergyConsultation: "EnergyConsultation",
	Vicinity: "Vicinity",
	PurchasingOffer: "PurchasingOffer",
	CourtageAgreement: "CourtageAgreement",
	ExclusivityAgreement: "ExclusivityAgreement",
	BillingOrInvoices: "BillingOrInvoices",
	InvestmentProposal: "InvestmentProposal",
	KYCDraft: "KYCDraft",
	IDSeller: "IDSeller",
	AddendumContractDraft: "AddendumContractDraft",
	AddendumContract: "AddendumContract",
	Auftragsempfehlung: "Auftragsempfehlung",
	Entscheidungsvorlage: "Entscheidungsvorlage",
	Werkvertrag: "Werkvertrag",
	Planervertrag: "Planervertrag"
};
//#endregion
//#region src/propx/gen/models/Estate.ts
const EstateEstateType = {
	Apartment: "Apartment",
	House: "House",
	Office: "Office"
};
//#endregion
//#region src/propx/gen/models/EstateAttributes.ts
const EstateAttributesHeatingType = {
	Coal: "Coal",
	PelletHeating: "PelletHeating",
	NaturalGasHeavy: "NaturalGasHeavy",
	SteamDistrictHeating: "SteamDistrictHeating",
	BioEnergy: "BioEnergy",
	DistrictHeating: "DistrictHeating",
	Electricity: "Electricity",
	CombinedHeatAndPowerFossilFuels: "CombinedHeatAndPowerFossilFuels",
	HydroEnergy: "HydroEnergy",
	Gas: "Gas",
	CombinedHeatAndPowerRenewableEnergy: "CombinedHeatAndPowerRenewableEnergy",
	NaturalGasLight: "NaturalGasLight",
	WindEnergy: "WindEnergy",
	CombinedHeatAndPowerRegenerativeEnergy: "CombinedHeatAndPowerRegenerativeEnergy",
	LiquidGas: "LiquidGas",
	EnvironmentalThermalEnergy: "EnvironmentalThermalEnergy",
	HeatSupply: "HeatSupply",
	Geothermal: "Geothermal",
	LocalHeating: "LocalHeating",
	Wood: "Wood",
	CombinedHeatAndPowerBioEnergy: "CombinedHeatAndPowerBioEnergy",
	SolarHeating: "SolarHeating",
	Oil: "Oil",
	WoodChips: "WoodChips",
	NoInformation: "NoInformation"
};
const EstateAttributesFloorLocation = {
	R: "R",
	MR: "MR",
	M: "M",
	ML: "ML",
	L: "L",
	TG: "TG",
	Garage: "Garage",
	OpenAir: "OpenAir",
	HP: "HP"
};
//#endregion
//#region src/propx/gen/models/EstateElement.ts
const EstateElementElementTypeName = {
	General: "General",
	Room: "Room",
	Structure: "Structure",
	Equipment: "Equipment",
	Furnishing: "Furnishing"
};
const EstateElementElementType = {
	General: "General",
	Hallway: "Hallway",
	LivingRoom: "LivingRoom",
	Bedroom: "Bedroom",
	Bathroom: "Bathroom",
	GuestWC: "GuestWC",
	Kitchen: "Kitchen",
	Kitchenette: "Kitchenette",
	Storeroom: "Storeroom",
	Balcony: "Balcony",
	LivingRoomWithKitchen: "LivingRoomWithKitchen",
	HallwayWithKitchen: "HallwayWithKitchen",
	LivingRoomWithHallwayAndKitchen: "LivingRoomWithHallwayAndKitchen",
	Other: "Other",
	Door: "Door",
	Window: "Window",
	Ceiling: "Ceiling",
	Wall: "Wall",
	Floor: "Floor",
	Sanitary: "Sanitary",
	Heater: "Heater",
	Electric: "Electric",
	EBK: "EBK"
};
const EstateElementElementRenovationStage = {
	PreRenovation: "PreRenovation",
	PostRenovation: "PostRenovation"
};
//#endregion
//#region src/propx/gen/models/FriIncreaseAmountTypeEnum.ts
const FriIncreaseAmountTypeEnum = {
	Percentage: "Percentage",
	Fixed: "Fixed"
};
//#endregion
//#region src/propx/gen/models/GeneralLedgerStatementExpandOpts.ts
const GeneralLedgerStatementExpandOptsSelect = {
	generalLedgerStatementId: "generalLedgerStatementId",
	month: "month",
	generalLedgerId: "generalLedgerId",
	rentTenancyId: "rentTenancyId",
	expectedValues: "expectedValues",
	cashflowValues: "cashflowValues",
	balanceValues: "balanceValues"
};
const GeneralLedgerStatementExpandOptsSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/HeatingCostItemCostType.ts
const HeatingCostItemCostType = {
	Grundkosten: "Grundkosten",
	Verbrauchskosten: "Verbrauchskosten",
	Gesamt: "Gesamt"
};
//#endregion
//#region src/propx/gen/models/HeatingCostItemType.ts
const HeatingCostItemType = {
	Gradtagszahlen: "Gradtagszahlen",
	Nutzungstage: "Nutzungstage"
};
//#endregion
//#region src/propx/gen/models/HeatingCostMethod.ts
const HeatingCostMethod = {
	DegreeDays: "DegreeDays",
	ManualSplit: "ManualSplit",
	Individual: "Individual"
};
//#endregion
//#region src/propx/gen/models/InvestorInfoExpandOpts.ts
const InvestorInfoExpandOptsSelect = {
	investorInfoId: "investorInfoId",
	startDate: "startDate",
	endDate: "endDate",
	security: "security",
	managementFee: "managementFee",
	investorBankAccountId: "investorBankAccountId",
	escrowBankAccountId: "escrowBankAccountId",
	estateId: "estateId",
	alert: "alert",
	isSev: "isSev",
	isLegacyCondo: "isLegacyCondo",
	hasBankAccountSubsidy: "hasBankAccountSubsidy",
	specialDealShouldExemptMaintenanceReserveMonth: "specialDealShouldExemptMaintenanceReserveMonth",
	specialDealMaintenanceReserveStartDate: "specialDealMaintenanceReserveStartDate",
	specialDealMaintenanceReserveEndDate: "specialDealMaintenanceReserveEndDate",
	specialDealMaintenanceReserveDuration: "specialDealMaintenanceReserveDuration",
	specialDealShouldExemptPropertyManagementMonthlyCosts: "specialDealShouldExemptPropertyManagementMonthlyCosts",
	specialDealPropertyManagementCostsStartDate: "specialDealPropertyManagementCostsStartDate",
	specialDealPropertyManagementCostsEndDate: "specialDealPropertyManagementCostsEndDate",
	specialDealPropertyManagementCostsDuration: "specialDealPropertyManagementCostsDuration",
	specialDealHasRepaymentSubsidy: "specialDealHasRepaymentSubsidy",
	specialDealRepaymentSubsidyRate: "specialDealRepaymentSubsidyRate",
	specialDealRepaymentSubsidyStartDate: "specialDealRepaymentSubsidyStartDate",
	specialDealRepaymentSubsidyEndDate: "specialDealRepaymentSubsidyEndDate",
	specialDealRepaymentSubsidyDuration: "specialDealRepaymentSubsidyDuration",
	specialDealHasAutomaticSubsidy: "specialDealHasAutomaticSubsidy",
	specialDealAutomaticSubsidyEquityPercentOrEuro: "specialDealAutomaticSubsidyEquityPercentOrEuro",
	specialDealAutomaticSubsidyDiscountPeriod: "specialDealAutomaticSubsidyDiscountPeriod"
};
const InvestorInfoExpandOptsSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/InvestorInfoOwnerExpandOpts.ts
const InvestorInfoOwnerExpandOptsSelect = {
	investorInfoOwnerId: "investorInfoOwnerId",
	investorInfoId: "investorInfoId",
	contactId: "contactId",
	companyId: "companyId"
};
const InvestorInfoOwnerExpandOptsSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/InvestorShareOperationEnum.ts
const InvestorShareOperationEnum = {
	Rent: "Rent",
	RentGuarantee: "RentGuarantee",
	RentReduction: "RentReduction",
	Housegeld: "Housegeld",
	ReimbursementNonAllocatableHousegeld: "ReimbursementNonAllocatableHousegeld",
	ManagementFee: "ManagementFee",
	ReimbursementManagementFee: "ReimbursementManagementFee",
	BankFee: "BankFee",
	BankFeeSubsidy: "BankFeeSubsidy",
	RepaymentSubsidy: "RepaymentSubsidy",
	HoaFeeSubsidy: "HoaFeeSubsidy",
	Invoice: "Invoice",
	PropertyTax: "PropertyTax",
	BkaIncome: "BkaIncome",
	BkaExpense: "BkaExpense",
	AccountingResult: "AccountingResult",
	RecalculationOfWP: "RecalculationOfWP",
	SpecialAllocation: "SpecialAllocation",
	BuildingLiquidityReserves: "BuildingLiquidityReserves",
	LiquidityReserve: "LiquidityReserve",
	AccountFundsNotSufficient: "AccountFundsNotSufficient",
	OtherRevenue: "OtherRevenue",
	OtherExpense: "OtherExpense",
	Other: "Other"
};
//#endregion
//#region src/propx/gen/models/InvestorShareOperationRow.ts
const InvestorShareOperationRowOperator = {
	Add: "Add",
	Sub: "Sub"
};
//#endregion
//#region src/propx/gen/models/InvestorYearlyPayoutStatus.ts
const InvestorYearlyPayoutStatus = {
	Open: "Open",
	Verified: "Verified",
	Sent: "Sent"
};
//#endregion
//#region src/propx/gen/models/InvoiceSchema.ts
const InvoiceSchemaCurrency = {
	EUR: "EUR",
	USD: "USD",
	GBP: "GBP",
	CHF: "CHF"
};
const InvoiceSchemaVatClass = {
	StandardRate: "StandardRate",
	LuxembourgStandardRate: "LuxembourgStandardRate",
	ReducedRate: "ReducedRate",
	ReverseCharge: "ReverseCharge",
	ImportTax: "ImportTax",
	ThirdCountriesOutsideEU: "ThirdCountriesOutsideEU",
	TaxFreeEEUPurchases: "TaxFreeEEUPurchases",
	EUPurchases: "EUPurchases",
	Exempt: "Exempt",
	VATZero: "VATZero",
	ReverseChargeThirdCountry: "ReverseChargeThirdCountry",
	ReverseChargeEU: "ReverseChargeEU",
	IntraCommunityAcquisition: "IntraCommunityAcquisition"
};
const InvoiceSchemaInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Consolidated: "Consolidated",
	Other: "Other"
};
const InvoiceSchemaDebtAllocation = {
	Junior: "Junior",
	Senior: "Senior"
};
const BarcodesType = {};
const BarcodesType2 = { EAN2: "EAN2" };
const BarcodesType3 = { EAN5: "EAN5" };
const BarcodesType4 = { EAN8: "EAN8" };
const BarcodesType5 = { UPCE: "UPCE" };
const BarcodesType6 = { ISBN10: "ISBN10" };
const BarcodesType7 = { UPCA: "UPCA" };
const BarcodesType8 = { EAN13: "EAN13" };
const BarcodesType9 = { ISBN13: "ISBN13" };
const BarcodesType10 = { COMPOSITE: "COMPOSITE" };
const BarcodesType11 = { I25: "I25" };
const BarcodesType12 = { DATABAR: "DATABAR" };
const BarcodesType13 = { DATABAR_EXP: "DATABAR_EXP" };
const BarcodesType14 = { CODABAR: "CODABAR" };
const BarcodesType15 = { CODE39: "CODE39" };
const BarcodesType16 = { PDF417: "PDF417" };
const BarcodesType17 = { QRCODE: "QRCODE" };
const BarcodesType18 = { CODE93: "CODE93" };
const BarcodesType19 = { CODE128: "CODE128" };
const RawDataDocumentType = {};
const RawDataDocumentType2 = { invoice: "invoice" };
const RawDataDocumentType3 = { receipt: "receipt" };
const RawDataDocumentType4 = { bank_transaction: "bank_transaction" };
const RawDataDocumentType5 = { bank_overview: "bank_overview" };
const RawDataDocumentType6 = { parking: "parking" };
const RawDataDocumentType7 = { petrol: "petrol" };
const RawDataDocumentType8 = { ticket: "ticket" };
const RawDataDocumentType9 = { boarding_pass: "boarding_pass" };
const RawDataDocumentType10 = { other: "other" };
const RawDataInvoiceType = {};
const RawDataInvoiceType2 = { invoice: "invoice" };
const RawDataInvoiceType3 = { credit_invoice: "credit_invoice" };
const RawDataPaymentmethod = {};
const RawDataPaymentmethod2 = { cash: "cash" };
const RawDataPaymentmethod3 = { creditcard: "creditcard" };
const RawDataPaymentmethod4 = { pin: "pin" };
const RawDataPaymentmethod5 = { bank: "bank" };
const InvoiceSchemaState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const InvoiceSchemaSource = {
	Upload: "Upload",
	Email: "Email"
};
//#endregion
//#region src/propx/gen/models/InvoiceSource.ts
const InvoiceSource = {
	Upload: "Upload",
	Email: "Email"
};
//#endregion
//#region src/propx/gen/models/InvoiceStates.ts
const InvoiceStates = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
//#endregion
//#region src/propx/gen/models/InvoiceType.ts
const InvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Consolidated: "Consolidated",
	Other: "Other"
};
//#endregion
//#region src/propx/gen/models/ManualAdjustmentsRow.ts
const ManualAdjustmentsRowOperator = {
	Add: "Add",
	Sub: "Sub"
};
//#endregion
//#region src/propx/gen/models/MediaFile.ts
const MediaFileConstructionCraft = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const MediaFileCategory = {
	Listing: "Listing",
	Inspection: "Inspection",
	PreRenovation: "PreRenovation",
	PostRenovation: "PostRenovation",
	Renovation: "Renovation",
	Avatar: "Avatar",
	Other: "Other",
	PropertyManagement: "PropertyManagement",
	Livings: "Livings",
	TechnicalDDInspection: "TechnicalDDInspection"
};
const MediaFileTags = {
	defect: "defect",
	publish: "publish",
	"construction-plan": "construction-plan",
	inspection: "inspection",
	"before-after": "before-after",
	"expose-building": "expose-building",
	"expose-kitchen": "expose-kitchen",
	"expose-living-room": "expose-living-room",
	"expose-bathroom": "expose-bathroom",
	summary: "summary",
	"expose-room-1": "expose-room-1",
	"expose-room-2": "expose-room-2",
	"expose-room-3": "expose-room-3",
	parking: "parking",
	"key-locker": "key-locker",
	"building-entrance": "building-entrance",
	"apartment-door": "apartment-door",
	"template-expose-bathroom": "template-expose-bathroom",
	"template-expose-kitchen": "template-expose-kitchen",
	"template-expose-living-room": "template-expose-living-room",
	"template-expose-room-1": "template-expose-room-1",
	"template-expose-room-2": "template-expose-room-2",
	"template-expose-room-3": "template-expose-room-3",
	"renting-management": "renting-management",
	"exterior-views": "exterior-views",
	apartments: "apartments",
	"commercial-properties": "commercial-properties",
	marketing: "marketing",
	"main-photo-pre-renovation": "main-photo-pre-renovation",
	"main-photo-post-renovation": "main-photo-post-renovation"
};
const MediaFileInternalTags = {
	"listing-title": "listing-title",
	"floor-plan": "floor-plan"
};
//#endregion
//#region src/propx/gen/models/MediaFileVariant.ts
const MediaFileVariantVariant = {
	Thumb: "Thumb",
	Listing: "Listing"
};
//#endregion
//#region src/propx/gen/models/MonthlyInvestorShare.ts
const MonthlyInvestorShareExcludedReason = {
	NoOwnersAssigned: "NoOwnersAssigned",
	InvestorLedgerNotFound: "InvestorLedgerNotFound",
	LowCashReserve: "LowCashReserve",
	Other: "Other"
};
const MonthlyInvestorShareStatus = {
	New: "New",
	ReadyToGenerate: "ReadyToGenerate",
	ReadyToSend: "ReadyToSend",
	Sent: "Sent",
	Delivered: "Delivered"
};
//#endregion
//#region src/propx/gen/models/MonthlyRentGuaranteeExpandOpts.ts
const MonthlyRentGuaranteeExpandOptsSelect = {
	monthlyRentGuaranteeId: "monthlyRentGuaranteeId",
	investorInfoId: "investorInfoId",
	month: "month",
	type: "type",
	payoutAmount: "payoutAmount",
	multiplicationFactor: "multiplicationFactor",
	payoutAmountWithFactor: "payoutAmountWithFactor",
	excludedFromPayment: "excludedFromPayment",
	reason: "reason",
	createdAt: "createdAt",
	updatedAt: "updatedAt"
};
const MonthlyRentGuaranteeExpandOptsSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/MonthlyRentGuaranteeTypeEnum.ts
const MonthlyRentGuaranteeTypeEnum = {
	RentGuarantee: "RentGuarantee",
	RentFreeTime: "RentFreeTime",
	MissingRent: "MissingRent"
};
//#endregion
//#region src/propx/gen/models/ParkingSpaceSchema.ts
const ParkingSpaceSchemaParkingSpaceType = {
	UndergroundGarage: "UndergroundGarage",
	Garage: "Garage",
	NoInformation: "NoInformation",
	StreetParking: "StreetParking",
	CarPark: "CarPark",
	NA: "NA",
	Carport: "Carport",
	Duplex: "Duplex",
	Outside: "Outside"
};
//#endregion
//#region src/propx/gen/models/ParsedSubtag.ts
const ParsedSubtagType = { DebtorIban: "DebtorIban" };
const ParsedSubtagType2 = { DebtorBic: "DebtorBic" };
const ParsedSubtagType3 = { Bookingtext: "Bookingtext" };
const ParsedSubtagType4 = { EndToEndReference: "EndToEndReference" };
const ParsedSubtagType5 = { MandateReference: "MandateReference" };
const ParsedSubtagType6 = { CustomerReference: "CustomerReference" };
const ParsedSubtagType7 = { DebtorIdentifier: "DebtorIdentifier" };
const ParsedSubtagType8 = { CreditorIdentifier: "CreditorIdentifier" };
const ParsedSubtagType9 = { SepaRefererenceNumber: "SepaRefererenceNumber" };
const ParsedSubtagType10 = { UltimateDebtor: "UltimateDebtor" };
const ParsedSubtagType11 = { UltimateCreditor: "UltimateCreditor" };
const ParsedSubtagType12 = { PrimanoteNumber: "PrimanoteNumber" };
const ParsedSubtagType13 = { Reference: "Reference" };
const ParsedSubtagType14 = { AdditionalPurpose: "AdditionalPurpose" };
const ParsedSubtagType15 = { Bic: "Bic" };
const ParsedSubtagType16 = { Iban: "Iban" };
const ParsedSubtagType17 = { Debtor: "Debtor" };
const ParsedSubtagType18 = { Creditor: "Creditor" };
const ParsedSubtagType19 = { ReasonCode: "ReasonCode" };
const ParsedSubtagType20 = { Unknown: "Unknown" };
//#endregion
//#region src/propx/gen/models/PersonalInfo.ts
const PersonalInfoEmploymentContractType = {
	Limited: "Limited",
	Unlimited: "Unlimited"
};
const PersonalInfoSchufa = {
	Good: "Good",
	Bad: "Bad"
};
//#endregion
//#region src/propx/gen/models/PortalName.ts
const PortalName = {
	INVESTOR: "INVESTOR",
	TENANT: "TENANT"
};
//#endregion
//#region src/propx/gen/models/Receipt.ts
const BarcodesType39 = {};
const BarcodesType40 = { EAN2: "EAN2" };
const BarcodesType41 = { EAN5: "EAN5" };
const BarcodesType42 = { EAN8: "EAN8" };
const BarcodesType43 = { UPCE: "UPCE" };
const BarcodesType44 = { ISBN10: "ISBN10" };
const BarcodesType45 = { UPCA: "UPCA" };
const BarcodesType46 = { EAN13: "EAN13" };
const BarcodesType47 = { ISBN13: "ISBN13" };
const BarcodesType48 = { COMPOSITE: "COMPOSITE" };
const BarcodesType49 = { I25: "I25" };
const BarcodesType50 = { DATABAR: "DATABAR" };
const BarcodesType51 = { DATABAR_EXP: "DATABAR_EXP" };
const BarcodesType52 = { CODABAR: "CODABAR" };
const BarcodesType53 = { CODE39: "CODE39" };
const BarcodesType54 = { PDF417: "PDF417" };
const BarcodesType55 = { QRCODE: "QRCODE" };
const BarcodesType56 = { CODE93: "CODE93" };
const BarcodesType57 = { CODE128: "CODE128" };
const ReceiptDocumentType = {};
const ReceiptDocumentType2 = { invoice: "invoice" };
const ReceiptDocumentType3 = { receipt: "receipt" };
const ReceiptDocumentType4 = { bank_transaction: "bank_transaction" };
const ReceiptDocumentType5 = { bank_overview: "bank_overview" };
const ReceiptDocumentType6 = { parking: "parking" };
const ReceiptDocumentType7 = { petrol: "petrol" };
const ReceiptDocumentType8 = { ticket: "ticket" };
const ReceiptDocumentType9 = { boarding_pass: "boarding_pass" };
const ReceiptDocumentType10 = { other: "other" };
const ReceiptInvoiceType = {};
const ReceiptInvoiceType2 = { invoice: "invoice" };
const ReceiptInvoiceType3 = { credit_invoice: "credit_invoice" };
const ReceiptPaymentmethod = {};
const ReceiptPaymentmethod2 = { cash: "cash" };
const ReceiptPaymentmethod3 = { creditcard: "creditcard" };
const ReceiptPaymentmethod4 = { pin: "pin" };
const ReceiptPaymentmethod5 = { bank: "bank" };
//#endregion
//#region src/propx/gen/models/ReceiptDocumentTypeEnum.ts
const ReceiptDocumentTypeEnum = {};
const ReceiptDocumentTypeEnum2 = { invoice: "invoice" };
const ReceiptDocumentTypeEnum3 = { receipt: "receipt" };
const ReceiptDocumentTypeEnum4 = { bank_transaction: "bank_transaction" };
const ReceiptDocumentTypeEnum5 = { bank_overview: "bank_overview" };
const ReceiptDocumentTypeEnum6 = { parking: "parking" };
const ReceiptDocumentTypeEnum7 = { petrol: "petrol" };
const ReceiptDocumentTypeEnum8 = { ticket: "ticket" };
const ReceiptDocumentTypeEnum9 = { boarding_pass: "boarding_pass" };
const ReceiptDocumentTypeEnum10 = { other: "other" };
//#endregion
//#region src/propx/gen/models/ReceiptInvoiceTypeEnum.ts
const ReceiptInvoiceTypeEnum = {};
const ReceiptInvoiceTypeEnum2 = { invoice: "invoice" };
const ReceiptInvoiceTypeEnum3 = { credit_invoice: "credit_invoice" };
//#endregion
//#region src/propx/gen/models/ReceiptPaymentmethodEnum.ts
const ReceiptPaymentmethodEnum = {};
const ReceiptPaymentmethodEnum2 = { cash: "cash" };
const ReceiptPaymentmethodEnum3 = { creditcard: "creditcard" };
const ReceiptPaymentmethodEnum4 = { pin: "pin" };
const ReceiptPaymentmethodEnum5 = { bank: "bank" };
//#endregion
//#region src/propx/gen/models/RentApartmentConditionEnum.ts
const RentApartmentConditionEnum = {
	Refurbished: "Refurbished",
	Old: "Old",
	Rentable: "Rentable"
};
//#endregion
//#region src/propx/gen/models/RentIncreaseFormulaEnum.ts
const RentIncreaseFormulaEnum = {
	FRI: "FRI",
	BasicIRI: "BasicIRI",
	IRIMinCap: "IRIMinCap",
	IRIMaxCap: "IRIMaxCap",
	IRIAveraged: "IRIAveraged"
};
//#endregion
//#region src/propx/gen/models/RentIncreaseTypeEnum.ts
const RentIncreaseTypeEnum = {
	Temp: "Temp",
	FRI: "FRI",
	IRI: "IRI"
};
//#endregion
//#region src/propx/gen/models/RentTenancyRentIncreaseTypeEnum.ts
const RentTenancyRentIncreaseTypeEnum = {
	NO_INCREASE: "NO_INCREASE",
	MANUAL: "MANUAL",
	IRI: "IRI",
	FRI: "FRI"
};
//#endregion
//#region src/propx/gen/models/RentableUnitExpandOpts.ts
const RentableUnitExpandOptsSelect = {
	rentableUnitId: "rentableUnitId",
	type: "type",
	estateId: "estateId",
	rentableUnitProcessId: "rentableUnitProcessId",
	parkingSpaceId: "parkingSpaceId",
	estateElementId: "estateElementId",
	estarCoreUnitId: "estarCoreUnitId",
	createdAt: "createdAt",
	updatedAt: "updatedAt",
	deletedAt: "deletedAt"
};
const RentableUnitExpandOptsSelect2 = { "*": "*" };
const EstateSelect = {
	estateId: "estateId",
	estateType: "estateType",
	title: "title",
	isRented: "isRented",
	isSold: "isSold",
	titlePicUrl: "titlePicUrl",
	propertyManagementOnly: "propertyManagementOnly",
	stateClass: "stateClass",
	uuid: "uuid",
	condoUuid: "condoUuid",
	purchasingOfferMadeAt: "purchasingOfferMadeAt",
	groupId: "groupId",
	isScreened: "isScreened",
	isNew: "isNew",
	salesPackageUnitNumber: "salesPackageUnitNumber",
	purchasingUnitNumber: "purchasingUnitNumber",
	propertyManagementUnitCount: "propertyManagementUnitCount",
	isSpecialDealLocked: "isSpecialDealLocked",
	locationRating: "locationRating",
	locationRatingNote: "locationRatingNote",
	attrId: "attrId",
	postRenovationAttrId: "postRenovationAttrId",
	locationId: "locationId",
	priceId: "priceId",
	portfolioId: "portfolioId",
	creditLinePortfolioId: "creditLinePortfolioId",
	salesPackageId: "salesPackageId",
	specialDealId: "specialDealId",
	priorityScore: "priorityScore",
	timeOnBooks: "timeOnBooks",
	timeAtRisk: "timeAtRisk",
	mfhId: "mfhId"
};
const EstateSelect2 = { "*": "*" };
const LocationSelect = {
	locationId: "locationId",
	refUuid: "refUuid",
	street: "street",
	addressLine2: "addressLine2",
	houseNumber: "houseNumber",
	latitude: "latitude",
	longitude: "longitude",
	zipcode: "zipcode",
	quarter: "quarter",
	city: "city",
	county: "county",
	state: "state",
	country: "country",
	scoring: "scoring"
};
const LocationSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/RentableUnitExternalRelations.ts
const RentableUnitExternalRelations = {
	estate: "estate",
	estateElement: "estateElement",
	parkingSpace: "parkingSpace"
};
//#endregion
//#region src/propx/gen/models/RentableUnitProcessSchema.ts
const RentableUnitProcessSchemaProcessType = {
	Sourcing: "Sourcing",
	Purchasing: "Purchasing",
	Renovation: "Renovation",
	Renting: "Renting",
	RentableUnit: "RentableUnit",
	Selling: "Selling",
	PropertyManagement: "PropertyManagement",
	EstateManagement: "EstateManagement",
	OwnerManagement: "OwnerManagement",
	TenantManagement: "TenantManagement"
};
const ProcessStateState2 = {
	Vacant: "Vacant",
	Occupied: "Occupied",
	OwnerOccupied: "OwnerOccupied",
	PartiallyOccupied: "PartiallyOccupied",
	BlockedByPm: "BlockedByPm",
	BlockedByRenovation: "BlockedByRenovation"
};
//#endregion
//#region src/propx/gen/models/RentableUnitTypeEnum.ts
const RentableUnitTypeEnum = {
	Estate: "Estate",
	Room: "Room",
	Parking: "Parking"
};
//#endregion
//#region src/propx/gen/models/RentalContractExpandOpts.ts
const RentalContractExpandOptsSelect = {
	rentalContractId: "rentalContractId",
	status: "status",
	type: "type",
	estateId: "estateId",
	rentTenancyId: "rentTenancyId",
	documentId: "documentId",
	estarCoreRentalContractId: "estarCoreRentalContractId",
	parentTenancyId: "parentTenancyId",
	parentId: "parentId",
	startDate: "startDate",
	endDate: "endDate",
	coldRent: "coldRent",
	heatingCost: "heatingCost",
	utilityCost: "utilityCost",
	monthlyAdditionalRent: "monthlyAdditionalRent",
	parkingSpaceRent: "parkingSpaceRent",
	hasParkingSpace: "hasParkingSpace",
	isColdRentWithParking: "isColdRentWithParking",
	isJobCenter: "isJobCenter",
	isSecondaryRent: "isSecondaryRent",
	numberOfTenantsAtViewing: "numberOfTenantsAtViewing",
	tenantsWithNetIncome: "tenantsWithNetIncome",
	updateRentOnApproval: "updateRentOnApproval",
	livingSpace: "livingSpace",
	isLivings: "isLivings",
	isFlatshare: "isFlatshare",
	isFurnished: "isFurnished",
	rentIncreaseType: "rentIncreaseType",
	rentIncreaseFormula: "rentIncreaseFormula",
	rentIncreaseInterval: "rentIncreaseInterval",
	friIncreaseAmount: "friIncreaseAmount",
	friIncreaseAmountType: "friIncreaseAmountType",
	friIncreaseCycles: "friIncreaseCycles",
	iriMinCap: "iriMinCap",
	iriMaxCap: "iriMaxCap",
	rentalFreePeriod: "rentalFreePeriod",
	rentFreePeriodInMonths: "rentFreePeriodInMonths",
	ancillaryCostFreeStartDate: "ancillaryCostFreeStartDate",
	ancillaryCostFreeEndDate: "ancillaryCostFreeEndDate",
	rentDeposit: "rentDeposit",
	depositReturnDate: "depositReturnDate",
	depositReturnAmount: "depositReturnAmount",
	paidRentDeposit: "paidRentDeposit",
	trackDepositAutomatically: "trackDepositAutomatically",
	numberOfInstallments: "numberOfInstallments",
	coldRentChurnPerSQM: "coldRentChurnPerSQM",
	commercialVATDamage: "commercialVATDamage",
	commercialRentIndexIncrease: "commercialRentIndexIncrease",
	reletDelayInMonths: "reletDelayInMonths",
	rentIncreaseEndDate: "rentIncreaseEndDate",
	isRefurbishedByCurrentOwner: "isRefurbishedByCurrentOwner",
	apartmentCondition: "apartmentCondition",
	condoSalesCondition: "condoSalesCondition",
	condoRefurbishmentCostsPerSQM: "condoRefurbishmentCostsPerSQM",
	rentBeforeIncrease: "rentBeforeIncrease",
	securityDeposit: "securityDeposit",
	vat: "vat",
	lastRentIncreaseDate: "lastRentIncreaseDate",
	valueOfLastRentIncrease: "valueOfLastRentIncrease",
	percentageOfLastRentIncrease: "percentageOfLastRentIncrease",
	isStorageRoomInAtticIsRented: "isStorageRoomInAtticIsRented",
	equipmentFeatures: "equipmentFeatures",
	option: "option",
	otherAgreements: "otherAgreements",
	isRentalContractSigned: "isRentalContractSigned",
	isRentIncreaseSigned: "isRentIncreaseSigned",
	isRentalContractChecked: "isRentalContractChecked",
	otherNote: "otherNote",
	regulationOfRentIncreaseNote: "regulationOfRentIncreaseNote",
	rentingLeadId: "rentingLeadId",
	rentingProcessId: "rentingProcessId",
	signedDocumentId: "signedDocumentId",
	createdAt: "createdAt",
	updatedAt: "updatedAt"
};
const RentalContractExpandOptsSelect2 = { "*": "*" };
const AnnualServiceChargeStatementsSelect = {
	serviceChargeStatementId: "serviceChargeStatementId",
	rentalContractId: "rentalContractId",
	status: "status",
	statusDates: "statusDates",
	dueDate: "dueDate",
	year: "year",
	amount: "amount",
	paidAmount: "paidAmount",
	lastPaidAt: "lastPaidAt",
	createdBy: "createdBy",
	bankTransactionIds: "bankTransactionIds",
	invoiceId: "invoiceId",
	propertyManagementCompanyId: "propertyManagementCompanyId",
	billingPeriodStart: "billingPeriodStart",
	billingPeriodEnd: "billingPeriodEnd",
	usagePeriodStart: "usagePeriodStart",
	usagePeriodEnd: "usagePeriodEnd",
	copiedFromId: "copiedFromId",
	operatingCostsData: "operatingCostsData",
	heatingCostsData: "heatingCostsData",
	serviceChargeAdjustment: "serviceChargeAdjustment",
	depositRetention: "depositRetention",
	ownershipSplitting: "ownershipSplitting",
	emailHistory: "emailHistory",
	correspondenceAddress: "correspondenceAddress",
	statements: "statements",
	participatingProperties: "participatingProperties",
	createdAt: "createdAt",
	updatedAt: "updatedAt"
};
const AnnualServiceChargeStatementsSelect2 = { "*": "*" };
const RentalContractUnitsSelect = {
	rentalContractUnitId: "rentalContractUnitId",
	rentalContractId: "rentalContractId",
	rentableUnitId: "rentableUnitId",
	rentingProcessId: "rentingProcessId"
};
const RentalContractUnitsSelect2 = { "*": "*" };
const RentsSelect = {
	rentId: "rentId",
	coldRent: "coldRent",
	utilityCost: "utilityCost",
	heatingCost: "heatingCost",
	parkingSpaceRent: "parkingSpaceRent",
	totalRent: "totalRent",
	startDate: "startDate",
	endDate: "endDate",
	isColdRentWithParking: "isColdRentWithParking",
	rentIncreaseType: "rentIncreaseType",
	cpi: "cpi",
	cpiDate: "cpiDate",
	cpiStartDate: "cpiStartDate",
	rentalContractUnitId: "rentalContractUnitId",
	vat: "vat"
};
const RentsSelect2 = { "*": "*" };
const RentTenancySelect = {
	rentTenancyId: "rentTenancyId",
	creatorId: "creatorId",
	dunningStatusLevel: "dunningStatusLevel",
	latestDunningNoticeDate: "latestDunningNoticeDate",
	rentBalance: "rentBalance",
	tenantBankAccountId: "tenantBankAccountId",
	transactionReferenceId: "transactionReferenceId",
	estarCoreTenantId: "estarCoreTenantId"
};
const RentTenancySelect2 = { "*": "*" };
const TenancyMembersSelect = {
	contact: "contact",
	company: "company"
};
const TenancyMembersSelect2 = { "*": "*" };
const ContactSelect = {
	contactId: "contactId",
	uuid: "uuid",
	contactType: "contactType",
	salutation: "salutation",
	firstname: "firstname",
	lastname: "lastname",
	fullname: "fullname",
	phoneNumber: "phoneNumber",
	faxNumber: "faxNumber",
	title: "title",
	email: "email",
	contactHours: "contactHours",
	homepageUrl: "homepageUrl",
	rentingLeadId: "rentingLeadId",
	birthday: "birthday",
	userId: "userId",
	personalInfoId: "personalInfoId",
	locationId: "locationId",
	avatarMediaFileId: "avatarMediaFileId",
	registeredToPortal: "registeredToPortal",
	invitedToPortal: "invitedToPortal",
	createdAt: "createdAt"
};
const ContactSelect2 = { "*": "*" };
const CompanySelect = {
	companyId: "companyId",
	name: "name",
	isExternalInvoiceApprover: "isExternalInvoiceApprover",
	invoiceExternalApprovalConfig: "invoiceExternalApprovalConfig",
	mfhRenovationProjectApprovalConfig: "mfhRenovationProjectApprovalConfig",
	contacts: "contacts",
	assetPartnerId: "assetPartnerId",
	sellingPartner: "sellingPartner",
	rentingLeadId: "rentingLeadId",
	createdAt: "createdAt",
	updatedAt: "updatedAt",
	type: "type",
	isHeadquarter: "isHeadquarter",
	corporateForm: "corporateForm",
	shortName: "shortName",
	commercialRegistryCode: "commercialRegistryCode",
	homepage: "homepage",
	email: "email",
	parentCompanyId: "parentCompanyId",
	phoneNumber: "phoneNumber",
	locationId: "locationId",
	isCondoCompany: "isCondoCompany",
	isInactive: "isInactive",
	excludeFromIC: "excludeFromIC",
	location: "location",
	partnerPreviewAccountUid: "partnerPreviewAccountUid"
};
const CompanySelect2 = { "*": "*" };
const TenantBankAccountSelect = {
	bankAccountId: "bankAccountId",
	bankAccountType: "bankAccountType",
	iban: "iban",
	bic: "bic",
	bankId: "bankId",
	parentId: "parentId",
	externalEntityId: "externalEntityId",
	companyId: "companyId",
	contactPersonId: "contactPersonId"
};
const TenantBankAccountSelect2 = { "*": "*" };
const RentableUnitSelect = {
	rentableUnitId: "rentableUnitId",
	type: "type",
	estateId: "estateId",
	rentableUnitProcessId: "rentableUnitProcessId",
	parkingSpaceId: "parkingSpaceId",
	estateElementId: "estateElementId",
	estarCoreUnitId: "estarCoreUnitId",
	createdAt: "createdAt",
	updatedAt: "updatedAt",
	deletedAt: "deletedAt"
};
const RentableUnitSelect2 = { "*": "*" };
const ParentContractSelect = {
	rentalContractId: "rentalContractId",
	status: "status",
	type: "type",
	estateId: "estateId",
	rentTenancyId: "rentTenancyId",
	documentId: "documentId",
	estarCoreRentalContractId: "estarCoreRentalContractId",
	parentTenancyId: "parentTenancyId",
	parentId: "parentId",
	startDate: "startDate",
	endDate: "endDate",
	coldRent: "coldRent",
	heatingCost: "heatingCost",
	utilityCost: "utilityCost",
	monthlyAdditionalRent: "monthlyAdditionalRent",
	parkingSpaceRent: "parkingSpaceRent",
	hasParkingSpace: "hasParkingSpace",
	isColdRentWithParking: "isColdRentWithParking",
	isJobCenter: "isJobCenter",
	isSecondaryRent: "isSecondaryRent",
	numberOfTenantsAtViewing: "numberOfTenantsAtViewing",
	tenantsWithNetIncome: "tenantsWithNetIncome",
	updateRentOnApproval: "updateRentOnApproval",
	livingSpace: "livingSpace",
	isLivings: "isLivings",
	isFlatshare: "isFlatshare",
	isFurnished: "isFurnished",
	rentIncreaseType: "rentIncreaseType",
	rentIncreaseFormula: "rentIncreaseFormula",
	rentIncreaseInterval: "rentIncreaseInterval",
	friIncreaseAmount: "friIncreaseAmount",
	friIncreaseAmountType: "friIncreaseAmountType",
	friIncreaseCycles: "friIncreaseCycles",
	iriMinCap: "iriMinCap",
	iriMaxCap: "iriMaxCap",
	rentalFreePeriod: "rentalFreePeriod",
	rentFreePeriodInMonths: "rentFreePeriodInMonths",
	ancillaryCostFreeStartDate: "ancillaryCostFreeStartDate",
	ancillaryCostFreeEndDate: "ancillaryCostFreeEndDate",
	rentDeposit: "rentDeposit",
	depositReturnDate: "depositReturnDate",
	depositReturnAmount: "depositReturnAmount",
	paidRentDeposit: "paidRentDeposit",
	trackDepositAutomatically: "trackDepositAutomatically",
	numberOfInstallments: "numberOfInstallments",
	coldRentChurnPerSQM: "coldRentChurnPerSQM",
	commercialVATDamage: "commercialVATDamage",
	commercialRentIndexIncrease: "commercialRentIndexIncrease",
	reletDelayInMonths: "reletDelayInMonths",
	rentIncreaseEndDate: "rentIncreaseEndDate",
	isRefurbishedByCurrentOwner: "isRefurbishedByCurrentOwner",
	apartmentCondition: "apartmentCondition",
	condoSalesCondition: "condoSalesCondition",
	condoRefurbishmentCostsPerSQM: "condoRefurbishmentCostsPerSQM",
	rentBeforeIncrease: "rentBeforeIncrease",
	securityDeposit: "securityDeposit",
	vat: "vat",
	lastRentIncreaseDate: "lastRentIncreaseDate",
	valueOfLastRentIncrease: "valueOfLastRentIncrease",
	percentageOfLastRentIncrease: "percentageOfLastRentIncrease",
	isStorageRoomInAtticIsRented: "isStorageRoomInAtticIsRented",
	equipmentFeatures: "equipmentFeatures",
	option: "option",
	otherAgreements: "otherAgreements",
	isRentalContractSigned: "isRentalContractSigned",
	isRentIncreaseSigned: "isRentIncreaseSigned",
	isRentalContractChecked: "isRentalContractChecked",
	otherNote: "otherNote",
	regulationOfRentIncreaseNote: "regulationOfRentIncreaseNote",
	rentingLeadId: "rentingLeadId",
	rentingProcessId: "rentingProcessId",
	signedDocumentId: "signedDocumentId",
	createdAt: "createdAt",
	updatedAt: "updatedAt"
};
const ParentContractSelect2 = { "*": "*" };
//#endregion
//#region src/propx/gen/models/RentalContractStatusEnum.ts
const RentalContractStatusEnum = {
	Draft: "Draft",
	Approved: "Approved",
	Cancelled: "Cancelled",
	Signed: "Signed"
};
//#endregion
//#region src/propx/gen/models/RentalContractTypeEnum.ts
const RentalContractTypeEnum = {
	Regular: "Regular",
	Addendum: "Addendum",
	Sublease: "Sublease"
};
//#endregion
//#region src/propx/gen/models/RentalContractWithoutParent.ts
const ReviewProcessReviewProcessState = {
	Requested: "Requested",
	Cancelled: "Cancelled",
	Approved: "Approved",
	Rejected: "Rejected"
};
//#endregion
//#region src/propx/gen/models/RentingDetails.ts
const RentingDetailsType = {
	Estate: "Estate",
	Room: "Room",
	Parking: "Parking"
};
const RentingDetailsRentingStates = {
	Identified: "Identified",
	ListedByTenant: "ListedByTenant",
	Prepared: "Prepared",
	Listed: "Listed",
	Livings: "Livings",
	ViewingScheduled: "ViewingScheduled",
	Viewed: "Viewed",
	TenantChosen: "TenantChosen",
	SigningScheduled: "SigningScheduled",
	ContractSent: "ContractSent",
	ContractSigned: "ContractSigned",
	HandoverScheduled: "HandoverScheduled",
	HandoverDone: "HandoverDone",
	Completed: "Completed",
	OwnerOccupied: "OwnerOccupied",
	Blocked: "Blocked"
};
//#endregion
//#region src/propx/gen/models/RentingLead.ts
const RentingLeadRentingLeadStatus = {
	New: "New",
	Approved: "Approved"
};
const RentingLeadLeadImpression = {
	Good: "Good",
	Neutral: "Neutral",
	Bad: "Bad"
};
//#endregion
//#region src/propx/gen/models/RentingListing.ts
const RentingListingMediaTags = {
	defect: "defect",
	publish: "publish",
	"construction-plan": "construction-plan",
	inspection: "inspection",
	"before-after": "before-after",
	"expose-building": "expose-building",
	"expose-kitchen": "expose-kitchen",
	"expose-living-room": "expose-living-room",
	"expose-bathroom": "expose-bathroom",
	summary: "summary",
	"expose-room-1": "expose-room-1",
	"expose-room-2": "expose-room-2",
	"expose-room-3": "expose-room-3",
	parking: "parking",
	"key-locker": "key-locker",
	"building-entrance": "building-entrance",
	"apartment-door": "apartment-door",
	"template-expose-bathroom": "template-expose-bathroom",
	"template-expose-kitchen": "template-expose-kitchen",
	"template-expose-living-room": "template-expose-living-room",
	"template-expose-room-1": "template-expose-room-1",
	"template-expose-room-2": "template-expose-room-2",
	"template-expose-room-3": "template-expose-room-3",
	"renting-management": "renting-management",
	"exterior-views": "exterior-views",
	apartments: "apartments",
	"commercial-properties": "commercial-properties",
	marketing: "marketing",
	"main-photo-pre-renovation": "main-photo-pre-renovation",
	"main-photo-post-renovation": "main-photo-post-renovation"
};
//#endregion
//#region src/propx/gen/models/RentingListingProvider.ts
const RentingListingProviderProvider = {
	IS24: "IS24",
	Immomio: "Immomio"
};
const RentingListingProviderState = {
	Created: "Created",
	Prepublished: "Prepublished",
	Published: "Published"
};
//#endregion
//#region src/propx/gen/models/RentingListingProviderEnum.ts
const RentingListingProviderEnum = {
	IS24: "IS24",
	Immomio: "Immomio"
};
//#endregion
//#region src/propx/gen/models/ServiceChargeDistributionKeys.ts
const ServiceChargeDistributionKeys = {
	total_area_m2: "total_area_m2",
	commercial_area_m2: "commercial_area_m2",
	usable_area_m2: "usable_area_m2",
	weighted_area_m2: "weighted_area_m2",
	living_area_m2: "living_area_m2",
	total_units: "total_units",
	residential_units: "residential_units",
	commercial_units: "commercial_units",
	registered_persons: "registered_persons",
	person_days: "person_days",
	person_months: "person_months",
	actual_consumption: "actual_consumption",
	heating_units: "heating_units",
	water_m3: "water_m3",
	warm_water_m3: "warm_water_m3",
	electricity_kwh: "electricity_kwh",
	gas_m3: "gas_m3",
	thousandths: "thousandths",
	land_register_share: "land_register_share",
	fixed_amount: "fixed_amount",
	fixed_percentage: "fixed_percentage",
	custom_ratio: "custom_ratio",
	contract_specific: "contract_specific",
	zero_allocation: "zero_allocation",
	radiator_count: "radiator_count",
	radiator_units: "radiator_units",
	smoke_detector_count: "smoke_detector_count",
	window_count: "window_count",
	window_area_m2: "window_area_m2",
	parking_spaces: "parking_spaces",
	underground_parking_spaces: "underground_parking_spaces",
	balcony_area_m2: "balcony_area_m2",
	room_count: "room_count",
	bathroom_count: "bathroom_count",
	occupancy_days: "occupancy_days",
	occupancy_months: "occupancy_months",
	rental_months: "rental_months",
	degree_days: "degree_days",
	floor_level: "floor_level",
	staircase_assignment: "staircase_assignment",
	insurance: "insurance",
	betriebskostenspiegel: "betriebskostenspiegel",
	heizkostenverordnung: "heizkostenverordnung",
	wirtschaftseinheit: "wirtschaftseinheit",
	nutzeinheit: "nutzeinheit",
	tax_assessment_share: "tax_assessment_share",
	co_ownership_share: "co_ownership_share",
	residential_units_hs: "residential_units_hs",
	total_units_hs: "total_units_hs",
	object_units: "object_units",
	cable_tv_units: "cable_tv_units",
	emission_measurement: "emission_measurement",
	waste_container: "waste_container",
	garden_area_m2: "garden_area_m2",
	basement_area_m2: "basement_area_m2",
	elevator_usage: "elevator_usage",
	households: "households",
	janitor_service: "janitor_service",
	cleaning_service: "cleaning_service",
	winter_service: "winter_service",
	garden_maintenance: "garden_maintenance",
	special_agreement: "special_agreement"
};
//#endregion
//#region src/propx/gen/models/TenancyTypeEnum.ts
const TenancyTypeEnum = {
	MainTenancy: "MainTenancy",
	SubTenancy: "SubTenancy",
	ParkingTenancy: "ParkingTenancy"
};
//#endregion
//#region src/propx/gen/models/Transaction.ts
const SubtagsType21 = { DebtorIban: "DebtorIban" };
const SubtagsType22 = { DebtorBic: "DebtorBic" };
const SubtagsType23 = { Bookingtext: "Bookingtext" };
const SubtagsType24 = { EndToEndReference: "EndToEndReference" };
const SubtagsType25 = { MandateReference: "MandateReference" };
const SubtagsType26 = { CustomerReference: "CustomerReference" };
const SubtagsType27 = { DebtorIdentifier: "DebtorIdentifier" };
const SubtagsType28 = { CreditorIdentifier: "CreditorIdentifier" };
const SubtagsType29 = { SepaRefererenceNumber: "SepaRefererenceNumber" };
const SubtagsType30 = { UltimateDebtor: "UltimateDebtor" };
const SubtagsType31 = { UltimateCreditor: "UltimateCreditor" };
const SubtagsType32 = { PrimanoteNumber: "PrimanoteNumber" };
const SubtagsType33 = { Reference: "Reference" };
const SubtagsType34 = { AdditionalPurpose: "AdditionalPurpose" };
const SubtagsType35 = { Bic: "Bic" };
const SubtagsType36 = { Iban: "Iban" };
const SubtagsType37 = { Debtor: "Debtor" };
const SubtagsType38 = { Creditor: "Creditor" };
const SubtagsType39 = { ReasonCode: "ReasonCode" };
const SubtagsType40 = { Unknown: "Unknown" };
//#endregion
//#region src/propx/gen/models/UploadableAttachmentSchema.ts
const MediaFileOrIdConstructionCraft = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const MediaFileOrIdCategory = {
	Listing: "Listing",
	Inspection: "Inspection",
	PreRenovation: "PreRenovation",
	PostRenovation: "PostRenovation",
	Renovation: "Renovation",
	Avatar: "Avatar",
	Other: "Other",
	PropertyManagement: "PropertyManagement",
	Livings: "Livings",
	TechnicalDDInspection: "TechnicalDDInspection"
};
const MediaFileOrIdTags = {
	defect: "defect",
	publish: "publish",
	"construction-plan": "construction-plan",
	inspection: "inspection",
	"before-after": "before-after",
	"expose-building": "expose-building",
	"expose-kitchen": "expose-kitchen",
	"expose-living-room": "expose-living-room",
	"expose-bathroom": "expose-bathroom",
	summary: "summary",
	"expose-room-1": "expose-room-1",
	"expose-room-2": "expose-room-2",
	"expose-room-3": "expose-room-3",
	parking: "parking",
	"key-locker": "key-locker",
	"building-entrance": "building-entrance",
	"apartment-door": "apartment-door",
	"template-expose-bathroom": "template-expose-bathroom",
	"template-expose-kitchen": "template-expose-kitchen",
	"template-expose-living-room": "template-expose-living-room",
	"template-expose-room-1": "template-expose-room-1",
	"template-expose-room-2": "template-expose-room-2",
	"template-expose-room-3": "template-expose-room-3",
	"renting-management": "renting-management",
	"exterior-views": "exterior-views",
	apartments: "apartments",
	"commercial-properties": "commercial-properties",
	marketing: "marketing",
	"main-photo-pre-renovation": "main-photo-pre-renovation",
	"main-photo-post-renovation": "main-photo-post-renovation"
};
const MediaFileOrIdInternalTags = {
	"listing-title": "listing-title",
	"floor-plan": "floor-plan"
};
//#endregion
//#region src/propx/gen/models/UserCompanyFunction.ts
const UserCompanyFunctionCompanyFunction = {
	Admin: "Admin",
	BusinessDevelopment: "BusinessDevelopment",
	HR: "HR",
	CTO: "CTO",
	PM: "PM",
	SoftwareEngineer: "SoftwareEngineer",
	DataScientist: "DataScientist",
	CDO: "CDO",
	TechnicalProjectLead: "TechnicalProjectLead",
	ProjectLeadConstruction: "ProjectLeadConstruction",
	TLRenovation: "TLRenovation",
	PLRenovation: "PLRenovation",
	RenovationPlanner: "RenovationPlanner",
	Architect: "Architect",
	CFO: "CFO",
	FinanceManager: "FinanceManager",
	Accountant: "Accountant",
	COO: "COO",
	HOTGermany: "HOTGermany",
	HOTCity: "HOTCity",
	TransactionManager: "TransactionManager",
	TransactionBackoffice: "TransactionBackoffice",
	RentingManager: "RentingManager",
	PropertyManager: "PropertyManager",
	InvestmentManager: "InvestmentManager",
	InvestmentBackoffice: "InvestmentBackoffice",
	AssetManager: "AssetManager",
	AssetManagementBackoffice: "AssetManagementBackoffice",
	ManagingDirector: "ManagingDirector",
	EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant"
};
//#endregion
//#region src/propx/gen/models/VatClass.ts
const VatClass = {
	StandardRate: "StandardRate",
	LuxembourgStandardRate: "LuxembourgStandardRate",
	ReducedRate: "ReducedRate",
	ReverseCharge: "ReverseCharge",
	ImportTax: "ImportTax",
	ThirdCountriesOutsideEU: "ThirdCountriesOutsideEU",
	TaxFreeEEUPurchases: "TaxFreeEEUPurchases",
	EUPurchases: "EUPurchases",
	Exempt: "Exempt",
	VATZero: "VATZero",
	ReverseChargeThirdCountry: "ReverseChargeThirdCountry",
	ReverseChargeEU: "ReverseChargeEU",
	IntraCommunityAcquisition: "IntraCommunityAcquisition"
};
//#endregion
//#region src/propx/gen/models/annualServiceChargeStatementModels/FindAnnualServiceChargeStatements.ts
const FindAnnualServiceChargeStatementsQueryParamsOrder = {
	ASC: "ASC",
	DESC: "DESC"
};
//#endregion
//#region src/propx/gen/models/dashboardModels/GetDashboardStatistics.ts
const StatisticsLineOfBusiness = { INSTI: "INSTI" };
const StatisticsLineOfBusiness2 = { RETAIL: "RETAIL" };
const StatisticsLineOfBusiness3 = { INSTI: "INSTI" };
const StatisticsLineOfBusiness4 = { RETAIL: "RETAIL" };
//#endregion
//#region src/propx/gen/models/investorInfoModels/FindInvestorInfos.ts
const FindInvestorInfosQueryParamsStatus = { active: "active" };
const FindInvestorInfosQueryParamsStatus2 = { inactive: "inactive" };
const FindInvestorInfosQueryParamsSevStatus = { yes: "yes" };
const FindInvestorInfosQueryParamsSevStatus2 = { no: "no" };
const FindInvestorInfosQueryParamsHoaFeeStatus = { active: "active" };
const FindInvestorInfosQueryParamsHoaFeeStatus2 = { inactive: "inactive" };
const FindInvestorInfosQueryParamsSevFeeStatus = { active: "active" };
const FindInvestorInfosQueryParamsSevFeeStatus2 = { inactive: "inactive" };
const FindInvestorInfosQueryParamsRepaymentSubsidyStatus = { active: "active" };
const FindInvestorInfosQueryParamsRepaymentSubsidyStatus2 = { inactive: "inactive" };
//#endregion
//#region src/propx/gen/models/maintenanceModels/ResetCache.ts
const ResetCacheMutationRequestKind = { usecase: "usecase" };
const ResetCacheMutationRequestKind2 = { repo: "repo" };
//#endregion
//#region src/propx/gen/models/monthlyInvestorSharesModels/UpdateMonthlyInvestorShare.ts
const DataExcludedReason = {
	NoOwnersAssigned: "NoOwnersAssigned",
	InvestorLedgerNotFound: "InvestorLedgerNotFound",
	LowCashReserve: "LowCashReserve",
	Other: "Other"
};
const DataStatus = {
	New: "New",
	ReadyToGenerate: "ReadyToGenerate",
	ReadyToSend: "ReadyToSend",
	Sent: "Sent",
	Delivered: "Delivered"
};
//#endregion
//#region src/propx/gen/models/monthlyRentGuaranteeModels/FindMonthlyRentGuarantees.ts
const QueryOrder = {
	ASC: "ASC",
	DESC: "DESC"
};
//#endregion
//#region src/propx/gen/models/rentTenancyModels/GetTenanciesList.ts
const GetTenanciesListQueryParamsOrder = { ASC: "ASC" };
const GetTenanciesListQueryParamsOrder2 = { DESC: "DESC" };
const GetTenanciesListQueryParamsOrder3 = { asc: "asc" };
const GetTenanciesListQueryParamsOrder4 = { desc: "desc" };
const GetTenanciesListQueryParamsLineOfBusiness = { RETAIL: "RETAIL" };
const GetTenanciesListQueryParamsLineOfBusiness2 = { INSTI: "INSTI" };
const GetTenanciesListQueryParamsTenantManagementState = { Initiated: "Initiated" };
const GetTenanciesListQueryParamsTenantManagementState2 = { Onboarding: "Onboarding" };
const GetTenanciesListQueryParamsTenantManagementState3 = { Active: "Active" };
const GetTenanciesListQueryParamsTenantManagementState4 = { RentReduction: "RentReduction" };
const GetTenanciesListQueryParamsTenantManagementState5 = { Cancelled: "Cancelled" };
const GetTenanciesListQueryParamsTenantManagementState6 = { TerminationNoticeReceived: "TerminationNoticeReceived" };
const GetTenanciesListQueryParamsTenantManagementState7 = { TerminationAccepted: "TerminationAccepted" };
const GetTenanciesListQueryParamsTenantManagementState8 = { TerminationInitiated: "TerminationInitiated" };
const GetTenanciesListQueryParamsTenantManagementState9 = { HandoverScheduled: "HandoverScheduled" };
const GetTenanciesListQueryParamsTenantManagementState10 = { HandoverDone: "HandoverDone" };
const GetTenanciesListQueryParamsTenantManagementState11 = { Terminated: "Terminated" };
const GetTenanciesListQueryParamsTenantManagementState12 = { Closed: "Closed" };
const GetTenanciesListQueryParamsSellingState = { OnHold: "OnHold" };
const GetTenanciesListQueryParamsSellingState2 = { Identified: "Identified" };
const GetTenanciesListQueryParamsSellingState3 = { Prepared: "Prepared" };
const GetTenanciesListQueryParamsSellingState4 = { SellingPartnerMandated: "SellingPartnerMandated" };
const GetTenanciesListQueryParamsSellingState5 = { SellingPartnerPrepared: "SellingPartnerPrepared" };
const GetTenanciesListQueryParamsSellingState6 = { OnMarket: "OnMarket" };
const GetTenanciesListQueryParamsSellingState7 = { OnOpenMarket: "OnOpenMarket" };
const GetTenanciesListQueryParamsSellingState8 = { OfferReceived: "OfferReceived" };
const GetTenanciesListQueryParamsSellingState9 = { OfferAccepted: "OfferAccepted" };
const GetTenanciesListQueryParamsSellingState10 = { NotaryDraftReceived: "NotaryDraftReceived" };
const GetTenanciesListQueryParamsSellingState11 = { DraftApproved: "DraftApproved" };
const GetTenanciesListQueryParamsSellingState12 = { NotarizationScheduled: "NotarizationScheduled" };
const GetTenanciesListQueryParamsSellingState13 = { Notarized: "Notarized" };
const GetTenanciesListQueryParamsSellingState14 = { FMReceived: "FMReceived" };
const GetTenanciesListQueryParamsSellingState15 = { Paid: "Paid" };
const GetTenanciesListQueryParamsSellingState16 = { HandoverDone: "HandoverDone" };
const GetTenanciesListQueryParamsSellingState17 = { Completed: "Completed" };
const GetTenanciesListQueryParamsSellingState18 = { Cancelled: "Cancelled" };
const GetTenanciesListQueryParamsRentIncreaseType = { NO_INCREASE: "NO_INCREASE" };
const GetTenanciesListQueryParamsRentIncreaseType2 = { MANUAL: "MANUAL" };
const GetTenanciesListQueryParamsRentIncreaseType3 = { IRI: "IRI" };
const GetTenanciesListQueryParamsRentIncreaseType4 = { FRI: "FRI" };
//#endregion
//#region src/propx/gen/models/rentableUnitModels/CreateRentableUnitProcess.ts
const RentableUnitProcessState = { Vacant: "Vacant" };
const RentableUnitProcessState2 = { Occupied: "Occupied" };
const RentableUnitProcessState3 = { OwnerOccupied: "OwnerOccupied" };
const RentableUnitProcessState4 = { PartiallyOccupied: "PartiallyOccupied" };
const RentableUnitProcessState5 = { BlockedByPm: "BlockedByPm" };
const RentableUnitProcessState6 = { BlockedByRenovation: "BlockedByRenovation" };
//#endregion
//#region src/propx/gen/models/rentableUnitModels/GetRentableUnitsList.ts
const GetRentableUnitsListQueryParamsType = {
	Estate: "Estate",
	Room: "Room",
	Parking: "Parking"
};
const GetRentableUnitsListQueryParamsStatus = {
	Available: "Available",
	Occupied: "Occupied",
	All: "All"
};
//#endregion
//#region src/propx/gen/models/rentableUnitModels/UpdateRentableUnit.ts
const RentableUnitType = {
	Estate: "Estate",
	Room: "Room",
	Parking: "Parking"
};
//#endregion
//#region src/propx/gen/models/rentalContractsModels/FindRentalContracts.ts
const PaginationOrder = {
	ASC: "ASC",
	DESC: "DESC"
};
const QueryReviewProcessStates = {
	Requested: "Requested",
	Cancelled: "Cancelled",
	Approved: "Approved",
	Rejected: "Rejected"
};
const QueryStatus = {
	Draft: "Draft",
	Approved: "Approved",
	Cancelled: "Cancelled",
	Signed: "Signed"
};
const QueryStatuses = {
	Draft: "Draft",
	Approved: "Approved",
	Cancelled: "Cancelled",
	Signed: "Signed"
};
const QueryLineOfBusiness = { RETAIL: "RETAIL" };
const QueryLineOfBusiness2 = { INSTI: "INSTI" };
//#endregion
//#region src/propx/gen/models/rentalContractsModels/GetActiveRentalContracts.ts
const GetActiveRentalContractsQueryParamsTypes = {
	Regular: "Regular",
	Addendum: "Addendum",
	Sublease: "Sublease"
};
//#endregion
//#region src/propx/gen/models/rentingLeadModels/FindRentingLeads.ts
const FindRentingLeadsQueryParamsRentingLeadStatus = {
	New: "New",
	Approved: "Approved"
};
//#endregion
//#region src/propx/gen/models/rentingListingModels/CreateRentingListing.ts
const RentingListingMediaTags2 = {
	defect: "defect",
	publish: "publish",
	"construction-plan": "construction-plan",
	inspection: "inspection",
	"before-after": "before-after",
	"expose-building": "expose-building",
	"expose-kitchen": "expose-kitchen",
	"expose-living-room": "expose-living-room",
	"expose-bathroom": "expose-bathroom",
	summary: "summary",
	"expose-room-1": "expose-room-1",
	"expose-room-2": "expose-room-2",
	"expose-room-3": "expose-room-3",
	parking: "parking",
	"key-locker": "key-locker",
	"building-entrance": "building-entrance",
	"apartment-door": "apartment-door",
	"template-expose-bathroom": "template-expose-bathroom",
	"template-expose-kitchen": "template-expose-kitchen",
	"template-expose-living-room": "template-expose-living-room",
	"template-expose-room-1": "template-expose-room-1",
	"template-expose-room-2": "template-expose-room-2",
	"template-expose-room-3": "template-expose-room-3",
	"renting-management": "renting-management",
	"exterior-views": "exterior-views",
	apartments: "apartments",
	"commercial-properties": "commercial-properties",
	marketing: "marketing",
	"main-photo-pre-renovation": "main-photo-pre-renovation",
	"main-photo-post-renovation": "main-photo-post-renovation"
};
//#endregion
//#region src/propx/gen/models/rentingListingModels/InvokeRentingListingAction.ts
const InvokeRentingListingActionPathParamsAction = {
	"pre-publish": "pre-publish",
	publish: "publish",
	"un-publish": "un-publish",
	delete: "delete"
};
//#endregion
//#region src/propx/gen/models/rentingListingModels/UpdateRentingListing.ts
const RentingListingMediaTags3 = {
	defect: "defect",
	publish: "publish",
	"construction-plan": "construction-plan",
	inspection: "inspection",
	"before-after": "before-after",
	"expose-building": "expose-building",
	"expose-kitchen": "expose-kitchen",
	"expose-living-room": "expose-living-room",
	"expose-bathroom": "expose-bathroom",
	summary: "summary",
	"expose-room-1": "expose-room-1",
	"expose-room-2": "expose-room-2",
	"expose-room-3": "expose-room-3",
	parking: "parking",
	"key-locker": "key-locker",
	"building-entrance": "building-entrance",
	"apartment-door": "apartment-door",
	"template-expose-bathroom": "template-expose-bathroom",
	"template-expose-kitchen": "template-expose-kitchen",
	"template-expose-living-room": "template-expose-living-room",
	"template-expose-room-1": "template-expose-room-1",
	"template-expose-room-2": "template-expose-room-2",
	"template-expose-room-3": "template-expose-room-3",
	"renting-management": "renting-management",
	"exterior-views": "exterior-views",
	apartments: "apartments",
	"commercial-properties": "commercial-properties",
	marketing: "marketing",
	"main-photo-pre-renovation": "main-photo-pre-renovation",
	"main-photo-post-renovation": "main-photo-post-renovation"
};
//#endregion
//#region src/propx/gen/models/rentingProcessModels/CreateRentingProcess.ts
const CreateRentingProcessMutationRequestProcessState = {
	Identified: "Identified",
	ListedByTenant: "ListedByTenant",
	Prepared: "Prepared",
	Listed: "Listed",
	Livings: "Livings",
	ViewingScheduled: "ViewingScheduled",
	Viewed: "Viewed",
	TenantChosen: "TenantChosen",
	SigningScheduled: "SigningScheduled",
	ContractSent: "ContractSent",
	ContractSigned: "ContractSigned",
	HandoverScheduled: "HandoverScheduled",
	HandoverDone: "HandoverDone",
	Completed: "Completed",
	OwnerOccupied: "OwnerOccupied",
	Blocked: "Blocked"
};
//#endregion
//#region src/propx/gen/models/rentingProcessModels/SyncRentableUnitProcessStates.ts
const SyncRentableUnitProcessStatesMutationRequestRentingState = {
	Identified: "Identified",
	ListedByTenant: "ListedByTenant",
	Prepared: "Prepared",
	Listed: "Listed",
	Livings: "Livings",
	ViewingScheduled: "ViewingScheduled",
	Viewed: "Viewed",
	TenantChosen: "TenantChosen",
	SigningScheduled: "SigningScheduled",
	ContractSent: "ContractSent",
	ContractSigned: "ContractSigned",
	HandoverScheduled: "HandoverScheduled",
	HandoverDone: "HandoverDone",
	Completed: "Completed",
	OwnerOccupied: "OwnerOccupied",
	Blocked: "Blocked"
};
//#endregion
//#region src/propx/gen/models/userConfirmationModels/SettleUserConfirmation.ts
const SettleUserConfirmationMutationRequestStatus = {
	CREATED: "CREATED",
	APPROVED: "APPROVED",
	TIMEOUT: "TIMEOUT",
	ERROR: "ERROR",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/propx/gen/models/userInfoModels/GetPortalInvitationProgress.ts
const GetPortalInvitationProgressQueryParamsPortalName = { INVESTOR: "INVESTOR" };
const GetPortalInvitationProgressQueryParamsPortalName2 = { TENANT: "TENANT" };
//#endregion
//#region src/propx/gen/models/userInfoModels/UpdateContactEmail.ts
const UpdateContactEmailMutationRequestPortalName = { INVESTOR: "INVESTOR" };
const UpdateContactEmailMutationRequestPortalName2 = { TENANT: "TENANT" };
//#endregion
//#region src/propx/client.ts
const axiosInstance = axios.create({ paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: "repeat" }) } });
function initHTTPClient(baseURL, onRequest, onRejectedResponse) {
	axiosInstance.defaults.baseURL = baseURL;
	if (onRequest) axiosInstance.interceptors.request.use(onRequest);
	if (onRejectedResponse) axiosInstance.interceptors.response.use((response) => response, onRejectedResponse);
	return axiosInstance;
}
const axiosClient = async (config) => {
	return axiosInstance.request({ ...config }).catch((e) => {
		throw e;
	});
};
//#endregion
//#region src/propx/gen/clients/axios.ts
var axios_exports = /* @__PURE__ */ __exportAll({
	addAttachments: () => addAttachments,
	addRentalContractUnit: () => addRentalContractUnit,
	addRentalContractUnitOld: () => addRentalContractUnitOld,
	calculateMonthlyInvestorShare: () => calculateMonthlyInvestorShare,
	convertRentingLeads: () => convertRentingLeads,
	copyAnnualServiceChargeStatement: () => copyAnnualServiceChargeStatement,
	createEstateRentableUnit: () => createEstateRentableUnit,
	createInvestorAnnualSettlement: () => createInvestorAnnualSettlement,
	createInvestorInfo: () => createInvestorInfo,
	createInvestorYearlyPayout: () => createInvestorYearlyPayout,
	createInvoiceFromBka: () => createInvoiceFromBka,
	createParkingRentableUnit: () => createParkingRentableUnit,
	createRent: () => createRent,
	createRentableUnitProcess: () => createRentableUnitProcess,
	createRentingListing: () => createRentingListing,
	createRentingProcess: () => createRentingProcess,
	createRentsFromRentalContract: () => createRentsFromRentalContract,
	createRoomRentableUnit: () => createRoomRentableUnit,
	deleteAnnualServiceChargeStatement: () => deleteAnnualServiceChargeStatement,
	deleteArrearNotice: () => deleteArrearNotice,
	deleteEstateRentableUnit: () => deleteEstateRentableUnit,
	deleteHoaFee: () => deleteHoaFee,
	deleteInvestorAnnualSettlement: () => deleteInvestorAnnualSettlement,
	deleteInvestorYearlyPayout: () => deleteInvestorYearlyPayout,
	deleteParkingRentableUnit: () => deleteParkingRentableUnit,
	deleteRent: () => deleteRent,
	deleteRentTenancy: () => deleteRentTenancy,
	deleteRentableUnitById: () => deleteRentableUnitById,
	deleteRentingLeadById: () => deleteRentingLeadById,
	deleteRentingListing: () => deleteRentingListing,
	deleteRentingListingAttachment: () => deleteRentingListingAttachment,
	deleteRentingProcess: () => deleteRentingProcess,
	deleteRoomRentableUnit: () => deleteRoomRentableUnit,
	deleteUnpublishedRentingListing: () => deleteUnpublishedRentingListing,
	exportMonthlySevPayment: () => exportMonthlySevPayment,
	exportRentingListingAsOpenImmo: () => exportRentingListingAsOpenImmo,
	fetchUserConfirmations: () => fetchUserConfirmations,
	findAnnualServiceChargeStatements: () => findAnnualServiceChargeStatements,
	findAvailableDraftsForRentalContract: () => findAvailableDraftsForRentalContract,
	findInvestorAnnualSettlements: () => findInvestorAnnualSettlements,
	findInvestorInfos: () => findInvestorInfos,
	findInvestorShareIds: () => findInvestorShareIds,
	findInvestorYearlyPayouts: () => findInvestorYearlyPayouts,
	findMatchingRentalContractsByInvestor: () => findMatchingRentalContractsByInvestor,
	findMonthlyInvestorShares: () => findMonthlyInvestorShares,
	findMonthlyRentGuarantees: () => findMonthlyRentGuarantees,
	findRentTenancies: () => findRentTenancies,
	findRentTenancyByRent: () => findRentTenancyByRent,
	findRentableUnits: () => findRentableUnits,
	findRentableUnitsByRentingProcess: () => findRentableUnitsByRentingProcess,
	findRentalContracts: () => findRentalContracts,
	findRentingLeads: () => findRentingLeads,
	findRents: () => findRents,
	findTenants: () => findTenants,
	findTenantsDeprecated: () => findTenantsDeprecated,
	generateAndSendMonthlyInvestorShares: () => generateAndSendMonthlyInvestorShares,
	generateArrearNotices: () => generateArrearNotices,
	generateBkaDocument: () => generateBkaDocument,
	generateInvestorPayoutDocument: () => generateInvestorPayoutDocument,
	generateInvestorPayoutStatement: () => generateInvestorPayoutStatement,
	generateInvestorYearlyPayout: () => generateInvestorYearlyPayout,
	getActiveInvestorInfos: () => getActiveInvestorInfos,
	getActiveRentTenancies: () => getActiveRentTenancies,
	getActiveRentalContracts: () => getActiveRentalContracts,
	getActiveRentsAmounts: () => getActiveRentsAmounts,
	getAnnualServiceChargeStatement: () => getAnnualServiceChargeStatement,
	getAnnualServiceChargeStatementsByEstate: () => getAnnualServiceChargeStatementsByEstate,
	getAnnualServiceChargeStatementsByRentalContract: () => getAnnualServiceChargeStatementsByRentalContract,
	getAnnualServiceChargeStatementsByTenancy: () => getAnnualServiceChargeStatementsByTenancy,
	getBkaEmailInfo: () => getBkaEmailInfo,
	getConfig: () => getConfig,
	getCpiValuesList: () => getCpiValuesList,
	getDashboardStatistics: () => getDashboardStatistics,
	getEntitySetting: () => getEntitySetting,
	getEstateDetails: () => getEstateDetails,
	getEstateRentTenancies: () => getEstateRentTenancies,
	getHoaFee: () => getHoaFee,
	getHoaFeeAtDate: () => getHoaFeeAtDate,
	getHoaFeesByEstate: () => getHoaFeesByEstate,
	getInvestorData: () => getInvestorData,
	getInvestorInfo: () => getInvestorInfo,
	getInvestorPortalAccess: () => getInvestorPortalAccess,
	getInvestorYearlyPayout: () => getInvestorYearlyPayout,
	getLiquidityReserveBuildUpSample: () => getLiquidityReserveBuildUpSample,
	getManyEstateActiveRentTenancies: () => getManyEstateActiveRentTenancies,
	getMfhLatestRents: () => getMfhLatestRents,
	getMinMaxDateOfMonthlyInvestorShare: () => getMinMaxDateOfMonthlyInvestorShare,
	getMonthlyInvestorShareById: () => getMonthlyInvestorShareById,
	getMonthlyInvestorShareStats: () => getMonthlyInvestorShareStats,
	getMonthlyRentGuarantee: () => getMonthlyRentGuarantee,
	getMonthlyRentGuaranteeRange: () => getMonthlyRentGuaranteeRange,
	getPortalInvitationProgress: () => getPortalInvitationProgress,
	getRegisteredTenants: () => getRegisteredTenants,
	getRegularActiveRentalContract: () => getRegularActiveRentalContract,
	getRent: () => getRent,
	getRentTenancy: () => getRentTenancy,
	getRentableUnit: () => getRentableUnit,
	getRentableUnitById: () => getRentableUnitById,
	getRentableUnitsList: () => getRentableUnitsList,
	getRentalContract: () => getRentalContract,
	getRentingDetailsOfEstate: () => getRentingDetailsOfEstate,
	getRentingLeadById: () => getRentingLeadById,
	getRentingListing: () => getRentingListing,
	getRentingListingAttachments: () => getRentingListingAttachments,
	getRentingListingAttachmentsOrder: () => getRentingListingAttachmentsOrder,
	getTenanciesList: () => getTenanciesList,
	getTenants: () => getTenants,
	getTheoreticalPayoutBreakdown: () => getTheoreticalPayoutBreakdown,
	getUnitStatistics: () => getUnitStatistics,
	initializeInvestorInfo: () => initializeInvestorInfo,
	invokeRentingListingAction: () => invokeRentingListingAction,
	isOnboardingValid: () => isOnboardingValid,
	isTerminationComplete: () => isTerminationComplete,
	operations: () => operations,
	patchAnnualServiceChargeStatement: () => patchAnnualServiceChargeStatement,
	patchRentTenancy: () => patchRentTenancy,
	patchRentalContract: () => patchRentalContract,
	recalculateLegacyRentBalance: () => recalculateLegacyRentBalance,
	recalculatePaidDeposit: () => recalculatePaidDeposit,
	recalculateRentBalance: () => recalculateRentBalance,
	rentGuaranteeBatchGenerate: () => rentGuaranteeBatchGenerate,
	resetCache: () => resetCache,
	saveAnnualServiceChargeStatement: () => saveAnnualServiceChargeStatement,
	saveRentTenancy: () => saveRentTenancy,
	saveRentingLead: () => saveRentingLead,
	sendBkaEmail: () => sendBkaEmail,
	sendContactInvitation: () => sendContactInvitation,
	sendEmailInvestorYearlyPayout: () => sendEmailInvestorYearlyPayout,
	sendInvestorPayoutDocument: () => sendInvestorPayoutDocument,
	setInvestorPortalAccess: () => setInvestorPortalAccess,
	settleUserConfirmation: () => settleUserConfirmation,
	stats: () => stats,
	syncRentableUnitProcessStates: () => syncRentableUnitProcessStates,
	updateArrearNotice: () => updateArrearNotice,
	updateContactEmail: () => updateContactEmail,
	updateDunningStatus: () => updateDunningStatus,
	updateInvestorAnnualSettlement: () => updateInvestorAnnualSettlement,
	updateInvestorInfo: () => updateInvestorInfo,
	updateInvestorInfoStartDateAndSpecialDeal: () => updateInvestorInfoStartDateAndSpecialDeal,
	updateInvestorYearlyPayout: () => updateInvestorYearlyPayout,
	updateMonthlyInvestorShare: () => updateMonthlyInvestorShare,
	updateMonthlyInvestorShareOperations: () => updateMonthlyInvestorShareOperations,
	updateMonthlyRentGuarantee: () => updateMonthlyRentGuarantee,
	updateRent: () => updateRent,
	updateRentTenancy: () => updateRentTenancy,
	updateRentableUnit: () => updateRentableUnit,
	updateRentableUnitsEstarCoreId: () => updateRentableUnitsEstarCoreId,
	updateRentalContractStatus: () => updateRentalContractStatus,
	updateRentalContractsEstarCoreId: () => updateRentalContractsEstarCoreId,
	updateRentingListing: () => updateRentingListing,
	updateRentingListingAttachment: () => updateRentingListingAttachment,
	updateRentingListingAttachmentsOrder: () => updateRentingListingAttachmentsOrder,
	updateTenantInformation: () => updateTenantInformation,
	upsertEntitySetting: () => upsertEntitySetting,
	upsertHoaFee: () => upsertHoaFee,
	upsertRentalContract: () => upsertRentalContract
});
/**
* @description Gets the default runtime config for propx frontend
* @link /config
*/
async function getConfig(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/config`,
		...options
	})).data;
}
/**
* @description Resets the cache
* @link /maintenance/reset-cache
*/
async function resetCache(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/maintenance/reset-cache`,
		data,
		...options
	})).data;
}
/**
* @description Create or update renting lead
* @link /api/renting-lead
*/
async function saveRentingLead(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-lead`,
		data,
		...options
	})).data;
}
/**
* @description Get renting lead by id
* @link /api/renting-lead/:rentingLeadId
*/
async function getRentingLeadById({ rentingLeadId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting-lead/${rentingLeadId}`,
		...options
	})).data;
}
/**
* @description Delete renting lead by id
* @link /api/renting-lead/:rentingLeadId
*/
async function deleteRentingLeadById({ rentingLeadId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/renting-lead/${rentingLeadId}`,
		...options
	})).data;
}
/**
* @description Get list of renting leads
* @link /api/renting-lead/list
*/
async function findRentingLeads(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting-lead/list`,
		params,
		...options
	})).data;
}
/**
* @description Convert renting leads to tenants
* @link /api/renting-lead/convert
*/
async function convertRentingLeads(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-lead/convert`,
		data,
		...options
	})).data;
}
/**
* @description Get renting listing
* @link /api/renting-listing
*/
async function getRentingListing(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting-listing`,
		params,
		...options
	})).data;
}
/**
* @description Create renting listing
* @link /api/renting-listing
*/
async function createRentingListing(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-listing`,
		data,
		...options
	})).data;
}
/**
* @description Update renting listing
* @link /api/renting-listing/:rentingListingId
*/
async function updateRentingListing({ rentingListingId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/renting-listing/${rentingListingId}`,
		data,
		...options
	})).data;
}
/**
* @description Delete unpublished renting listing
* @link /api/renting-listing/:rentingListingId
*/
async function deleteUnpublishedRentingListing({ rentingListingId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/renting-listing/${rentingListingId}`,
		...options
	})).data;
}
/**
* @description Delete renting listing
* @link /api/renting-listing/:rentingListingId/provider/:provider
*/
async function deleteRentingListing({ rentingListingId, provider }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/renting-listing/${rentingListingId}/provider/${provider}`,
		...options
	})).data;
}
/**
* @description Pre-publish/publish/un-publish renting listing
* @link /api/renting-listing/:rentingListingId/providers/:provider/actions/:action
*/
async function invokeRentingListingAction({ rentingListingId, provider, action }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-listing/${rentingListingId}/providers/${provider}/actions/${action}`,
		...options
	})).data;
}
/**
* @description Add attachments to renting listing
* @link /api/renting-listing/:rentingLeadId/attachments
*/
async function addAttachments({ rentingLeadId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-listing/${rentingLeadId}/attachments`,
		data,
		...options
	})).data;
}
/**
* @description Get renting listing attachments
* @link /api/renting-listing/:rentingListingId/attachments
*/
async function getRentingListingAttachments({ rentingListingId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting-listing/${rentingListingId}/attachments`,
		...options
	})).data;
}
/**
* @description Get renting listing attachments order
* @link /api/renting-listing/:rentingListingId/attachments-order
*/
async function getRentingListingAttachmentsOrder({ rentingListingId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting-listing/${rentingListingId}/attachments-order`,
		...options
	})).data;
}
/**
* @description Update renting listing attachments order
* @link /api/renting-listing/:rentingListingId/attachments-order
*/
async function updateRentingListingAttachmentsOrder({ rentingListingId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/renting-listing/${rentingListingId}/attachments-order`,
		data,
		...options
	})).data;
}
/**
* @description Update renting listing attachment
* @link /api/renting-listing/:rentingListingId/attachments/:attachmentId
*/
async function updateRentingListingAttachment({ rentingListingId, attachmentId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/renting-listing/${rentingListingId}/attachments/${attachmentId}`,
		data,
		...options
	})).data;
}
/**
* @description Delete renting listing attachment
* @link /api/renting-listing/:rentingListingId/attachments/:attachmentId
*/
async function deleteRentingListingAttachment({ rentingListingId, attachmentId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/renting-listing/${rentingListingId}/attachments/${attachmentId}`,
		...options
	})).data;
}
/**
* @description Export renting listing as open immo
* @link /api/renting-listing/:rentingListingId/export
*/
async function exportRentingListingAsOpenImmo({ rentingListingId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting-listing/${rentingListingId}/export`,
		...options
	})).data;
}
/**
* @description Get renting details of estate
* @link /api/renting/estate/:estateId
*/
async function getRentingDetailsOfEstate({ estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/renting/estate/${estateId}`,
		...options
	})).data;
}
/**
* @description Create renting process
* @link /api/renting-process
*/
async function createRentingProcess(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-process`,
		data,
		...options
	})).data;
}
/**
* @description Sync rentable unit process states for a renting process
* @link /api/renting-process/sync-rentable-unit-states
*/
async function syncRentableUnitProcessStates(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/renting-process/sync-rentable-unit-states`,
		data,
		...options
	})).data;
}
/**
* @description Delete renting process by ID
* @link /api/renting-process/:rentingProcessId
*/
async function deleteRentingProcess({ rentingProcessId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/renting-process/${rentingProcessId}`,
		...options
	})).data;
}
/**
* @description Create rentable unit
* @link /api/estate-rentable-unit
*/
async function createEstateRentableUnit(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/estate-rentable-unit`,
		data,
		...options
	})).data;
}
/**
* @description Create rentable unit
* @link /api/room-rentable-unit
*/
async function createRoomRentableUnit(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/room-rentable-unit`,
		data,
		...options
	})).data;
}
/**
* @description Create rentable unit
* @link /api/parking-rentable-unit
*/
async function createParkingRentableUnit(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/parking-rentable-unit`,
		data,
		...options
	})).data;
}
/**
* @description Update a rentable unit
* @link /api/rentable-unit
*/
async function updateRentableUnit(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/rentable-unit`,
		data,
		...options
	})).data;
}
/**
* @description Find rentable units by estateId or estarCoreUnitId
* @link /api/rentable-unit
*/
async function findRentableUnits(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rentable-unit`,
		params,
		...options
	})).data;
}
/**
* @description Update multiple rentable units EstarCore ids
* @link /api/rentable-units/estar-core-id
*/
async function updateRentableUnitsEstarCoreId(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/rentable-units/estar-core-id`,
		data,
		...options
	})).data;
}
/**
* @description Get rentable unit by id
* @link /api/rentable-unit/:rentableUnitId
*/
async function getRentableUnitById({ rentableUnitId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rentable-unit/${rentableUnitId}`,
		...options
	})).data;
}
/**
* @description Delete rentable unit by id
* @link /api/rentable-unit/:rentableUnitId
*/
async function deleteRentableUnitById({ rentableUnitId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/rentable-unit/${rentableUnitId}`,
		...options
	})).data;
}
/**
* @description Find rentable units by renting process ID
* @link /api/rentable-unit/by-renting-process/:rentingProcessId
*/
async function findRentableUnitsByRentingProcess({ rentingProcessId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rentable-unit/by-renting-process/${rentingProcessId}`,
		params,
		...options
	})).data;
}
/**
* @description Get paginated list of rentable units with search and filtering capabilities
* @link /api/rentable-units/list
*/
async function getRentableUnitsList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rentable-units/list`,
		params,
		...options
	})).data;
}
/**
* @description Get rentable unit by one key. If more than one key is present priority follows: rentableUnitId, estateId, estateElementId, parkingSpaceId
* @link /api/rentable-unit/one
*/
async function getRentableUnit(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rentable-unit/one`,
		params,
		...options
	})).data;
}
/**
* @description Delete estate rentable unit by estateId
* @link /api/estate-rentable-unit/:estateId
*/
async function deleteEstateRentableUnit({ estateId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/estate-rentable-unit/${estateId}`,
		...options
	})).data;
}
/**
* @description Delete room rentable unit by estateElementId
* @link /api/room-rentable-unit/:estateElementId
*/
async function deleteRoomRentableUnit({ estateElementId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/room-rentable-unit/${estateElementId}`,
		...options
	})).data;
}
/**
* @description Delete parking rentable unit by parkingSpaceId
* @link /api/parking-rentable-unit/:parkingSpaceId
*/
async function deleteParkingRentableUnit({ parkingSpaceId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/parking-rentable-unit/${parkingSpaceId}`,
		...options
	})).data;
}
/**
* @description Create rentable unit process
* @link /api/rentable-unit-process
*/
async function createRentableUnitProcess(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rentable-unit-process`,
		data,
		...options
	})).data;
}
/**
* @description Get entity setting by entity ID
* @link /api/entity-setting
*/
async function getEntitySetting(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/entity-setting`,
		params,
		...options
	})).data;
}
/**
* @description Upsert entity setting
* @link /api/entity-setting
*/
async function upsertEntitySetting(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/entity-setting`,
		data,
		...options
	})).data;
}
/**
* @description Get estate details for investor portal
* @link /api/estate/:estateId/details
*/
async function getEstateDetails({ estateId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/estate/${estateId}/details`,
		params,
		...options
	})).data;
}
/**
* @description Get unit statistics (tenancies, investors, defects, notes, documents)
* @link /api/estate/:estateId/statistics
*/
async function getUnitStatistics({ estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/estate/${estateId}/statistics`,
		...options
	})).data;
}
/**
* @description Get HOA fee at date by estate ID
* @link /api/hoa-fees/active-at-date
*/
async function getHoaFeeAtDate(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/hoa-fees/active-at-date`,
		params,
		...options
	})).data;
}
/**
* @description Get HOA fee by ID
* @link /api/hoa-fees/:hoaFeeId
*/
async function getHoaFee({ hoaFeeId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/hoa-fees/${hoaFeeId}`,
		...options
	})).data;
}
/**
* @description Delete HOA fee by ID
* @link /api/hoa-fees/:hoaFeeId
*/
async function deleteHoaFee({ hoaFeeId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/hoa-fees/${hoaFeeId}`,
		...options
	})).data;
}
/**
* @description Get HOA fees by estate ID
* @link /api/estates/:estateId/hoa-fees
*/
async function getHoaFeesByEstate({ estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/estates/${estateId}/hoa-fees`,
		...options
	})).data;
}
/**
* @description Create or update HOA fee
* @link /api/hoa-fees
*/
async function upsertHoaFee(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/hoa-fees`,
		data,
		...options
	})).data;
}
/**
* @description Find investor infos with pagination support
* @link /api/investor-infos
*/
async function findInvestorInfos(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-infos`,
		params,
		...options
	})).data;
}
/**
* @description Create investor info
* @link /api/investor-infos
*/
async function createInvestorInfo(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-infos`,
		data,
		...options
	})).data;
}
/**
* @description Get the active investor info for a given estate or all active investor infos if estateId is not specified
* @link /api/investor-infos/active
*/
async function getActiveInvestorInfos(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-infos/active`,
		params,
		...options
	})).data;
}
/**
* @description Get investor info data by entity ID
* @link /api/investor-infos/:investorInfoId
*/
async function getInvestorInfo({ investorInfoId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-infos/${investorInfoId}`,
		params,
		...options
	})).data;
}
/**
* @description Update investor info
* @link /api/investor-infos/:investorInfoId
*/
async function updateInvestorInfo({ investorInfoId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/investor-infos/${investorInfoId}`,
		data,
		...options
	})).data;
}
/**
* @description Initialize investor info
* @link /api/investor-infos/initialize
*/
async function initializeInvestorInfo(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-infos/initialize`,
		data,
		...options
	})).data;
}
/**
* @description Get theoretical monthly investor shares breakdown
* @link /api/investor-infos/:investorInfoId/theoretical-payout-breakdown
*/
async function getTheoreticalPayoutBreakdown({ investorInfoId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-infos/${investorInfoId}/theoretical-payout-breakdown`,
		...options
	})).data;
}
/**
* @description Get liquidity reserve build up sample
* @link /api/investor-infos/:investorInfoId/liquidity-reserve-sample
*/
async function getLiquidityReserveBuildUpSample({ investorInfoId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-infos/${investorInfoId}/liquidity-reserve-sample`,
		...options
	})).data;
}
/**
* @description Update investor info start date and special deal
* @link /api/investor-infos/start-date-and-special-deal
*/
async function updateInvestorInfoStartDateAndSpecialDeal(data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/investor-infos/start-date-and-special-deal`,
		data,
		...options
	})).data;
}
/**
* @description Get investor data for investor portal
* @link /api/investor-data
*/
async function getInvestorData(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-data`,
		params,
		...options
	})).data;
}
/**
* @description Get investor portal access block state for an investor info
* @link /api/investor-infos/:investorInfoId/portal-access
*/
async function getInvestorPortalAccess({ investorInfoId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-infos/${investorInfoId}/portal-access`,
		...options
	})).data;
}
/**
* @description Block or unblock investor portal access for invited owners of an investor info
* @link /api/investor-infos/:investorInfoId/portal-access
*/
async function setInvestorPortalAccess({ investorInfoId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-infos/${investorInfoId}/portal-access`,
		data,
		...options
	})).data;
}
/**
* @description Get active rents amounts
* @link /api/rents/active-amounts
*/
async function getActiveRentsAmounts(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rents/active-amounts`,
		...options
	})).data;
}
/**
* @description Get rent by ID
* @link /api/rents/:rentId
*/
async function getRent({ rentId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rents/${rentId}`,
		params,
		...options
	})).data;
}
/**
* @description Delete rent by ID
* @link /api/rents/:rentId
*/
async function deleteRent({ rentId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/rents/${rentId}`,
		...options
	})).data;
}
/**
* @description Update rent
* @link /api/rents/:rentId
*/
async function updateRent({ rentId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/rents/${rentId}`,
		data,
		...options
	})).data;
}
/**
* @description Create rent
* @link /api/rents
*/
async function createRent(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rents`,
		data,
		...options
	})).data;
}
/**
* @description Find rents
* @link /api/rents
*/
async function findRents(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rents`,
		params,
		...options
	})).data;
}
/**
* @description Get all CPI values
* @link /api/rents/cpi-values
*/
async function getCpiValuesList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rents/cpi-values`,
		params,
		...options
	})).data;
}
/**
* @description Get rents for MFH building
* @link /api/rents/mfh/:mfhId
*/
async function getMfhLatestRents({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rents/mfh/${mfhId}`,
		...options
	})).data;
}
/**
* @description Get many estates active rent tenancies
* @link /api/rent-tenancies/estates
*/
async function getManyEstateActiveRentTenancies(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/estates`,
		params,
		...options
	})).data;
}
/**
* @description Get currently active rent tenancies
* @link /api/rent-tenancies/active
*/
async function getActiveRentTenancies(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/active`,
		...options
	})).data;
}
/**
* @description Get tenancies list with comprehensive details including contracts, tenants, rents, rentable units, and estates. Requires lineOfBusiness filter (RETAIL or INSTI)
* @link /api/tenancies
*/
async function getTenanciesList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/tenancies`,
		params,
		...options
	})).data;
}
/**
* @description Get rent tenancy by entity ID
* @link /api/rent-tenancies/:rentTenancyId
*/
async function getRentTenancy({ rentTenancyId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/${rentTenancyId}`,
		params,
		...options
	})).data;
}
/**
* @description Delete rent tenancy by entity ID
* @link /api/rent-tenancies/:rentTenancyId
*/
async function deleteRentTenancy({ rentTenancyId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/rent-tenancies/${rentTenancyId}`,
		...options
	})).data;
}
/**
* @description Update rent tenancy
* @link /api/rent-tenancies/:rentTenancyId
*/
async function updateRentTenancy({ rentTenancyId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/rent-tenancies/${rentTenancyId}`,
		data,
		...options
	})).data;
}
/**
* @description Patches one rent tenancy
* @link /api/rent-tenancies/:rentTenancyId
*/
async function patchRentTenancy({ rentTenancyId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/rent-tenancies/${rentTenancyId}`,
		data,
		...options
	})).data;
}
/**
* @description Find rent tenancy by rent ID
* @link /api/rent-tenancies/by-rent/:rentId
*/
async function findRentTenancyByRent({ rentId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/by-rent/${rentId}`,
		...options
	})).data;
}
/**
* @description Get estate rent tenancies
* @link /api/rent-tenancies/estate/:estateId
*/
async function getEstateRentTenancies({ estateId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/estate/${estateId}`,
		params,
		...options
	})).data;
}
/**
* @description Create rent tenancy
* @link /api/rent-tenancies
*/
async function saveRentTenancy(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rent-tenancies`,
		data,
		...options
	})).data;
}
/**
* @description Finds rent tenancies matching the provided query
* @link /api/rent-tenancies
*/
async function findRentTenancies(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies`,
		params,
		...options
	})).data;
}
/**
* @description Recalculate rent balance for one rent tenancy
* @link /api/rent-tenancies/re-calculate-rent-balance
*/
async function recalculateRentBalance(params, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rent-tenancies/re-calculate-rent-balance`,
		params,
		...options
	})).data;
}
/**
* @description Recalculate legact rent balance for one rent tenancy
* @link /api/rent-tenancies/:rentTenancyId/legacy-rent-balance
*/
async function recalculateLegacyRentBalance({ rentTenancyId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/${rentTenancyId}/legacy-rent-balance`,
		...options
	})).data;
}
/**
* @description Update dunning status
* @link /api/rent-tenancies/:rentTenancyId/dunning-status
*/
async function updateDunningStatus({ rentTenancyId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rent-tenancies/${rentTenancyId}/dunning-status`,
		data,
		...options
	})).data;
}
/**
* @description Returns whether the onboarding of the given tenancy is valid or not
* @link /api/rent-tenancies/:rentTenancyId/onboarding
*/
async function isOnboardingValid({ rentTenancyId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/${rentTenancyId}/onboarding`,
		...options
	})).data;
}
/**
* @description Returns whether the onboarding of the given tenancy is valid or not
* @link /api/rent-tenancies/:rentTenancyId/termination
*/
async function isTerminationComplete({ rentTenancyId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/${rentTenancyId}/termination`,
		...options
	})).data;
}
/**
* @description Finds tenants for a given estate (only current/active tenants by default)
* @link /api/rent-tenancies/tenants/:estateId
*/
async function findTenantsDeprecated({ estateId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/tenants/${estateId}`,
		params,
		...options
	})).data;
}
/**
* @description Finds tenants for a given estates (only current/active tenants by default)
* @link /api/rent-tenancies/tenants
*/
async function findTenants(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rent-tenancies/tenants`,
		params,
		...options
	})).data;
}
/**
* @description Find rental contracts
* @link /api/rental-contracts
*/
async function findRentalContracts(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rental-contracts`,
		params,
		...options
	})).data;
}
/**
* @description Upsert rental contract
* @link /api/rental-contracts
*/
async function upsertRentalContract(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contracts`,
		data,
		...options
	})).data;
}
/**
* @description Get rental contract by ID
* @link /api/rental-contracts/:rentalContractId
*/
async function getRentalContract({ rentalContractId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rental-contracts/${rentalContractId}`,
		params,
		...options
	})).data;
}
/**
* @description Patch rental contract
* @link /api/rental-contracts/:rentalContractId
*/
async function patchRentalContract({ rentalContractId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/rental-contracts/${rentalContractId}`,
		data,
		...options
	})).data;
}
/**
* @description Create rents from rental contract
* @link /api/rental-contracts/create-rents
*/
async function createRentsFromRentalContract(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contracts/create-rents`,
		data,
		...options
	})).data;
}
/**
* @description Update rental contracts estar core IDs
* @link /api/rental-contracts/update-estar-core-id
*/
async function updateRentalContractsEstarCoreId(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contracts/update-estar-core-id`,
		data,
		...options
	})).data;
}
/**
* @description Recalculates amount paid for rent deposit from transactions
* @link /api/rental-contracts/:rentalContractId/recalculate-paid-deposit
*/
async function recalculatePaidDeposit({ rentalContractId }, params, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/rental-contracts/${rentalContractId}/recalculate-paid-deposit`,
		params,
		...options
	})).data;
}
/**
* @description Find rental contracts by investorInfoId
* @link /api/rental-contracts/by-investor/:investorInfoId
*/
async function findMatchingRentalContractsByInvestor({ investorInfoId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rental-contracts/by-investor/${investorInfoId}`,
		params,
		...options
	})).data;
}
/**
* @description Update rental contract status
* @link /api/rental-contracts/:rentalContractId/status
*/
async function updateRentalContractStatus({ rentalContractId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contracts/${rentalContractId}/status`,
		data,
		...options
	})).data;
}
/**
* @description Add a rentable unit to a rental contract
* @link /api/rental-contracts/:rentalContractId/units
*/
async function addRentalContractUnitOld({ rentalContractId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contracts/${rentalContractId}/units`,
		data,
		...options
	})).data;
}
/**
* @description Find available drafts for rental contract
* @link /api/rental-contracts/find-available-drafts
*/
async function findAvailableDraftsForRentalContract(params, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contracts/find-available-drafts`,
		params,
		...options
	})).data;
}
/**
* @description Get active rental contracts, optionally filtered by type
* @link /api/rental-contracts/active
*/
async function getActiveRentalContracts(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rental-contracts/active`,
		params,
		...options
	})).data;
}
/**
* @description Get regular (non sublease) active rental contract for a given rentable unit
* @link /api/rental-contracts/regular-active
*/
async function getRegularActiveRentalContract(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/rental-contracts/regular-active`,
		params,
		...options
	})).data;
}
/**
* @description Add a rentable unit to a rental contract
* @link /api/rental-contract-units
*/
async function addRentalContractUnit(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/rental-contract-units`,
		data,
		...options
	})).data;
}
/**
* @description Get all tenants
* @link /api/tenants
*/
async function getTenants(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/tenants`,
		...options
	})).data;
}
/**
* @description Update tenant information
* @link /api/tenants
*/
async function updateTenantInformation(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/tenants`,
		data,
		...options
	})).data;
}
/**
* @description Find many monthly investor shares
* @link /api/investor-share
*/
async function findMonthlyInvestorShares(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-share`,
		params,
		...options
	})).data;
}
/**
* @description Get min/max dates of across investor shares data
* @link /api/investor-share/min-max-date
*/
async function getMinMaxDateOfMonthlyInvestorShare(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-share/min-max-date`,
		...options
	})).data;
}
/**
* @description Get investor shares by ID
* @link /api/investor-share/:monthlyInvestorShareId
*/
async function getMonthlyInvestorShareById({ monthlyInvestorShareId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-share/${monthlyInvestorShareId}`,
		params,
		...options
	})).data;
}
/**
* @description Update monthly investor share operations
* @link /api/monthly-investor-shares/:monthlyInvestorShareId/operations
*/
async function updateMonthlyInvestorShareOperations({ monthlyInvestorShareId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/monthly-investor-shares/${monthlyInvestorShareId}/operations`,
		data,
		...options
	})).data;
}
/**
* @description Update monthly investor share
* @link /api/monthly-investor-shares/:monthlyInvestorShareId
*/
async function updateMonthlyInvestorShare({ monthlyInvestorShareId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/monthly-investor-shares/${monthlyInvestorShareId}`,
		data,
		...options
	})).data;
}
/**
* @description Export SEV payment
* @link /api/investor-share/export-monthly-sev-payment
*/
async function exportMonthlySevPayment(data, params, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-share/export-monthly-sev-payment`,
		params,
		data,
		...options
	})).data;
}
/**
* @description Generate and send all checked monthly investor shares for the provided month
* @link /api/investor-share/generate-and-send
*/
async function generateAndSendMonthlyInvestorShares(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-share/generate-and-send`,
		data,
		...options
	})).data;
}
/**
* @description Calculate monthly investor share
* @link /api/investor-share/calculate
*/
async function calculateMonthlyInvestorShare(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-share/calculate`,
		data,
		...options
	})).data;
}
/**
* @link /admin/investor-share/generate-investor-payout-document
*/
async function generateInvestorPayoutDocument(options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/admin/investor-share/generate-investor-payout-document`,
		...options
	})).data;
}
/**
* @link /admin/investor-share/send-investor-payout-document
*/
async function sendInvestorPayoutDocument(options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/admin/investor-share/send-investor-payout-document`,
		...options
	})).data;
}
/**
* @description Find investor share IDs for a given month
* @link /api/investor-share/ids
*/
async function findInvestorShareIds(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-share/ids`,
		params,
		...options
	})).data;
}
/**
* @description Get monthly investor share statistics
* @link /api/investor-share/stats
*/
async function getMonthlyInvestorShareStats(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-share/stats`,
		params,
		...options
	})).data;
}
/**
* @description Generate investor payout statement document
* @link /api/investor-share/:monthlyInvestorShareId/generate-payout-statement
*/
async function generateInvestorPayoutStatement({ monthlyInvestorShareId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-share/${monthlyInvestorShareId}/generate-payout-statement`,
		data,
		...options
	})).data;
}
/**
* @description Get monthly rent guarantee date range
* @link /api/monthly-rent-guarantees/date-range
*/
async function getMonthlyRentGuaranteeRange(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/monthly-rent-guarantees/date-range`,
		...options
	})).data;
}
/**
* @description Get monthly rent guarantee by ID
* @link /api/monthly-rent-guarantees/:monthlyRentGuaranteeId
*/
async function getMonthlyRentGuarantee({ monthlyRentGuaranteeId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/monthly-rent-guarantees/${monthlyRentGuaranteeId}`,
		params,
		...options
	})).data;
}
/**
* @description Update monthly rent guarantee
* @link /api/monthly-rent-guarantees/:monthlyRentGuaranteeId
*/
async function updateMonthlyRentGuarantee({ monthlyRentGuaranteeId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/monthly-rent-guarantees/${monthlyRentGuaranteeId}`,
		data,
		...options
	})).data;
}
/**
* @description Generate rent guarantee in batch
* @link /api/monthly-rent-guarantees/generate
*/
async function rentGuaranteeBatchGenerate(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/monthly-rent-guarantees/generate`,
		data,
		...options
	})).data;
}
/**
* @description Find monthly rent guarantees
* @link /api/monthly-rent-guarantees
*/
async function findMonthlyRentGuarantees(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/monthly-rent-guarantees`,
		params,
		...options
	})).data;
}
/**
* @description Update a rent arrear notice
* @link /api/rent-arrear-notice
*/
async function updateArrearNotice(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/rent-arrear-notice`,
		data,
		...options
	})).data;
}
/**
* @description Delete a rent arrear notice
* @link /api/rent-arrear-notice/:rentArrearNoticeId
*/
async function deleteArrearNotice({ rentArrearNoticeId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/rent-arrear-notice/${rentArrearNoticeId}`,
		...options
	})).data;
}
/**
* @description Generate arrear notices
* @link /rent-arrear-notices/generate
*/
async function generateArrearNotices(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/rent-arrear-notices/generate`,
		data,
		...options
	})).data;
}
/**
* @link /stats
*/
async function stats(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/stats`,
		params,
		...options
	})).data;
}
/**
* @description Schedule contact invitation sending
* @link /api/contacts/:contactId/invitation-request
*/
async function sendContactInvitation({ contactId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/contacts/${contactId}/invitation-request`,
		data,
		...options
	})).data;
}
/**
* @description Get contacts Invitation Progress (Registered, Invited)
* @link /api/contacts/invitation-progress
*/
async function getPortalInvitationProgress(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/contacts/invitation-progress`,
		params,
		...options
	})).data;
}
/**
* @description Get registered tenants at Livings
* @link /api/registered-tenants
*/
async function getRegisteredTenants(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/registered-tenants`,
		...options
	})).data;
}
/**
* @description Update contact email
* @link /api/contacts/:contactId/update-email
*/
async function updateContactEmail({ contactId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/contacts/${contactId}/update-email`,
		data,
		...options
	})).data;
}
/**
* @description Find investorAnnualSettlements
* @link /api/investor-annual-settlement
*/
async function findInvestorAnnualSettlements(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-annual-settlement`,
		params,
		...options
	})).data;
}
/**
* @description Creates a new investorAnnualSettlement
* @link /api/investor-annual-settlement
*/
async function createInvestorAnnualSettlement(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-annual-settlement`,
		data,
		...options
	})).data;
}
/**
* @description Updates a investorAnnualSettlement
* @link /api/investor-annual-settlement
*/
async function updateInvestorAnnualSettlement(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/investor-annual-settlement`,
		data,
		...options
	})).data;
}
/**
* @description Deletes a investorAnnualSettlement
* @link /api/investor-annual-settlement/:investorAnnualSettlementId
*/
async function deleteInvestorAnnualSettlement({ investorAnnualSettlementId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/investor-annual-settlement/${investorAnnualSettlementId}`,
		...options
	})).data;
}
/**
* @description Find investorYearlyPayouts
* @link /api/investor-yearly-payout
*/
async function findInvestorYearlyPayouts(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-yearly-payout`,
		params,
		...options
	})).data;
}
/**
* @description Creates a new investorYearlyPayout
* @link /api/investor-yearly-payout
*/
async function createInvestorYearlyPayout(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-yearly-payout`,
		data,
		...options
	})).data;
}
/**
* @description Updates a investorYearlyPayout
* @link /api/investor-yearly-payout
*/
async function updateInvestorYearlyPayout(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/investor-yearly-payout`,
		data,
		...options
	})).data;
}
/**
* @description Generates a new investorYearlyPayout
* @link /api/investor-yearly-payout/generate
*/
async function generateInvestorYearlyPayout(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-yearly-payout/generate`,
		data,
		...options
	})).data;
}
/**
* @description Gets a investor yearly payout
* @link /api/investor-yearly-payout/:investorYearlyPayoutId
*/
async function getInvestorYearlyPayout({ investorYearlyPayoutId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/investor-yearly-payout/${investorYearlyPayoutId}`,
		params,
		...options
	})).data;
}
/**
* @description Deletes a investorYearlyPayout
* @link /api/investor-yearly-payout/:investorYearlyPayoutId
*/
async function deleteInvestorYearlyPayout({ investorYearlyPayoutId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/investor-yearly-payout/${investorYearlyPayoutId}`,
		...options
	})).data;
}
/**
* @description Send Investor Yearly Payout to investor by email
* @link /api/investor-yearly-payout/:investorYearlyPayoutId/send-email
*/
async function sendEmailInvestorYearlyPayout({ investorYearlyPayoutId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/investor-yearly-payout/${investorYearlyPayoutId}/send-email`,
		...options
	})).data;
}
/**
* @description Get a Nebenkostenabrechnung
* @link /api/annual-service-charge-statement/:serviceChargeStatementId
*/
async function getAnnualServiceChargeStatement({ serviceChargeStatementId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}`,
		params,
		...options
	})).data;
}
/**
* @description Patch specific fields of a Nebenkostenabrechnung
* @link /api/annual-service-charge-statement/:serviceChargeStatementId
*/
async function patchAnnualServiceChargeStatement({ serviceChargeStatementId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}`,
		data,
		...options
	})).data;
}
/**
* @description Delete Nebenkostenabrechnung
* @link /api/annual-service-charge-statement/:serviceChargeStatementId
*/
async function deleteAnnualServiceChargeStatement({ serviceChargeStatementId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}`,
		...options
	})).data;
}
/**
* @description Save a Nebenkostenabrechnung
* @link /api/annual-service-charge-statement
*/
async function saveAnnualServiceChargeStatement(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/annual-service-charge-statement`,
		data,
		...options
	})).data;
}
/**
* @description Find Annual Service Charge Statements
* @link /api/annual-service-charge-statement/list
*/
async function findAnnualServiceChargeStatements(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/annual-service-charge-statement/list`,
		params,
		...options
	})).data;
}
/**
* @description Get Annual Service Charges by Tenancy
* @link /api/annual-service-charge-statement/tenancy
*/
async function getAnnualServiceChargeStatementsByTenancy(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/annual-service-charge-statement/tenancy`,
		params,
		...options
	})).data;
}
/**
* @description Get Annual Service Charges by Rental Contract
* @link /api/annual-service-charge-statement/rental-contract
*/
async function getAnnualServiceChargeStatementsByRentalContract(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/annual-service-charge-statement/rental-contract`,
		params,
		...options
	})).data;
}
/**
* @description Get Annual Service Charge Statements by Estate
* @link /api/annual-service-charge-statement/estate/:estateId
*/
async function getAnnualServiceChargeStatementsByEstate({ estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/annual-service-charge-statement/estate/${estateId}`,
		...options
	})).data;
}
/**
* @description Create Invoice from BKA
* @link /api/annual-service-charge-statement/:serviceChargeStatementId/invoice
*/
async function createInvoiceFromBka({ serviceChargeStatementId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/invoice`,
		data,
		...options
	})).data;
}
/**
* @description Generate a BKA document by statement and type
* @link /api/annual-service-charge-statement/:serviceChargeStatementId/generate-document
*/
async function generateBkaDocument({ serviceChargeStatementId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/generate-document`,
		data,
		...options
	})).data;
}
/**
* @description Copy an existing Annual Service Charge Statement
* @link /api/annual-service-charge-statement/:annualServiceChargeStatementId/copy
*/
async function copyAnnualServiceChargeStatement({ annualServiceChargeStatementId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/annual-service-charge-statement/${annualServiceChargeStatementId}/copy`,
		...options
	})).data;
}
/**
* @description Get BKA email information including tenants, investors, and email content
* @link /api/annual-service-charge-statement/:serviceChargeStatementId/email-info
*/
async function getBkaEmailInfo({ serviceChargeStatementId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/email-info`,
		...options
	})).data;
}
/**
* @description Send BKA emails to tenants and investors
* @link /api/annual-service-charge-statement/:serviceChargeStatementId/send-email
*/
async function sendBkaEmail({ serviceChargeStatementId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/send-email`,
		data,
		...options
	})).data;
}
/**
* @link /dashboard/statistics
*/
async function getDashboardStatistics(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/dashboard/statistics`,
		...options
	})).data;
}
/**
* @description Settles a user-confirmation (either approved or rejected)
* @link /user-confirmations/:id
*/
async function settleUserConfirmation({ id }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-confirmations/${id}`,
		data,
		...options
	})).data;
}
/**
* @description Fetches user-confirmations, which are not yet approved/rejected
* @link /user-confirmations
*/
async function fetchUserConfirmations(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/user-confirmations`,
		...options
	})).data;
}
const operations = {
	getConfig: {
		path: "/config",
		method: "get"
	},
	resetCache: {
		path: "/maintenance/reset-cache",
		method: "post"
	},
	saveRentingLead: {
		path: "/api/renting-lead",
		method: "post"
	},
	getRentingLeadById: {
		path: "/api/renting-lead/:rentingLeadId",
		method: "get"
	},
	deleteRentingLeadById: {
		path: "/api/renting-lead/:rentingLeadId",
		method: "delete"
	},
	findRentingLeads: {
		path: "/api/renting-lead/list",
		method: "get"
	},
	convertRentingLeads: {
		path: "/api/renting-lead/convert",
		method: "post"
	},
	getRentingListing: {
		path: "/api/renting-listing",
		method: "get"
	},
	createRentingListing: {
		path: "/api/renting-listing",
		method: "post"
	},
	updateRentingListing: {
		path: "/api/renting-listing/:rentingListingId",
		method: "patch"
	},
	deleteUnpublishedRentingListing: {
		path: "/api/renting-listing/:rentingListingId",
		method: "delete"
	},
	deleteRentingListing: {
		path: "/api/renting-listing/:rentingListingId/provider/:provider",
		method: "delete"
	},
	invokeRentingListingAction: {
		path: "/api/renting-listing/:rentingListingId/providers/:provider/actions/:action",
		method: "post"
	},
	addAttachments: {
		path: "/api/renting-listing/:rentingLeadId/attachments",
		method: "post"
	},
	getRentingListingAttachments: {
		path: "/api/renting-listing/:rentingListingId/attachments",
		method: "get"
	},
	getRentingListingAttachmentsOrder: {
		path: "/api/renting-listing/:rentingListingId/attachments-order",
		method: "get"
	},
	updateRentingListingAttachmentsOrder: {
		path: "/api/renting-listing/:rentingListingId/attachments-order",
		method: "put"
	},
	updateRentingListingAttachment: {
		path: "/api/renting-listing/:rentingListingId/attachments/:attachmentId",
		method: "put"
	},
	deleteRentingListingAttachment: {
		path: "/api/renting-listing/:rentingListingId/attachments/:attachmentId",
		method: "delete"
	},
	exportRentingListingAsOpenImmo: {
		path: "/api/renting-listing/:rentingListingId/export",
		method: "get"
	},
	getRentingDetailsOfEstate: {
		path: "/api/renting/estate/:estateId",
		method: "get"
	},
	createRentingProcess: {
		path: "/api/renting-process",
		method: "post"
	},
	syncRentableUnitProcessStates: {
		path: "/api/renting-process/sync-rentable-unit-states",
		method: "post"
	},
	deleteRentingProcess: {
		path: "/api/renting-process/:rentingProcessId",
		method: "delete"
	},
	createEstateRentableUnit: {
		path: "/api/estate-rentable-unit",
		method: "post"
	},
	createRoomRentableUnit: {
		path: "/api/room-rentable-unit",
		method: "post"
	},
	createParkingRentableUnit: {
		path: "/api/parking-rentable-unit",
		method: "post"
	},
	updateRentableUnit: {
		path: "/api/rentable-unit",
		method: "put"
	},
	findRentableUnits: {
		path: "/api/rentable-unit",
		method: "get"
	},
	updateRentableUnitsEstarCoreId: {
		path: "/api/rentable-units/estar-core-id",
		method: "put"
	},
	getRentableUnitById: {
		path: "/api/rentable-unit/:rentableUnitId",
		method: "get"
	},
	deleteRentableUnitById: {
		path: "/api/rentable-unit/:rentableUnitId",
		method: "delete"
	},
	findRentableUnitsByRentingProcess: {
		path: "/api/rentable-unit/by-renting-process/:rentingProcessId",
		method: "get"
	},
	getRentableUnitsList: {
		path: "/api/rentable-units/list",
		method: "get"
	},
	getRentableUnit: {
		path: "/api/rentable-unit/one",
		method: "get"
	},
	deleteEstateRentableUnit: {
		path: "/api/estate-rentable-unit/:estateId",
		method: "delete"
	},
	deleteRoomRentableUnit: {
		path: "/api/room-rentable-unit/:estateElementId",
		method: "delete"
	},
	deleteParkingRentableUnit: {
		path: "/api/parking-rentable-unit/:parkingSpaceId",
		method: "delete"
	},
	createRentableUnitProcess: {
		path: "/api/rentable-unit-process",
		method: "post"
	},
	getEntitySetting: {
		path: "/api/entity-setting",
		method: "get"
	},
	upsertEntitySetting: {
		path: "/api/entity-setting",
		method: "post"
	},
	getEstateDetails: {
		path: "/api/estate/:estateId/details",
		method: "get"
	},
	getUnitStatistics: {
		path: "/api/estate/:estateId/statistics",
		method: "get"
	},
	getHoaFeeAtDate: {
		path: "/api/hoa-fees/active-at-date",
		method: "get"
	},
	getHoaFee: {
		path: "/api/hoa-fees/:hoaFeeId",
		method: "get"
	},
	deleteHoaFee: {
		path: "/api/hoa-fees/:hoaFeeId",
		method: "delete"
	},
	getHoaFeesByEstate: {
		path: "/api/estates/:estateId/hoa-fees",
		method: "get"
	},
	upsertHoaFee: {
		path: "/api/hoa-fees",
		method: "post"
	},
	findInvestorInfos: {
		path: "/api/investor-infos",
		method: "get"
	},
	createInvestorInfo: {
		path: "/api/investor-infos",
		method: "post"
	},
	getActiveInvestorInfos: {
		path: "/api/investor-infos/active",
		method: "get"
	},
	getInvestorInfo: {
		path: "/api/investor-infos/:investorInfoId",
		method: "get"
	},
	updateInvestorInfo: {
		path: "/api/investor-infos/:investorInfoId",
		method: "put"
	},
	initializeInvestorInfo: {
		path: "/api/investor-infos/initialize",
		method: "post"
	},
	getTheoreticalPayoutBreakdown: {
		path: "/api/investor-infos/:investorInfoId/theoretical-payout-breakdown",
		method: "get"
	},
	getLiquidityReserveBuildUpSample: {
		path: "/api/investor-infos/:investorInfoId/liquidity-reserve-sample",
		method: "get"
	},
	updateInvestorInfoStartDateAndSpecialDeal: {
		path: "/api/investor-infos/start-date-and-special-deal",
		method: "patch"
	},
	getInvestorData: {
		path: "/api/investor-data",
		method: "get"
	},
	getInvestorPortalAccess: {
		path: "/api/investor-infos/:investorInfoId/portal-access",
		method: "get"
	},
	setInvestorPortalAccess: {
		path: "/api/investor-infos/:investorInfoId/portal-access",
		method: "post"
	},
	getActiveRentsAmounts: {
		path: "/api/rents/active-amounts",
		method: "get"
	},
	getRent: {
		path: "/api/rents/:rentId",
		method: "get"
	},
	deleteRent: {
		path: "/api/rents/:rentId",
		method: "delete"
	},
	updateRent: {
		path: "/api/rents/:rentId",
		method: "put"
	},
	createRent: {
		path: "/api/rents",
		method: "post"
	},
	findRents: {
		path: "/api/rents",
		method: "get"
	},
	getCPIValuesList: {
		path: "/api/rents/cpi-values",
		method: "get"
	},
	getMfhLatestRents: {
		path: "/api/rents/mfh/:mfhId",
		method: "get"
	},
	getManyEstateActiveRentTenancies: {
		path: "/api/rent-tenancies/estates",
		method: "get"
	},
	getActiveRentTenancies: {
		path: "/api/rent-tenancies/active",
		method: "get"
	},
	getTenanciesList: {
		path: "/api/tenancies",
		method: "get"
	},
	getRentTenancy: {
		path: "/api/rent-tenancies/:rentTenancyId",
		method: "get"
	},
	deleteRentTenancy: {
		path: "/api/rent-tenancies/:rentTenancyId",
		method: "delete"
	},
	updateRentTenancy: {
		path: "/api/rent-tenancies/:rentTenancyId",
		method: "put"
	},
	patchRentTenancy: {
		path: "/api/rent-tenancies/:rentTenancyId",
		method: "patch"
	},
	findRentTenancyByRent: {
		path: "/api/rent-tenancies/by-rent/:rentId",
		method: "get"
	},
	getEstateRentTenancies: {
		path: "/api/rent-tenancies/estate/:estateId",
		method: "get"
	},
	saveRentTenancy: {
		path: "/api/rent-tenancies",
		method: "post"
	},
	findRentTenancies: {
		path: "/api/rent-tenancies",
		method: "get"
	},
	recalculateRentBalance: {
		path: "/api/rent-tenancies/re-calculate-rent-balance",
		method: "post"
	},
	recalculateLegacyRentBalance: {
		path: "/api/rent-tenancies/:rentTenancyId/legacy-rent-balance",
		method: "get"
	},
	updateDunningStatus: {
		path: "/api/rent-tenancies/:rentTenancyId/dunning-status",
		method: "post"
	},
	isOnboardingValid: {
		path: "/api/rent-tenancies/:rentTenancyId/onboarding",
		method: "get"
	},
	isTerminationComplete: {
		path: "/api/rent-tenancies/:rentTenancyId/termination",
		method: "get"
	},
	findTenantsDeprecated: {
		path: "/api/rent-tenancies/tenants/:estateId",
		method: "get"
	},
	findTenants: {
		path: "/api/rent-tenancies/tenants",
		method: "get"
	},
	findRentalContracts: {
		path: "/api/rental-contracts",
		method: "get"
	},
	upsertRentalContract: {
		path: "/api/rental-contracts",
		method: "post"
	},
	getRentalContract: {
		path: "/api/rental-contracts/:rentalContractId",
		method: "get"
	},
	patchRentalContract: {
		path: "/api/rental-contracts/:rentalContractId",
		method: "patch"
	},
	createRentsFromRentalContract: {
		path: "/api/rental-contracts/create-rents",
		method: "post"
	},
	updateRentalContractsEstarCoreId: {
		path: "/api/rental-contracts/update-estar-core-id",
		method: "post"
	},
	recalculatePaidDeposit: {
		path: "/api/rental-contracts/:rentalContractId/recalculate-paid-deposit",
		method: "put"
	},
	findMatchingRentalContractsByInvestor: {
		path: "/api/rental-contracts/by-investor/:investorInfoId",
		method: "get"
	},
	updateRentalContractStatus: {
		path: "/api/rental-contracts/:rentalContractId/status",
		method: "post"
	},
	addRentalContractUnit_old: {
		path: "/api/rental-contracts/:rentalContractId/units",
		method: "post"
	},
	findAvailableDraftsForRentalContract: {
		path: "/api/rental-contracts/find-available-drafts",
		method: "post"
	},
	getActiveRentalContracts: {
		path: "/api/rental-contracts/active",
		method: "get"
	},
	getRegularActiveRentalContract: {
		path: "/api/rental-contracts/regular-active",
		method: "get"
	},
	addRentalContractUnit: {
		path: "/api/rental-contract-units",
		method: "post"
	},
	getTenants: {
		path: "/api/tenants",
		method: "get"
	},
	updateTenantInformation: {
		path: "/api/tenants",
		method: "put"
	},
	findMonthlyInvestorShares: {
		path: "/api/investor-share",
		method: "get"
	},
	getMinMaxDateOfMonthlyInvestorShare: {
		path: "/api/investor-share/min-max-date",
		method: "get"
	},
	getMonthlyInvestorShareById: {
		path: "/api/investor-share/:monthlyInvestorShareId",
		method: "get"
	},
	updateMonthlyInvestorShareOperations: {
		path: "/api/monthly-investor-shares/:monthlyInvestorShareId/operations",
		method: "put"
	},
	updateMonthlyInvestorShare: {
		path: "/api/monthly-investor-shares/:monthlyInvestorShareId",
		method: "patch"
	},
	exportMonthlySevPayment: {
		path: "/api/investor-share/export-monthly-sev-payment",
		method: "post"
	},
	generateAndSendMonthlyInvestorShares: {
		path: "/api/investor-share/generate-and-send",
		method: "post"
	},
	calculateMonthlyInvestorShare: {
		path: "/api/investor-share/calculate",
		method: "post"
	},
	generateInvestorPayoutDocument: {
		path: "/admin/investor-share/generate-investor-payout-document",
		method: "post"
	},
	sendInvestorPayoutDocument: {
		path: "/admin/investor-share/send-investor-payout-document",
		method: "post"
	},
	findInvestorShareIds: {
		path: "/api/investor-share/ids",
		method: "get"
	},
	getMonthlyInvestorShareStats: {
		path: "/api/investor-share/stats",
		method: "get"
	},
	generateInvestorPayoutStatement: {
		path: "/api/investor-share/:monthlyInvestorShareId/generate-payout-statement",
		method: "post"
	},
	getMonthlyRentGuaranteeRange: {
		path: "/api/monthly-rent-guarantees/date-range",
		method: "get"
	},
	getMonthlyRentGuarantee: {
		path: "/api/monthly-rent-guarantees/:monthlyRentGuaranteeId",
		method: "get"
	},
	updateMonthlyRentGuarantee: {
		path: "/api/monthly-rent-guarantees/:monthlyRentGuaranteeId",
		method: "patch"
	},
	rentGuaranteeBatchGenerate: {
		path: "/api/monthly-rent-guarantees/generate",
		method: "post"
	},
	findMonthlyRentGuarantees: {
		path: "/api/monthly-rent-guarantees",
		method: "get"
	},
	updateArrearNotice: {
		path: "/api/rent-arrear-notice",
		method: "put"
	},
	deleteArrearNotice: {
		path: "/api/rent-arrear-notice/:rentArrearNoticeId",
		method: "delete"
	},
	generateArrearNotices: {
		path: "/rent-arrear-notices/generate",
		method: "post"
	},
	stats: {
		path: "/stats",
		method: "get"
	},
	sendContactInvitation: {
		path: "/api/contacts/:contactId/invitation-request",
		method: "post"
	},
	getPortalInvitationProgress: {
		path: "/api/contacts/invitation-progress",
		method: "get"
	},
	getRegisteredTenants: {
		path: "/api/registered-tenants",
		method: "get"
	},
	updateContactEmail: {
		path: "/api/contacts/:contactId/update-email",
		method: "post"
	},
	findInvestorAnnualSettlements: {
		path: "/api/investor-annual-settlement",
		method: "get"
	},
	createInvestorAnnualSettlement: {
		path: "/api/investor-annual-settlement",
		method: "post"
	},
	updateInvestorAnnualSettlement: {
		path: "/api/investor-annual-settlement",
		method: "put"
	},
	deleteInvestorAnnualSettlement: {
		path: "/api/investor-annual-settlement/:investorAnnualSettlementId",
		method: "delete"
	},
	findInvestorYearlyPayouts: {
		path: "/api/investor-yearly-payout",
		method: "get"
	},
	createInvestorYearlyPayout: {
		path: "/api/investor-yearly-payout",
		method: "post"
	},
	updateInvestorYearlyPayout: {
		path: "/api/investor-yearly-payout",
		method: "put"
	},
	generateInvestorYearlyPayout: {
		path: "/api/investor-yearly-payout/generate",
		method: "post"
	},
	getInvestorYearlyPayout: {
		path: "/api/investor-yearly-payout/:investorYearlyPayoutId",
		method: "get"
	},
	deleteInvestorYearlyPayout: {
		path: "/api/investor-yearly-payout/:investorYearlyPayoutId",
		method: "delete"
	},
	sendEmailInvestorYearlyPayout: {
		path: "/api/investor-yearly-payout/:investorYearlyPayoutId/send-email",
		method: "post"
	},
	getAnnualServiceChargeStatement: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId",
		method: "get"
	},
	patchAnnualServiceChargeStatement: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId",
		method: "patch"
	},
	deleteAnnualServiceChargeStatement: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId",
		method: "delete"
	},
	saveAnnualServiceChargeStatement: {
		path: "/api/annual-service-charge-statement",
		method: "post"
	},
	findAnnualServiceChargeStatements: {
		path: "/api/annual-service-charge-statement/list",
		method: "get"
	},
	getAnnualServiceChargeStatementsByTenancy: {
		path: "/api/annual-service-charge-statement/tenancy",
		method: "get"
	},
	getAnnualServiceChargeStatementsByRentalContract: {
		path: "/api/annual-service-charge-statement/rental-contract",
		method: "get"
	},
	getAnnualServiceChargeStatementsByEstate: {
		path: "/api/annual-service-charge-statement/estate/:estateId",
		method: "get"
	},
	createInvoiceFromBka: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId/invoice",
		method: "post"
	},
	generateBKADocument: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId/generate-document",
		method: "post"
	},
	copyAnnualServiceChargeStatement: {
		path: "/api/annual-service-charge-statement/:annualServiceChargeStatementId/copy",
		method: "post"
	},
	getBKAEmailInfo: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId/email-info",
		method: "get"
	},
	sendBKAEmail: {
		path: "/api/annual-service-charge-statement/:serviceChargeStatementId/send-email",
		method: "post"
	},
	getDashboardStatistics: {
		path: "/dashboard/statistics",
		method: "get"
	},
	settleUserConfirmation: {
		path: "/user-confirmations/:id",
		method: "post"
	},
	fetchUserConfirmations: {
		path: "/user-confirmations",
		method: "get"
	}
};
//#endregion
//#region src/propx/gen/clients/axios-class-client.ts
var PropxSdk = class {
	client;
	constructor(client) {
		this.client = client;
	}
	async axiosClient(config) {
		return this.client.request({ ...config }).catch((e) => {
			throw e;
		});
	}
	/**
	* @description Gets the default runtime config for propx frontend
	* @link /config
	*/
	async getConfig(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/config`,
			...options
		})).data;
	}
	/**
	* @description Resets the cache
	* @link /maintenance/reset-cache
	*/
	async resetCache(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/maintenance/reset-cache`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create or update renting lead
	* @link /api/renting-lead
	*/
	async saveRentingLead(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-lead`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get renting lead by id
	* @link /api/renting-lead/:rentingLeadId
	*/
	async getRentingLeadById({ rentingLeadId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting-lead/${rentingLeadId}`,
			...options
		})).data;
	}
	/**
	* @description Delete renting lead by id
	* @link /api/renting-lead/:rentingLeadId
	*/
	async deleteRentingLeadById({ rentingLeadId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/renting-lead/${rentingLeadId}`,
			...options
		})).data;
	}
	/**
	* @description Get list of renting leads
	* @link /api/renting-lead/list
	*/
	async findRentingLeads(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting-lead/list`,
			params,
			...options
		})).data;
	}
	/**
	* @description Convert renting leads to tenants
	* @link /api/renting-lead/convert
	*/
	async convertRentingLeads(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-lead/convert`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get renting listing
	* @link /api/renting-listing
	*/
	async getRentingListing(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting-listing`,
			params,
			...options
		})).data;
	}
	/**
	* @description Create renting listing
	* @link /api/renting-listing
	*/
	async createRentingListing(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-listing`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update renting listing
	* @link /api/renting-listing/:rentingListingId
	*/
	async updateRentingListing({ rentingListingId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/renting-listing/${rentingListingId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete unpublished renting listing
	* @link /api/renting-listing/:rentingListingId
	*/
	async deleteUnpublishedRentingListing({ rentingListingId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/renting-listing/${rentingListingId}`,
			...options
		})).data;
	}
	/**
	* @description Delete renting listing
	* @link /api/renting-listing/:rentingListingId/provider/:provider
	*/
	async deleteRentingListing({ rentingListingId, provider }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/renting-listing/${rentingListingId}/provider/${provider}`,
			...options
		})).data;
	}
	/**
	* @description Pre-publish/publish/un-publish renting listing
	* @link /api/renting-listing/:rentingListingId/providers/:provider/actions/:action
	*/
	async invokeRentingListingAction({ rentingListingId, provider, action }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-listing/${rentingListingId}/providers/${provider}/actions/${action}`,
			...options
		})).data;
	}
	/**
	* @description Add attachments to renting listing
	* @link /api/renting-listing/:rentingLeadId/attachments
	*/
	async addAttachments({ rentingLeadId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-listing/${rentingLeadId}/attachments`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get renting listing attachments
	* @link /api/renting-listing/:rentingListingId/attachments
	*/
	async getRentingListingAttachments({ rentingListingId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting-listing/${rentingListingId}/attachments`,
			...options
		})).data;
	}
	/**
	* @description Get renting listing attachments order
	* @link /api/renting-listing/:rentingListingId/attachments-order
	*/
	async getRentingListingAttachmentsOrder({ rentingListingId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting-listing/${rentingListingId}/attachments-order`,
			...options
		})).data;
	}
	/**
	* @description Update renting listing attachments order
	* @link /api/renting-listing/:rentingListingId/attachments-order
	*/
	async updateRentingListingAttachmentsOrder({ rentingListingId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/renting-listing/${rentingListingId}/attachments-order`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update renting listing attachment
	* @link /api/renting-listing/:rentingListingId/attachments/:attachmentId
	*/
	async updateRentingListingAttachment({ rentingListingId, attachmentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/renting-listing/${rentingListingId}/attachments/${attachmentId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete renting listing attachment
	* @link /api/renting-listing/:rentingListingId/attachments/:attachmentId
	*/
	async deleteRentingListingAttachment({ rentingListingId, attachmentId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/renting-listing/${rentingListingId}/attachments/${attachmentId}`,
			...options
		})).data;
	}
	/**
	* @description Export renting listing as open immo
	* @link /api/renting-listing/:rentingListingId/export
	*/
	async exportRentingListingAsOpenImmo({ rentingListingId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting-listing/${rentingListingId}/export`,
			...options
		})).data;
	}
	/**
	* @description Get renting details of estate
	* @link /api/renting/estate/:estateId
	*/
	async getRentingDetailsOfEstate({ estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/renting/estate/${estateId}`,
			...options
		})).data;
	}
	/**
	* @description Create renting process
	* @link /api/renting-process
	*/
	async createRentingProcess(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-process`,
			data,
			...options
		})).data;
	}
	/**
	* @description Sync rentable unit process states for a renting process
	* @link /api/renting-process/sync-rentable-unit-states
	*/
	async syncRentableUnitProcessStates(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/renting-process/sync-rentable-unit-states`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete renting process by ID
	* @link /api/renting-process/:rentingProcessId
	*/
	async deleteRentingProcess({ rentingProcessId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/renting-process/${rentingProcessId}`,
			...options
		})).data;
	}
	/**
	* @description Create rentable unit
	* @link /api/estate-rentable-unit
	*/
	async createEstateRentableUnit(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/estate-rentable-unit`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create rentable unit
	* @link /api/room-rentable-unit
	*/
	async createRoomRentableUnit(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/room-rentable-unit`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create rentable unit
	* @link /api/parking-rentable-unit
	*/
	async createParkingRentableUnit(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/parking-rentable-unit`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update a rentable unit
	* @link /api/rentable-unit
	*/
	async updateRentableUnit(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/rentable-unit`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find rentable units by estateId or estarCoreUnitId
	* @link /api/rentable-unit
	*/
	async findRentableUnits(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rentable-unit`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update multiple rentable units EstarCore ids
	* @link /api/rentable-units/estar-core-id
	*/
	async updateRentableUnitsEstarCoreId(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/rentable-units/estar-core-id`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get rentable unit by id
	* @link /api/rentable-unit/:rentableUnitId
	*/
	async getRentableUnitById({ rentableUnitId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rentable-unit/${rentableUnitId}`,
			...options
		})).data;
	}
	/**
	* @description Delete rentable unit by id
	* @link /api/rentable-unit/:rentableUnitId
	*/
	async deleteRentableUnitById({ rentableUnitId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/rentable-unit/${rentableUnitId}`,
			...options
		})).data;
	}
	/**
	* @description Find rentable units by renting process ID
	* @link /api/rentable-unit/by-renting-process/:rentingProcessId
	*/
	async findRentableUnitsByRentingProcess({ rentingProcessId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rentable-unit/by-renting-process/${rentingProcessId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get paginated list of rentable units with search and filtering capabilities
	* @link /api/rentable-units/list
	*/
	async getRentableUnitsList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rentable-units/list`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get rentable unit by one key. If more than one key is present priority follows: rentableUnitId, estateId, estateElementId, parkingSpaceId
	* @link /api/rentable-unit/one
	*/
	async getRentableUnit(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rentable-unit/one`,
			params,
			...options
		})).data;
	}
	/**
	* @description Delete estate rentable unit by estateId
	* @link /api/estate-rentable-unit/:estateId
	*/
	async deleteEstateRentableUnit({ estateId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/estate-rentable-unit/${estateId}`,
			...options
		})).data;
	}
	/**
	* @description Delete room rentable unit by estateElementId
	* @link /api/room-rentable-unit/:estateElementId
	*/
	async deleteRoomRentableUnit({ estateElementId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/room-rentable-unit/${estateElementId}`,
			...options
		})).data;
	}
	/**
	* @description Delete parking rentable unit by parkingSpaceId
	* @link /api/parking-rentable-unit/:parkingSpaceId
	*/
	async deleteParkingRentableUnit({ parkingSpaceId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/parking-rentable-unit/${parkingSpaceId}`,
			...options
		})).data;
	}
	/**
	* @description Create rentable unit process
	* @link /api/rentable-unit-process
	*/
	async createRentableUnitProcess(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rentable-unit-process`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get entity setting by entity ID
	* @link /api/entity-setting
	*/
	async getEntitySetting(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/entity-setting`,
			params,
			...options
		})).data;
	}
	/**
	* @description Upsert entity setting
	* @link /api/entity-setting
	*/
	async upsertEntitySetting(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/entity-setting`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get estate details for investor portal
	* @link /api/estate/:estateId/details
	*/
	async getEstateDetails({ estateId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/estate/${estateId}/details`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get unit statistics (tenancies, investors, defects, notes, documents)
	* @link /api/estate/:estateId/statistics
	*/
	async getUnitStatistics({ estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/estate/${estateId}/statistics`,
			...options
		})).data;
	}
	/**
	* @description Get HOA fee at date by estate ID
	* @link /api/hoa-fees/active-at-date
	*/
	async getHoaFeeAtDate(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/hoa-fees/active-at-date`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get HOA fee by ID
	* @link /api/hoa-fees/:hoaFeeId
	*/
	async getHoaFee({ hoaFeeId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/hoa-fees/${hoaFeeId}`,
			...options
		})).data;
	}
	/**
	* @description Delete HOA fee by ID
	* @link /api/hoa-fees/:hoaFeeId
	*/
	async deleteHoaFee({ hoaFeeId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/hoa-fees/${hoaFeeId}`,
			...options
		})).data;
	}
	/**
	* @description Get HOA fees by estate ID
	* @link /api/estates/:estateId/hoa-fees
	*/
	async getHoaFeesByEstate({ estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/estates/${estateId}/hoa-fees`,
			...options
		})).data;
	}
	/**
	* @description Create or update HOA fee
	* @link /api/hoa-fees
	*/
	async upsertHoaFee(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/hoa-fees`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find investor infos with pagination support
	* @link /api/investor-infos
	*/
	async findInvestorInfos(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-infos`,
			params,
			...options
		})).data;
	}
	/**
	* @description Create investor info
	* @link /api/investor-infos
	*/
	async createInvestorInfo(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-infos`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get the active investor info for a given estate or all active investor infos if estateId is not specified
	* @link /api/investor-infos/active
	*/
	async getActiveInvestorInfos(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-infos/active`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get investor info data by entity ID
	* @link /api/investor-infos/:investorInfoId
	*/
	async getInvestorInfo({ investorInfoId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-infos/${investorInfoId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update investor info
	* @link /api/investor-infos/:investorInfoId
	*/
	async updateInvestorInfo({ investorInfoId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/investor-infos/${investorInfoId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Initialize investor info
	* @link /api/investor-infos/initialize
	*/
	async initializeInvestorInfo(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-infos/initialize`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get theoretical monthly investor shares breakdown
	* @link /api/investor-infos/:investorInfoId/theoretical-payout-breakdown
	*/
	async getTheoreticalPayoutBreakdown({ investorInfoId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-infos/${investorInfoId}/theoretical-payout-breakdown`,
			...options
		})).data;
	}
	/**
	* @description Get liquidity reserve build up sample
	* @link /api/investor-infos/:investorInfoId/liquidity-reserve-sample
	*/
	async getLiquidityReserveBuildUpSample({ investorInfoId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-infos/${investorInfoId}/liquidity-reserve-sample`,
			...options
		})).data;
	}
	/**
	* @description Update investor info start date and special deal
	* @link /api/investor-infos/start-date-and-special-deal
	*/
	async updateInvestorInfoStartDateAndSpecialDeal(data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/investor-infos/start-date-and-special-deal`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get investor data for investor portal
	* @link /api/investor-data
	*/
	async getInvestorData(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-data`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get investor portal access block state for an investor info
	* @link /api/investor-infos/:investorInfoId/portal-access
	*/
	async getInvestorPortalAccess({ investorInfoId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-infos/${investorInfoId}/portal-access`,
			...options
		})).data;
	}
	/**
	* @description Block or unblock investor portal access for invited owners of an investor info
	* @link /api/investor-infos/:investorInfoId/portal-access
	*/
	async setInvestorPortalAccess({ investorInfoId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-infos/${investorInfoId}/portal-access`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get active rents amounts
	* @link /api/rents/active-amounts
	*/
	async getActiveRentsAmounts(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rents/active-amounts`,
			...options
		})).data;
	}
	/**
	* @description Get rent by ID
	* @link /api/rents/:rentId
	*/
	async getRent({ rentId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rents/${rentId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Delete rent by ID
	* @link /api/rents/:rentId
	*/
	async deleteRent({ rentId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/rents/${rentId}`,
			...options
		})).data;
	}
	/**
	* @description Update rent
	* @link /api/rents/:rentId
	*/
	async updateRent({ rentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/rents/${rentId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create rent
	* @link /api/rents
	*/
	async createRent(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rents`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find rents
	* @link /api/rents
	*/
	async findRents(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rents`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get all CPI values
	* @link /api/rents/cpi-values
	*/
	async getCpiValuesList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rents/cpi-values`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get rents for MFH building
	* @link /api/rents/mfh/:mfhId
	*/
	async getMfhLatestRents({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rents/mfh/${mfhId}`,
			...options
		})).data;
	}
	/**
	* @description Get many estates active rent tenancies
	* @link /api/rent-tenancies/estates
	*/
	async getManyEstateActiveRentTenancies(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/estates`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get currently active rent tenancies
	* @link /api/rent-tenancies/active
	*/
	async getActiveRentTenancies(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/active`,
			...options
		})).data;
	}
	/**
	* @description Get tenancies list with comprehensive details including contracts, tenants, rents, rentable units, and estates. Requires lineOfBusiness filter (RETAIL or INSTI)
	* @link /api/tenancies
	*/
	async getTenanciesList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/tenancies`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get rent tenancy by entity ID
	* @link /api/rent-tenancies/:rentTenancyId
	*/
	async getRentTenancy({ rentTenancyId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/${rentTenancyId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Delete rent tenancy by entity ID
	* @link /api/rent-tenancies/:rentTenancyId
	*/
	async deleteRentTenancy({ rentTenancyId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/rent-tenancies/${rentTenancyId}`,
			...options
		})).data;
	}
	/**
	* @description Update rent tenancy
	* @link /api/rent-tenancies/:rentTenancyId
	*/
	async updateRentTenancy({ rentTenancyId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/rent-tenancies/${rentTenancyId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Patches one rent tenancy
	* @link /api/rent-tenancies/:rentTenancyId
	*/
	async patchRentTenancy({ rentTenancyId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/rent-tenancies/${rentTenancyId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find rent tenancy by rent ID
	* @link /api/rent-tenancies/by-rent/:rentId
	*/
	async findRentTenancyByRent({ rentId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/by-rent/${rentId}`,
			...options
		})).data;
	}
	/**
	* @description Get estate rent tenancies
	* @link /api/rent-tenancies/estate/:estateId
	*/
	async getEstateRentTenancies({ estateId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/estate/${estateId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Create rent tenancy
	* @link /api/rent-tenancies
	*/
	async saveRentTenancy(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rent-tenancies`,
			data,
			...options
		})).data;
	}
	/**
	* @description Finds rent tenancies matching the provided query
	* @link /api/rent-tenancies
	*/
	async findRentTenancies(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies`,
			params,
			...options
		})).data;
	}
	/**
	* @description Recalculate rent balance for one rent tenancy
	* @link /api/rent-tenancies/re-calculate-rent-balance
	*/
	async recalculateRentBalance(params, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rent-tenancies/re-calculate-rent-balance`,
			params,
			...options
		})).data;
	}
	/**
	* @description Recalculate legact rent balance for one rent tenancy
	* @link /api/rent-tenancies/:rentTenancyId/legacy-rent-balance
	*/
	async recalculateLegacyRentBalance({ rentTenancyId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/${rentTenancyId}/legacy-rent-balance`,
			...options
		})).data;
	}
	/**
	* @description Update dunning status
	* @link /api/rent-tenancies/:rentTenancyId/dunning-status
	*/
	async updateDunningStatus({ rentTenancyId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rent-tenancies/${rentTenancyId}/dunning-status`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns whether the onboarding of the given tenancy is valid or not
	* @link /api/rent-tenancies/:rentTenancyId/onboarding
	*/
	async isOnboardingValid({ rentTenancyId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/${rentTenancyId}/onboarding`,
			...options
		})).data;
	}
	/**
	* @description Returns whether the onboarding of the given tenancy is valid or not
	* @link /api/rent-tenancies/:rentTenancyId/termination
	*/
	async isTerminationComplete({ rentTenancyId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/${rentTenancyId}/termination`,
			...options
		})).data;
	}
	/**
	* @description Finds tenants for a given estate (only current/active tenants by default)
	* @link /api/rent-tenancies/tenants/:estateId
	*/
	async findTenantsDeprecated({ estateId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/tenants/${estateId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Finds tenants for a given estates (only current/active tenants by default)
	* @link /api/rent-tenancies/tenants
	*/
	async findTenants(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rent-tenancies/tenants`,
			params,
			...options
		})).data;
	}
	/**
	* @description Find rental contracts
	* @link /api/rental-contracts
	*/
	async findRentalContracts(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rental-contracts`,
			params,
			...options
		})).data;
	}
	/**
	* @description Upsert rental contract
	* @link /api/rental-contracts
	*/
	async upsertRentalContract(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contracts`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get rental contract by ID
	* @link /api/rental-contracts/:rentalContractId
	*/
	async getRentalContract({ rentalContractId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rental-contracts/${rentalContractId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Patch rental contract
	* @link /api/rental-contracts/:rentalContractId
	*/
	async patchRentalContract({ rentalContractId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/rental-contracts/${rentalContractId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create rents from rental contract
	* @link /api/rental-contracts/create-rents
	*/
	async createRentsFromRentalContract(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contracts/create-rents`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update rental contracts estar core IDs
	* @link /api/rental-contracts/update-estar-core-id
	*/
	async updateRentalContractsEstarCoreId(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contracts/update-estar-core-id`,
			data,
			...options
		})).data;
	}
	/**
	* @description Recalculates amount paid for rent deposit from transactions
	* @link /api/rental-contracts/:rentalContractId/recalculate-paid-deposit
	*/
	async recalculatePaidDeposit({ rentalContractId }, params, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/rental-contracts/${rentalContractId}/recalculate-paid-deposit`,
			params,
			...options
		})).data;
	}
	/**
	* @description Find rental contracts by investorInfoId
	* @link /api/rental-contracts/by-investor/:investorInfoId
	*/
	async findMatchingRentalContractsByInvestor({ investorInfoId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rental-contracts/by-investor/${investorInfoId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update rental contract status
	* @link /api/rental-contracts/:rentalContractId/status
	*/
	async updateRentalContractStatus({ rentalContractId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contracts/${rentalContractId}/status`,
			data,
			...options
		})).data;
	}
	/**
	* @description Add a rentable unit to a rental contract
	* @link /api/rental-contracts/:rentalContractId/units
	*/
	async addRentalContractUnitOld({ rentalContractId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contracts/${rentalContractId}/units`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find available drafts for rental contract
	* @link /api/rental-contracts/find-available-drafts
	*/
	async findAvailableDraftsForRentalContract(params, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contracts/find-available-drafts`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get active rental contracts, optionally filtered by type
	* @link /api/rental-contracts/active
	*/
	async getActiveRentalContracts(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rental-contracts/active`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get regular (non sublease) active rental contract for a given rentable unit
	* @link /api/rental-contracts/regular-active
	*/
	async getRegularActiveRentalContract(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/rental-contracts/regular-active`,
			params,
			...options
		})).data;
	}
	/**
	* @description Add a rentable unit to a rental contract
	* @link /api/rental-contract-units
	*/
	async addRentalContractUnit(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/rental-contract-units`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get all tenants
	* @link /api/tenants
	*/
	async getTenants(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/tenants`,
			...options
		})).data;
	}
	/**
	* @description Update tenant information
	* @link /api/tenants
	*/
	async updateTenantInformation(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/tenants`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find many monthly investor shares
	* @link /api/investor-share
	*/
	async findMonthlyInvestorShares(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-share`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get min/max dates of across investor shares data
	* @link /api/investor-share/min-max-date
	*/
	async getMinMaxDateOfMonthlyInvestorShare(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-share/min-max-date`,
			...options
		})).data;
	}
	/**
	* @description Get investor shares by ID
	* @link /api/investor-share/:monthlyInvestorShareId
	*/
	async getMonthlyInvestorShareById({ monthlyInvestorShareId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-share/${monthlyInvestorShareId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update monthly investor share operations
	* @link /api/monthly-investor-shares/:monthlyInvestorShareId/operations
	*/
	async updateMonthlyInvestorShareOperations({ monthlyInvestorShareId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/monthly-investor-shares/${monthlyInvestorShareId}/operations`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update monthly investor share
	* @link /api/monthly-investor-shares/:monthlyInvestorShareId
	*/
	async updateMonthlyInvestorShare({ monthlyInvestorShareId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/monthly-investor-shares/${monthlyInvestorShareId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Export SEV payment
	* @link /api/investor-share/export-monthly-sev-payment
	*/
	async exportMonthlySevPayment(data, params, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-share/export-monthly-sev-payment`,
			params,
			data,
			...options
		})).data;
	}
	/**
	* @description Generate and send all checked monthly investor shares for the provided month
	* @link /api/investor-share/generate-and-send
	*/
	async generateAndSendMonthlyInvestorShares(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-share/generate-and-send`,
			data,
			...options
		})).data;
	}
	/**
	* @description Calculate monthly investor share
	* @link /api/investor-share/calculate
	*/
	async calculateMonthlyInvestorShare(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-share/calculate`,
			data,
			...options
		})).data;
	}
	/** @link /admin/investor-share/generate-investor-payout-document */
	async generateInvestorPayoutDocument(options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/admin/investor-share/generate-investor-payout-document`,
			...options
		})).data;
	}
	/** @link /admin/investor-share/send-investor-payout-document */
	async sendInvestorPayoutDocument(options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/admin/investor-share/send-investor-payout-document`,
			...options
		})).data;
	}
	/**
	* @description Find investor share IDs for a given month
	* @link /api/investor-share/ids
	*/
	async findInvestorShareIds(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-share/ids`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get monthly investor share statistics
	* @link /api/investor-share/stats
	*/
	async getMonthlyInvestorShareStats(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-share/stats`,
			params,
			...options
		})).data;
	}
	/**
	* @description Generate investor payout statement document
	* @link /api/investor-share/:monthlyInvestorShareId/generate-payout-statement
	*/
	async generateInvestorPayoutStatement({ monthlyInvestorShareId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-share/${monthlyInvestorShareId}/generate-payout-statement`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get monthly rent guarantee date range
	* @link /api/monthly-rent-guarantees/date-range
	*/
	async getMonthlyRentGuaranteeRange(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/monthly-rent-guarantees/date-range`,
			...options
		})).data;
	}
	/**
	* @description Get monthly rent guarantee by ID
	* @link /api/monthly-rent-guarantees/:monthlyRentGuaranteeId
	*/
	async getMonthlyRentGuarantee({ monthlyRentGuaranteeId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/monthly-rent-guarantees/${monthlyRentGuaranteeId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update monthly rent guarantee
	* @link /api/monthly-rent-guarantees/:monthlyRentGuaranteeId
	*/
	async updateMonthlyRentGuarantee({ monthlyRentGuaranteeId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/monthly-rent-guarantees/${monthlyRentGuaranteeId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Generate rent guarantee in batch
	* @link /api/monthly-rent-guarantees/generate
	*/
	async rentGuaranteeBatchGenerate(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/monthly-rent-guarantees/generate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find monthly rent guarantees
	* @link /api/monthly-rent-guarantees
	*/
	async findMonthlyRentGuarantees(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/monthly-rent-guarantees`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update a rent arrear notice
	* @link /api/rent-arrear-notice
	*/
	async updateArrearNotice(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/rent-arrear-notice`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete a rent arrear notice
	* @link /api/rent-arrear-notice/:rentArrearNoticeId
	*/
	async deleteArrearNotice({ rentArrearNoticeId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/rent-arrear-notice/${rentArrearNoticeId}`,
			...options
		})).data;
	}
	/**
	* @description Generate arrear notices
	* @link /rent-arrear-notices/generate
	*/
	async generateArrearNotices(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/rent-arrear-notices/generate`,
			data,
			...options
		})).data;
	}
	/** @link /stats */
	async stats(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/stats`,
			params,
			...options
		})).data;
	}
	/**
	* @description Schedule contact invitation sending
	* @link /api/contacts/:contactId/invitation-request
	*/
	async sendContactInvitation({ contactId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/contacts/${contactId}/invitation-request`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get contacts Invitation Progress (Registered, Invited)
	* @link /api/contacts/invitation-progress
	*/
	async getPortalInvitationProgress(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/contacts/invitation-progress`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get registered tenants at Livings
	* @link /api/registered-tenants
	*/
	async getRegisteredTenants(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/registered-tenants`,
			...options
		})).data;
	}
	/**
	* @description Update contact email
	* @link /api/contacts/:contactId/update-email
	*/
	async updateContactEmail({ contactId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/contacts/${contactId}/update-email`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find investorAnnualSettlements
	* @link /api/investor-annual-settlement
	*/
	async findInvestorAnnualSettlements(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-annual-settlement`,
			params,
			...options
		})).data;
	}
	/**
	* @description Creates a new investorAnnualSettlement
	* @link /api/investor-annual-settlement
	*/
	async createInvestorAnnualSettlement(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-annual-settlement`,
			data,
			...options
		})).data;
	}
	/**
	* @description Updates a investorAnnualSettlement
	* @link /api/investor-annual-settlement
	*/
	async updateInvestorAnnualSettlement(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/investor-annual-settlement`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes a investorAnnualSettlement
	* @link /api/investor-annual-settlement/:investorAnnualSettlementId
	*/
	async deleteInvestorAnnualSettlement({ investorAnnualSettlementId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/investor-annual-settlement/${investorAnnualSettlementId}`,
			...options
		})).data;
	}
	/**
	* @description Find investorYearlyPayouts
	* @link /api/investor-yearly-payout
	*/
	async findInvestorYearlyPayouts(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-yearly-payout`,
			params,
			...options
		})).data;
	}
	/**
	* @description Creates a new investorYearlyPayout
	* @link /api/investor-yearly-payout
	*/
	async createInvestorYearlyPayout(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-yearly-payout`,
			data,
			...options
		})).data;
	}
	/**
	* @description Updates a investorYearlyPayout
	* @link /api/investor-yearly-payout
	*/
	async updateInvestorYearlyPayout(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/investor-yearly-payout`,
			data,
			...options
		})).data;
	}
	/**
	* @description Generates a new investorYearlyPayout
	* @link /api/investor-yearly-payout/generate
	*/
	async generateInvestorYearlyPayout(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-yearly-payout/generate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Gets a investor yearly payout
	* @link /api/investor-yearly-payout/:investorYearlyPayoutId
	*/
	async getInvestorYearlyPayout({ investorYearlyPayoutId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/investor-yearly-payout/${investorYearlyPayoutId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Deletes a investorYearlyPayout
	* @link /api/investor-yearly-payout/:investorYearlyPayoutId
	*/
	async deleteInvestorYearlyPayout({ investorYearlyPayoutId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/investor-yearly-payout/${investorYearlyPayoutId}`,
			...options
		})).data;
	}
	/**
	* @description Send Investor Yearly Payout to investor by email
	* @link /api/investor-yearly-payout/:investorYearlyPayoutId/send-email
	*/
	async sendEmailInvestorYearlyPayout({ investorYearlyPayoutId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/investor-yearly-payout/${investorYearlyPayoutId}/send-email`,
			...options
		})).data;
	}
	/**
	* @description Get a Nebenkostenabrechnung
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId
	*/
	async getAnnualServiceChargeStatement({ serviceChargeStatementId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Patch specific fields of a Nebenkostenabrechnung
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId
	*/
	async patchAnnualServiceChargeStatement({ serviceChargeStatementId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete Nebenkostenabrechnung
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId
	*/
	async deleteAnnualServiceChargeStatement({ serviceChargeStatementId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}`,
			...options
		})).data;
	}
	/**
	* @description Save a Nebenkostenabrechnung
	* @link /api/annual-service-charge-statement
	*/
	async saveAnnualServiceChargeStatement(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/annual-service-charge-statement`,
			data,
			...options
		})).data;
	}
	/**
	* @description Find Annual Service Charge Statements
	* @link /api/annual-service-charge-statement/list
	*/
	async findAnnualServiceChargeStatements(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/annual-service-charge-statement/list`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Annual Service Charges by Tenancy
	* @link /api/annual-service-charge-statement/tenancy
	*/
	async getAnnualServiceChargeStatementsByTenancy(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/annual-service-charge-statement/tenancy`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Annual Service Charges by Rental Contract
	* @link /api/annual-service-charge-statement/rental-contract
	*/
	async getAnnualServiceChargeStatementsByRentalContract(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/annual-service-charge-statement/rental-contract`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Annual Service Charge Statements by Estate
	* @link /api/annual-service-charge-statement/estate/:estateId
	*/
	async getAnnualServiceChargeStatementsByEstate({ estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/annual-service-charge-statement/estate/${estateId}`,
			...options
		})).data;
	}
	/**
	* @description Create Invoice from BKA
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId/invoice
	*/
	async createInvoiceFromBka({ serviceChargeStatementId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/invoice`,
			data,
			...options
		})).data;
	}
	/**
	* @description Generate a BKA document by statement and type
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId/generate-document
	*/
	async generateBkaDocument({ serviceChargeStatementId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/generate-document`,
			data,
			...options
		})).data;
	}
	/**
	* @description Copy an existing Annual Service Charge Statement
	* @link /api/annual-service-charge-statement/:annualServiceChargeStatementId/copy
	*/
	async copyAnnualServiceChargeStatement({ annualServiceChargeStatementId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/annual-service-charge-statement/${annualServiceChargeStatementId}/copy`,
			...options
		})).data;
	}
	/**
	* @description Get BKA email information including tenants, investors, and email content
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId/email-info
	*/
	async getBkaEmailInfo({ serviceChargeStatementId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/email-info`,
			...options
		})).data;
	}
	/**
	* @description Send BKA emails to tenants and investors
	* @link /api/annual-service-charge-statement/:serviceChargeStatementId/send-email
	*/
	async sendBkaEmail({ serviceChargeStatementId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/annual-service-charge-statement/${serviceChargeStatementId}/send-email`,
			data,
			...options
		})).data;
	}
	/** @link /dashboard/statistics */
	async getDashboardStatistics(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/dashboard/statistics`,
			...options
		})).data;
	}
	/**
	* @description Settles a user-confirmation (either approved or rejected)
	* @link /user-confirmations/:id
	*/
	async settleUserConfirmation({ id }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-confirmations/${id}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Fetches user-confirmations, which are not yet approved/rejected
	* @link /user-confirmations
	*/
	async fetchUserConfirmations(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/user-confirmations`,
			...options
		})).data;
	}
};
//#endregion
export { ActiveRentTenancyTenancyType, AnnualServiceChargeStatementStatusEnum, AnnualServiceChargeStatementsSelect, AnnualServiceChargeStatementsSelect2, BankAccountExpandOptsSelect, BankAccountExpandOptsSelect2, BarcodeType, BarcodeType10, BarcodeType11, BarcodeType12, BarcodeType13, BarcodeType14, BarcodeType15, BarcodeType16, BarcodeType17, BarcodeType18, BarcodeType19, BarcodeType2, BarcodeType3, BarcodeType4, BarcodeType5, BarcodeType6, BarcodeType7, BarcodeType8, BarcodeType9, BarcodeTypeEnum, BarcodeTypeEnum10, BarcodeTypeEnum11, BarcodeTypeEnum12, BarcodeTypeEnum13, BarcodeTypeEnum14, BarcodeTypeEnum15, BarcodeTypeEnum16, BarcodeTypeEnum17, BarcodeTypeEnum18, BarcodeTypeEnum19, BarcodeTypeEnum2, BarcodeTypeEnum3, BarcodeTypeEnum4, BarcodeTypeEnum5, BarcodeTypeEnum6, BarcodeTypeEnum7, BarcodeTypeEnum8, BarcodeTypeEnum9, BarcodesType, BarcodesType10, BarcodesType11, BarcodesType12, BarcodesType13, BarcodesType14, BarcodesType15, BarcodesType16, BarcodesType17, BarcodesType18, BarcodesType19, BarcodesType2, BarcodesType20, BarcodesType21, BarcodesType22, BarcodesType23, BarcodesType24, BarcodesType25, BarcodesType26, BarcodesType27, BarcodesType28, BarcodesType29, BarcodesType3, BarcodesType30, BarcodesType31, BarcodesType32, BarcodesType33, BarcodesType34, BarcodesType35, BarcodesType36, BarcodesType37, BarcodesType38, BarcodesType39, BarcodesType4, BarcodesType40, BarcodesType41, BarcodesType42, BarcodesType43, BarcodesType44, BarcodesType45, BarcodesType46, BarcodesType47, BarcodesType48, BarcodesType49, BarcodesType5, BarcodesType50, BarcodesType51, BarcodesType52, BarcodesType53, BarcodesType54, BarcodesType55, BarcodesType56, BarcodesType57, BarcodesType6, BarcodesType7, BarcodesType8, BarcodesType9, BaseBankAccountBankAccountType, BaseBankAccountBankAccountType2, BaseBankAccountBankAccountType3, BaseBankAccountBankAccountType4, BaseBankAccountBankAccountType5, BaseBankAccountBankAccountType6, BaseBankAccountBankAccountType7, BaseBankAccountBankAccountType8, BaseBankAccountBankAccountType9, BaseBankTransactionBankTransactionState, BaseBankTransactionBankTransactionState2, BaseBankTransactionBankTransactionState3, BaseBankTransactionBankTransactionState4, BaseBankTransactionBankTransactionState5, BaseBankTransactionCategory, BaseBankTransactionCategory10, BaseBankTransactionCategory11, BaseBankTransactionCategory2, BaseBankTransactionCategory3, BaseBankTransactionCategory4, BaseBankTransactionCategory5, BaseBankTransactionCategory6, BaseBankTransactionCategory7, BaseBankTransactionCategory8, BaseBankTransactionCategory9, BaseBankTransactionCategoryType, BaseBankTransactionCategoryType10, BaseBankTransactionCategoryType11, BaseBankTransactionCategoryType12, BaseBankTransactionCategoryType13, BaseBankTransactionCategoryType14, BaseBankTransactionCategoryType15, BaseBankTransactionCategoryType16, BaseBankTransactionCategoryType17, BaseBankTransactionCategoryType18, BaseBankTransactionCategoryType19, BaseBankTransactionCategoryType2, BaseBankTransactionCategoryType20, BaseBankTransactionCategoryType21, BaseBankTransactionCategoryType22, BaseBankTransactionCategoryType23, BaseBankTransactionCategoryType24, BaseBankTransactionCategoryType25, BaseBankTransactionCategoryType26, BaseBankTransactionCategoryType27, BaseBankTransactionCategoryType28, BaseBankTransactionCategoryType29, BaseBankTransactionCategoryType3, BaseBankTransactionCategoryType30, BaseBankTransactionCategoryType31, BaseBankTransactionCategoryType32, BaseBankTransactionCategoryType33, BaseBankTransactionCategoryType34, BaseBankTransactionCategoryType35, BaseBankTransactionCategoryType4, BaseBankTransactionCategoryType5, BaseBankTransactionCategoryType6, BaseBankTransactionCategoryType7, BaseBankTransactionCategoryType8, BaseBankTransactionCategoryType9, BaseBankTransactionTransactionSource, BaseBankTransactionTransactionSource2, BaseCompanySellingPartner, BaseCompanyType, BaseCompanyType10, BaseCompanyType11, BaseCompanyType12, BaseCompanyType13, BaseCompanyType14, BaseCompanyType15, BaseCompanyType16, BaseCompanyType17, BaseCompanyType18, BaseCompanyType19, BaseCompanyType2, BaseCompanyType20, BaseCompanyType21, BaseCompanyType22, BaseCompanyType23, BaseCompanyType24, BaseCompanyType25, BaseCompanyType26, BaseCompanyType27, BaseCompanyType28, BaseCompanyType29, BaseCompanyType3, BaseCompanyType30, BaseCompanyType31, BaseCompanyType32, BaseCompanyType33, BaseCompanyType34, BaseCompanyType35, BaseCompanyType36, BaseCompanyType37, BaseCompanyType38, BaseCompanyType39, BaseCompanyType4, BaseCompanyType40, BaseCompanyType5, BaseCompanyType6, BaseCompanyType7, BaseCompanyType8, BaseCompanyType9, BaseContactPersonContactType, BaseEstateEstateType, BaseInvoiceSchemaCurrency, BaseInvoiceSchemaDebtAllocation, BaseInvoiceSchemaInvoiceType, BaseInvoiceSchemaSource, BaseInvoiceSchemaState, BaseInvoiceSchemaVatClass, BaseMonthlyInvestorShareExcludedReason, BaseMonthlyInvestorShareStatus, BaseParkingSpaceParkingSpaceType, BaseProcessProcessType, BaseProcessProcessType10, BaseProcessProcessType2, BaseProcessProcessType3, BaseProcessProcessType4, BaseProcessProcessType5, BaseProcessProcessType6, BaseProcessProcessType7, BaseProcessProcessType8, BaseProcessProcessType9, BaseRentableUnitProcessProcessType, BaseRentingLeadLeadImpression, BaseRentingLeadRentingLeadStatus, BaseReviewProcessReviewProcessState, BaseTenantManagementProcessProcessType, CompanyEmploymentRelationCompanyRole, CompanySelect, CompanySelect2, CondoSalesConditionEnum, ContactPersonContactType, ContactSelect, ContactSelect2, CostTypes, CreateRentingProcessMutationRequestProcessState, Currency, DataExcludedReason, DataStatus, DebtAllocation, DocumentCategory, DocumentType, EstateAttributesFloorLocation, EstateAttributesHeatingType, EstateElementElementRenovationStage, EstateElementElementType, EstateElementElementTypeName, EstateEstateType, EstateSelect, EstateSelect2, FindAnnualServiceChargeStatementsQueryParamsOrder, FindInvestorInfosQueryParamsHoaFeeStatus, FindInvestorInfosQueryParamsHoaFeeStatus2, FindInvestorInfosQueryParamsRepaymentSubsidyStatus, FindInvestorInfosQueryParamsRepaymentSubsidyStatus2, FindInvestorInfosQueryParamsSevFeeStatus, FindInvestorInfosQueryParamsSevFeeStatus2, FindInvestorInfosQueryParamsSevStatus, FindInvestorInfosQueryParamsSevStatus2, FindInvestorInfosQueryParamsStatus, FindInvestorInfosQueryParamsStatus2, FindRentingLeadsQueryParamsRentingLeadStatus, FriIncreaseAmountTypeEnum, GeneralLedgerStatementExpandOptsSelect, GeneralLedgerStatementExpandOptsSelect2, GetActiveRentalContractsQueryParamsTypes, GetPortalInvitationProgressQueryParamsPortalName, GetPortalInvitationProgressQueryParamsPortalName2, GetRentableUnitsListQueryParamsStatus, GetRentableUnitsListQueryParamsType, GetTenanciesListQueryParamsLineOfBusiness, GetTenanciesListQueryParamsLineOfBusiness2, GetTenanciesListQueryParamsOrder, GetTenanciesListQueryParamsOrder2, GetTenanciesListQueryParamsOrder3, GetTenanciesListQueryParamsOrder4, GetTenanciesListQueryParamsRentIncreaseType, GetTenanciesListQueryParamsRentIncreaseType2, GetTenanciesListQueryParamsRentIncreaseType3, GetTenanciesListQueryParamsRentIncreaseType4, GetTenanciesListQueryParamsSellingState, GetTenanciesListQueryParamsSellingState10, GetTenanciesListQueryParamsSellingState11, GetTenanciesListQueryParamsSellingState12, GetTenanciesListQueryParamsSellingState13, GetTenanciesListQueryParamsSellingState14, GetTenanciesListQueryParamsSellingState15, GetTenanciesListQueryParamsSellingState16, GetTenanciesListQueryParamsSellingState17, GetTenanciesListQueryParamsSellingState18, GetTenanciesListQueryParamsSellingState2, GetTenanciesListQueryParamsSellingState3, GetTenanciesListQueryParamsSellingState4, GetTenanciesListQueryParamsSellingState5, GetTenanciesListQueryParamsSellingState6, GetTenanciesListQueryParamsSellingState7, GetTenanciesListQueryParamsSellingState8, GetTenanciesListQueryParamsSellingState9, GetTenanciesListQueryParamsTenantManagementState, GetTenanciesListQueryParamsTenantManagementState10, GetTenanciesListQueryParamsTenantManagementState11, GetTenanciesListQueryParamsTenantManagementState12, GetTenanciesListQueryParamsTenantManagementState2, GetTenanciesListQueryParamsTenantManagementState3, GetTenanciesListQueryParamsTenantManagementState4, GetTenanciesListQueryParamsTenantManagementState5, GetTenanciesListQueryParamsTenantManagementState6, GetTenanciesListQueryParamsTenantManagementState7, GetTenanciesListQueryParamsTenantManagementState8, GetTenanciesListQueryParamsTenantManagementState9, HeatingCostItemCostType, HeatingCostItemType, HeatingCostMethod, InvestorInfoExpandOptsSelect, InvestorInfoExpandOptsSelect2, InvestorInfoOwnerExpandOptsSelect, InvestorInfoOwnerExpandOptsSelect2, InvestorShareOperationEnum, InvestorShareOperationRowOperator, InvestorYearlyPayoutStatus, InvoiceSchemaCurrency, InvoiceSchemaDebtAllocation, InvoiceSchemaInvoiceType, InvoiceSchemaSource, InvoiceSchemaState, InvoiceSchemaVatClass, InvoiceSource, InvoiceStates, InvoiceType, InvokeRentingListingActionPathParamsAction, LocationSelect, LocationSelect2, ManualAdjustmentsRowOperator, MediaFileCategory, MediaFileConstructionCraft, MediaFileInternalTags, MediaFileOrIdCategory, MediaFileOrIdConstructionCraft, MediaFileOrIdInternalTags, MediaFileOrIdTags, MediaFileTags, MediaFileVariantVariant, MonthlyInvestorShareExcludedReason, MonthlyInvestorShareStatus, MonthlyRentGuaranteeExpandOptsSelect, MonthlyRentGuaranteeExpandOptsSelect2, MonthlyRentGuaranteeTypeEnum, PaginationOrder, ParentContractSelect, ParentContractSelect2, ParkingSpaceSchemaParkingSpaceType, ParsedSubtagType, ParsedSubtagType10, ParsedSubtagType11, ParsedSubtagType12, ParsedSubtagType13, ParsedSubtagType14, ParsedSubtagType15, ParsedSubtagType16, ParsedSubtagType17, ParsedSubtagType18, ParsedSubtagType19, ParsedSubtagType2, ParsedSubtagType20, ParsedSubtagType3, ParsedSubtagType4, ParsedSubtagType5, ParsedSubtagType6, ParsedSubtagType7, ParsedSubtagType8, ParsedSubtagType9, PersonalInfoEmploymentContractType, PersonalInfoSchufa, PortalName, ProcessStateState, ProcessStateState2, PropxSdk, QueryLineOfBusiness, QueryLineOfBusiness2, QueryOrder, QueryReviewProcessStates, QueryStatus, QueryStatuses, RawDataDocumentType, RawDataDocumentType10, RawDataDocumentType11, RawDataDocumentType12, RawDataDocumentType13, RawDataDocumentType14, RawDataDocumentType15, RawDataDocumentType16, RawDataDocumentType17, RawDataDocumentType18, RawDataDocumentType19, RawDataDocumentType2, RawDataDocumentType20, RawDataDocumentType3, RawDataDocumentType4, RawDataDocumentType5, RawDataDocumentType6, RawDataDocumentType7, RawDataDocumentType8, RawDataDocumentType9, RawDataInvoiceType, RawDataInvoiceType2, RawDataInvoiceType3, RawDataInvoiceType4, RawDataInvoiceType5, RawDataInvoiceType6, RawDataPaymentmethod, RawDataPaymentmethod10, RawDataPaymentmethod2, RawDataPaymentmethod3, RawDataPaymentmethod4, RawDataPaymentmethod5, RawDataPaymentmethod6, RawDataPaymentmethod7, RawDataPaymentmethod8, RawDataPaymentmethod9, ReceiptDocumentType, ReceiptDocumentType10, ReceiptDocumentType2, ReceiptDocumentType3, ReceiptDocumentType4, ReceiptDocumentType5, ReceiptDocumentType6, ReceiptDocumentType7, ReceiptDocumentType8, ReceiptDocumentType9, ReceiptDocumentTypeEnum, ReceiptDocumentTypeEnum10, ReceiptDocumentTypeEnum2, ReceiptDocumentTypeEnum3, ReceiptDocumentTypeEnum4, ReceiptDocumentTypeEnum5, ReceiptDocumentTypeEnum6, ReceiptDocumentTypeEnum7, ReceiptDocumentTypeEnum8, ReceiptDocumentTypeEnum9, ReceiptInvoiceType, ReceiptInvoiceType2, ReceiptInvoiceType3, ReceiptInvoiceTypeEnum, ReceiptInvoiceTypeEnum2, ReceiptInvoiceTypeEnum3, ReceiptPaymentmethod, ReceiptPaymentmethod2, ReceiptPaymentmethod3, ReceiptPaymentmethod4, ReceiptPaymentmethod5, ReceiptPaymentmethodEnum, ReceiptPaymentmethodEnum2, ReceiptPaymentmethodEnum3, ReceiptPaymentmethodEnum4, ReceiptPaymentmethodEnum5, RentApartmentConditionEnum, RentIncreaseFormulaEnum, RentIncreaseTypeEnum, RentTenancyRentIncreaseTypeEnum, RentTenancySelect, RentTenancySelect2, RentableUnitExpandOptsSelect, RentableUnitExpandOptsSelect2, RentableUnitExternalRelations, RentableUnitProcessSchemaProcessType, RentableUnitProcessState, RentableUnitProcessState2, RentableUnitProcessState3, RentableUnitProcessState4, RentableUnitProcessState5, RentableUnitProcessState6, RentableUnitSelect, RentableUnitSelect2, RentableUnitType, RentableUnitTypeEnum, RentalContractExpandOptsSelect, RentalContractExpandOptsSelect2, RentalContractStatusEnum, RentalContractTypeEnum, RentalContractUnitsSelect, RentalContractUnitsSelect2, RentingDetailsRentingStates, RentingDetailsType, RentingLeadLeadImpression, RentingLeadRentingLeadStatus, RentingListingMediaTags, RentingListingMediaTags2, RentingListingMediaTags3, RentingListingProviderEnum, RentingListingProviderProvider, RentingListingProviderState, RentsSelect, RentsSelect2, ResetCacheMutationRequestKind, ResetCacheMutationRequestKind2, ReviewProcessReviewProcessState, ServiceChargeDistributionKeys, SettleUserConfirmationMutationRequestStatus, StatisticsLineOfBusiness, StatisticsLineOfBusiness2, StatisticsLineOfBusiness3, StatisticsLineOfBusiness4, SubtagsType, SubtagsType10, SubtagsType11, SubtagsType12, SubtagsType13, SubtagsType14, SubtagsType15, SubtagsType16, SubtagsType17, SubtagsType18, SubtagsType19, SubtagsType2, SubtagsType20, SubtagsType21, SubtagsType22, SubtagsType23, SubtagsType24, SubtagsType25, SubtagsType26, SubtagsType27, SubtagsType28, SubtagsType29, SubtagsType3, SubtagsType30, SubtagsType31, SubtagsType32, SubtagsType33, SubtagsType34, SubtagsType35, SubtagsType36, SubtagsType37, SubtagsType38, SubtagsType39, SubtagsType4, SubtagsType40, SubtagsType5, SubtagsType6, SubtagsType7, SubtagsType8, SubtagsType9, SyncRentableUnitProcessStatesMutationRequestRentingState, TenancyMembersSelect, TenancyMembersSelect2, TenancyTypeEnum, TenantBankAccountSelect, TenantBankAccountSelect2, UpdateContactEmailMutationRequestPortalName, UpdateContactEmailMutationRequestPortalName2, UserCompanyFunctionCompanyFunction, VatClass, initHTTPClient as initPropxHTTPClient, axios_exports as propxApi };
